// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
// ----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface GenerateTokenModel {
    /** Почта или номер телефона пользователя */
    userName?: string | undefined;
    /** Пароль */
    password?: string | undefined;
    /** Код организации */
    code?: string | undefined;
}

export interface RefreshTokenModel {
    /** Текущий или просроченный токен доступа */
    accessToken?: string | undefined;
    /** Токен для обновления, который был получен в текущей авторизации. */
    refreshToken?: string | undefined;
}

export enum OrganizationType {
    Organization = "Organization",
    CargoOwnerOrganization = "CargoOwnerOrganization",
    TruckingOrganization = "TruckingOrganization",
    ForwarderOrganization = "ForwarderOrganization",
}

export interface RegisterModel {
    /** Email */
    email?: string | undefined;
    /** Название */
    name?: string | undefined;
    /** Сайт */
    site?: string | undefined;
    /** Телефон */
    phoneNumber?: string | undefined;
    /** Адрес */
    address?: string | undefined;
    /** ИНН/КПП */
    inn?: string | undefined;
    kpp?: string | undefined;
    /** ОГРН */
    ogrn?: string | undefined;
    /** Банк */
    bank?: string | undefined;
    /** к/с */
    ks?: string | undefined;
    /** р/с */
    rs?: string | undefined;
    type: OrganizationType;
    /** Пароль */
    password?: string | undefined;
    /** Подтверждение пароля */
    confirmPassword?: string | undefined;
    code?: string | undefined;
}

export interface ConfirmEmailModel {
    /** Идентификатор пользователя */
    userId: number;
    /** Код для подтверждения */
    code?: string | undefined;
}

export interface ForgotPasswordModel {
    /** Почта */
    email?: string | undefined;
    /** Номер телефона */
    phoneNumber?: string | undefined;
}

export interface ResetPasswordModel {
    /** Пароль */
    password?: string | undefined;
    /** Подтверждение пароля */
    confirmPassword?: string | undefined;
    /** Идентификатор пользователя */
    userId: number;
    /** Код для подтверждения */
    code?: string | undefined;
}

export enum RegistrationStatus {
    None = "None",
    Credentials = "Credentials",
    CarInfo = "CarInfo",
    TrailerInfo = "TrailerInfo",
}

export interface RequestForgotPasswordCodeModel {
    userId: number;
    /** Номер телефона. */
    phoneNumber: string | undefined;
    /** Новый пароль. */
    password: string | undefined;
    /** Новый пароль еще раз. */
    passwordConfirm: string | undefined;
    /** Код организации */
    code?: string | undefined;
}

export interface CreateNewPasswordModel {
    /** Код подтверждения, который пришел по СМС. */
    confirmationCode: string | undefined;
    userId: number;
    /** Номер телефона. */
    phoneNumber: string | undefined;
    /** Новый пароль. */
    password: string | undefined;
    /** Новый пароль еще раз. */
    passwordConfirm: string | undefined;
    /** Код организации */
    code?: string | undefined;
}

export interface AcceptBidRateModel {
    /** Идентификатор ставки заявки. */
    bidRateId: number;
}

export interface CancelBidRateModel {
    /** Идентификатор ставки заявки. */
    bidRateId: number;
}

export enum BidRateStatus {
    New = "New",
    Invited = "Invited",
    Accepted = "Accepted",
    Canceled = "Canceled",
    Recalled = "Recalled",
}

export interface OrganizationSimpleModel {
    id: number;
    isDeleted: boolean;
    name?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface CatalogItemViewModel {
    id: number;
    /** Отображаемое имя */
    displayName: string | undefined;
}

export interface BidRateViewModel {
    id: number;
    createdAt: string;
    hourlyPrice?: number | undefined;
    price?: number | undefined;
    comment?: string | undefined;
    chatId: number;
    status: BidRateStatus;
    initiatorOrganization?: OrganizationSimpleModel;
    paymentType?: CatalogItemViewModel;
    ndsType?: CatalogItemViewModel;
}

export interface BidRateDeleteModel {
    /** Идентификатор ставки. */
    bidRateId: number;
}

export interface PredictUnloadPointByBidModel {
    id: number;
}

export enum Ordinates {
    None = "None",
    X = "X",
    Y = "Y",
    Z = "Z",
    M = "M",
    XY = "XY",
    XYZ = "XYZ",
    XYM = "XYM",
    XYZM = "XYZM",
    Spatial1 = "Spatial1",
    Spatial2 = "Spatial2",
    Spatial3 = "Spatial3",
    Spatial4 = "Spatial4",
    Spatial5 = "Spatial5",
    Spatial6 = "Spatial6",
    Spatial7 = "Spatial7",
    Spatial8 = "Spatial8",
    Spatial9 = "Spatial9",
    Spatial10 = "Spatial10",
    Spatial11 = "Spatial11",
    Spatial12 = "Spatial12",
    Spatial13 = "Spatial13",
    Spatial14 = "Spatial14",
    Spatial15 = "Spatial15",
    Spatial16 = "Spatial16",
    AllSpatialOrdinates = "AllSpatialOrdinates",
    Measure1 = "Measure1",
    Measure2 = "Measure2",
    Measure3 = "Measure3",
    Measure4 = "Measure4",
    Measure5 = "Measure5",
    Measure6 = "Measure6",
    Measure7 = "Measure7",
    Measure8 = "Measure8",
    Measure9 = "Measure9",
    Measure10 = "Measure10",
    Measure11 = "Measure11",
    Measure12 = "Measure12",
    Measure13 = "Measure13",
    Measure14 = "Measure14",
    Measure15 = "Measure15",
    Measure16 = "Measure16",
    AllMeasureOrdinates = "AllMeasureOrdinates",
    AllOrdinates = "AllOrdinates",
}

export interface Coordinate {
    x: number;
    y: number;
    z: number;
    m: number;
    coordinateValue?: Coordinate;
    readonly isValid: boolean;
}

export interface CoordinateSequence {
    readonly dimension: number;
    readonly measures: number;
    readonly spatial: number;
    ordinates: Ordinates;
    readonly hasZ: boolean;
    readonly hasM: boolean;
    readonly zOrdinateIndex: number;
    readonly mOrdinateIndex: number;
    first?: Coordinate;
    last?: Coordinate;
    readonly count: number;
}

export enum Dimension {
    Point = "Point",
    P = "P",
    Curve = "Curve",
    L = "L",
    Surface = "Surface",
    A = "A",
    False = "False",
    True = "True",
    Dontcare = "Dontcare",
    Unknown = "Unknown",
    Collapse = "Collapse",
}

export enum OgcGeometryType {
    Point = "Point",
    LineString = "LineString",
    Polygon = "Polygon",
    MultiPoint = "MultiPoint",
    MultiLineString = "MultiLineString",
    MultiPolygon = "MultiPolygon",
    GeometryCollection = "GeometryCollection",
    CircularString = "CircularString",
    CompoundCurve = "CompoundCurve",
    CurvePolygon = "CurvePolygon",
    MultiCurve = "MultiCurve",
    MultiSurface = "MultiSurface",
    Curve = "Curve",
    Surface = "Surface",
    PolyhedralSurface = "PolyhedralSurface",
    TIN = "TIN",
}

export enum PrecisionModels {
    Floating = "Floating",
    FloatingSingle = "FloatingSingle",
    Fixed = "Fixed",
}

export interface PrecisionModel {
    readonly isFloating: boolean;
    readonly maximumSignificantDigits: number;
    scale: number;
    readonly gridSize: number;
    precisionModelType: PrecisionModels;
}

export interface CoordinateSequenceFactory {
    ordinates: Ordinates;
}

export interface GeometryOverlay {}

export interface CoordinateEqualityComparer {}

export interface NtsGeometryServices {
    geometryOverlay?: GeometryOverlay;
    coordinateEqualityComparer?: CoordinateEqualityComparer;
    readonly defaultSRID: number;
    defaultCoordinateSequenceFactory?: CoordinateSequenceFactory;
    defaultPrecisionModel?: PrecisionModel;
}

export interface GeometryFactory {
    precisionModel?: PrecisionModel;
    coordinateSequenceFactory?: CoordinateSequenceFactory;
    srid: number;
    geometryServices?: NtsGeometryServices;
}

export interface Envelope {
    readonly isNull: boolean;
    readonly width: number;
    readonly height: number;
    readonly diameter: number;
    readonly minX: number;
    readonly maxX: number;
    readonly minY: number;
    readonly maxY: number;
    readonly area: number;
    readonly minExtent: number;
    readonly maxExtent: number;
    centre?: Coordinate;
}

export interface Geometry {
    factory?: GeometryFactory;
    userData?: any | undefined;
    srid: number;
    readonly geometryType?: string | undefined;
    ogcGeometryType: OgcGeometryType;
    precisionModel?: PrecisionModel;
    coordinate?: Coordinate;
    readonly coordinates?: Coordinate[] | undefined;
    readonly numPoints: number;
    readonly numGeometries: number;
    readonly isSimple: boolean;
    readonly isValid: boolean;
    readonly isEmpty: boolean;
    readonly area: number;
    readonly length: number;
    centroid?: Point;
    interiorPoint?: Point;
    pointOnSurface?: Point;
    dimension: Dimension;
    boundary?: Geometry;
    boundaryDimension: Dimension;
    envelope?: Geometry;
    envelopeInternal?: Envelope;
    readonly isRectangle: boolean;
}

export interface Point {
    /** Координата (долгота, широта) */
    coordinates?: any;
}

/** Base address model */
export interface AddressModel {
    /** City or village name */
    city?: string | undefined;
    /** Village name */
    village?: string | undefined;
    /** e.g.: Республика Татарстан */
    state?: string | undefined;
    /** District in region, e.g.: Новошешминский район */
    county?: string | undefined;
    /** Street name */
    street?: string | undefined;
    /** House number */
    houseNumber?: string | undefined;
    /** e.g.: Приволжский федеральный округ */
    federalDistrict?: string | undefined;
}

export enum GeocoderSourceType {
    Yandex = "Yandex",
    Nominatim = "Nominatim",
    Dadata = "Dadata",
    Here = "Here",
}

/** Address view model */
export interface AddressViewModel {
    /** Человекочитаемый адрес */
    displayName?: string | undefined;
    location?: Point;
    address?: AddressModel;
    geocoderSourceType: GeocoderSourceType;
    /** Id локации из источника геокодирования, если есть */
    locationId?: string | undefined;
}

export interface BidUnloadPointPredictResult {
    addressInfo?: AddressViewModel;
    probability: number;
    lastBidPointId: number;
    radius?: number | undefined;
}

/** Bid estimation info (e.g. bid lateness period) */
export interface BidEstimateGetModel {
    id: number;
    bidPointId: number;
    latePeriod: string;
    estimatedDate?: string | undefined;
    manualEstimatedLeaveDate?: string | undefined;
}

export enum BidPointType {
    StartPoint = "StartPoint",
    LoadPoint = "LoadPoint",
    UnloadPoint = "UnloadPoint",
    CustomPoint = "CustomPoint",
    ServicePoint = "ServicePoint",
}

export interface AverageAxisLoadValueModel {
    /** Average value (optional) */
    averageValue?: number | undefined;
}

export interface ServicePointViewModel {
    /** Наименование СТО */
    serviceStationName?: string | undefined;
    /** Тип сервисной работы */
    serviceType?: string | undefined;
    /** Cотовый телефон */
    phoneNumber?: string | undefined;
    /** Инициатор */
    initiator?: string | undefined;
    /** Опция "Без груза" */
    withoutCargo: boolean;
    /** Идентификатор сервисной работы в Эксплуатации */
    externalId?: string | undefined;
}

export enum MapObjectType {
    None = "None",
    BidPoint = "BidPoint",
    RouteSupportPoint = "RouteSupportPoint",
    GasStation = "GasStation",
    StartBidPoint = "StartBidPoint",
    PostamatPoint = "PostamatPoint",
    ItemChangePoint = "ItemChangePoint",
    ServicePoint = "ServicePoint",
    CounterpartyPoint = "CounterpartyPoint",
    TripCouplingPoint = "TripCouplingPoint",
}

/** Объект инфраструктуры/геозона */
export interface MapObjectModel {
    location: Point;
    id: number;
    city?: string | undefined;
    address?: string | undefined;
    village?: string | undefined;
    state?: string | undefined;
    county?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    federalDistrict?: string | undefined;
    /** Радиус, для заявок устанавливается автоматически */
    radius?: number | undefined;
    type: MapObjectType;
}

/** Контактное лицо */
export interface ContactPersonModel {
    /** Номер телефона, если такой контакт был введен ранее, существующие данные будут использованы */
    phoneNumber?: string | undefined;
    /** Имя */
    name?: string | undefined;
    id: number;
}

export interface CounterpartyViewModel {
    id: number;
    name?: string | undefined;
}

export interface LoadOptionModel {
    id: number;
}

export interface TypeOptionModel {
    /** Идентификатор типа */
    id: number;
    /** Идентификатор опции сущности */
    entityOptionId: number;
}

export interface ExtendedPropertyJsonObject {
    propertyName?: string | undefined;
    value?: string | undefined;
}

export interface CustomPointTypeSimpleModel {
    id: number;
    name?: string | undefined;
}

/** Bid point model for a view */
export interface BidPointViewModel {
    id: number;
    /** Порядок точки */
    order: number;
    type: BidPointType;
    customPointTypeId?: number | undefined;
    /** Дата въезда в геозону от водителя */
    enteredAt?: string | undefined;
    /** Дата загрузки/выгрузки от водителя */
    loadUnloadedAt?: string | undefined;
    /** Дата получения документов, от водителя */
    documentsReceivedAt?: string | undefined;
    /** Автоматическая дата въезда в точку */
    autoEnteredAt?: string | undefined;
    /** Автоматическая дата выезда из точки */
    autoLeavedAt?: string | undefined;
    /** Дата въезда в точку, проставленная логистом */
    enteredAtByLogist?: string | undefined;
    /** Дата выгрузки/выезда из точки, проставленная логистом */
    loadUnloadedAtByLogist?: string | undefined;
    axisLoadAfterLeaving?: AverageAxisLoadValueModel;
    servicePoint?: ServicePointViewModel;
    /** Сценарий для водителя */
    scenarioId?: number | undefined;
    /** Плановое расстояние от предыдущей точки до текущей (метры) */
    planDistance?: number | undefined;
    /** Фактическое расстояние от предыдущей точки до текущей (метры) */
    factDistance?: number | undefined;
    /** Опции точки */
    readonly intOptions?: number | undefined;
    client?: string | undefined;
    /** Комментарий к точке */
    comment?: string | undefined;
    /** Внешний ид точки */
    externalId?: string | undefined;
    /** Плановая локальная дата загрузки/выгрузки (по местному времени адреса точки). */
    planEnterDate: string;
    /** Плановая дата загрузки/выгрузки, вычисленная по плановой локальной дате, учитывая часовой пояс точки. */
    planEnterDateOffset: string;
    /** Плановая дата выезда. Если модуль планирования включен, вычисляется как плановая дата въезда + X часов. */
    planLeaveDateOffset?: string | undefined;
    /** Вторая плановая дата въезда */
    secondaryPlanEnterDate?: string | undefined;
    /** Вторая плановая дата загрузки/выгрузки, вычисленная по плановой локальной дате, учитывая часовой пояс точки. */
    secondaryPlanEnterDateOffset?: string | undefined;
    /** Плановая дата выезда */
    planLeaveDate?: string | undefined;
    createdById: number;
    geozone?: MapObjectModel;
    contactPerson?: ContactPersonModel;
    counterparty?: CounterpartyViewModel;
    /** Типы загрузок/выгрузок на точке */
    loadOptions?: LoadOptionModel[] | undefined;
    /** Дополнительные опции типов для точки */
    typeOptions?: TypeOptionModel[] | undefined;
    /** Дополнительные поля точки заявки */
    extendedProperties?: ExtendedPropertyJsonObject[] | undefined;
    customPointType?: CustomPointTypeSimpleModel;
}

export interface TollRoadSegmentModel {
    segmentId: number;
    trackName?: string | undefined;
    tag?: string | undefined;
    distance: number;
    cost: number;
    startIndex: number;
    endIndex: number;
    waypointIndexes?: number[] | undefined;
}

/** Map object simple view model */
export interface MapObjectSimpleViewModel {
    id: number;
    /** Radius */
    radius: number;
    /** Full address */
    address?: string | undefined;
    type: MapObjectType;
    /** Location */
    location?: number[] | undefined;
}

/** Segment full view model, with coordinates */
export interface SegmentFullViewModel {
    id: number;
    duration: number;
    distance: number;
    mapObjectFrom?: MapObjectSimpleViewModel;
    mapObjectTo?: MapObjectSimpleViewModel;
    points?: number[][] | undefined;
}

export interface SegmentSequenceViewModel {
    order: number;
    segmentId: number;
}

export enum RouterCountryType {
    Russia = "Russia",
}

export enum RouterProfile {
    HgvOptimal = "HgvOptimal",
    HgvShortest = "HgvShortest",
    Hgv15tOptimal = "Hgv15tOptimal",
    Lcv = "Lcv",
}

export interface RouteOptions {
    disallowToll: boolean;
    disallowTollExceptM4: boolean;
    disallowTollExceptM12DRT: boolean;
    avoidTollRoadFlags: number;
    avoidSpecialRoadFlags: number;
    allowFerry: boolean;
    calcTolls: boolean;
    country?: RouterCountryType;
    routerProfile?: RouterProfile;
}

/** Route view model with full information in segments */
export interface RouteFullViewModel {
    tollRoadSegments?: TollRoadSegmentModel[] | undefined;
    segments?: SegmentFullViewModel[] | undefined;
    segmentSequences?: SegmentSequenceViewModel[] | undefined;
    id: number;
    /** Дистанция маршрута в метрах */
    distance: number;
    /** Продолжительность маршрута в секундах */
    duration: number;
    /** Дистанция маршрута от первой точки до последней, в метрах */
    distanceWithoutEmptyMileage: number;
    /** Дистанция маршрута от нулевой точки до первой точки, в метрах */
    emptyMileageDistance: number;
    /** Продолжительность маршрута от первой точки до последней, в секундах */
    durationWithoutEmptyMileage: number;
    routeOptions?: RouteOptions;
}

export enum BidStatus {
    New = "New",
    Planned = "Planned",
    Started = "Started",
    Canceled = "Canceled",
    Done = "Done",
}

export interface BidInfoForExploitationModel {
    id: number;
    /** Расчетная информация по заявке (опоздание, дата прибытия) */
    estimations?: BidEstimateGetModel[] | undefined;
    /** Точки заявки */
    bidPoints?: BidPointViewModel[] | undefined;
    route?: RouteFullViewModel;
    status: BidStatus;
}

/** Модель координаты */
export interface PointEditModel {
    /** [0] - долгота, [1] - широта */
    coordinates?: number[] | undefined;
}

/** Модель для редактирования объекта карты */
export interface MapObjectEditModel {
    location: PointEditModel;
    id: number;
    city?: string | undefined;
    address?: string | undefined;
    village?: string | undefined;
    state?: string | undefined;
    county?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    federalDistrict?: string | undefined;
    /** Радиус, для заявок устанавливается автоматически */
    radius?: number | undefined;
    type: MapObjectType;
}

export interface CalculateServicePointModel {
    /** Идентификатор заявки */
    bidId: number;
    /** Дата прибытия */
    planEnterDate: string;
    /** Дата убытия */
    planLeaveDate: string;
    /** Порядок */
    order: number;
    mapObject?: MapObjectEditModel;
    /** Комментарий к точке */
    comment?: string | undefined;
    contactPerson?: ContactPersonModel;
    id: number;
}

export interface ServicePointCalculationViewModel {
    route?: RouteFullViewModel;
    estimations?: BidEstimateGetModel[] | undefined;
}

export interface ServicePointEditModel {
    /** Идентификатор заявки */
    bidId: number;
    /** Дата прибытия */
    planEnterDate: string;
    /** Дата убытия */
    planLeaveDate: string;
    /** Порядок */
    order: number;
    mapObject?: MapObjectEditModel;
    /** Комментарий к точке */
    comment?: string | undefined;
    contactPerson?: ContactPersonModel;
    /** Наименование СТО */
    serviceStationName?: string | undefined;
    /** Тип сервисной работы */
    serviceType?: string | undefined;
    /** Внешний идентификатор */
    externalId?: string | undefined;
    /** Cотовый телефон */
    phoneNumber?: string | undefined;
    /** Инициатор */
    initiator?: string | undefined;
    /** Опция "Без груза" */
    withoutCargo: boolean;
    id: number;
}

export interface ServicePointDeleteModel {
    id: number;
    /** Идентификатор заявки */
    bidId: number;
}

export enum BidStatusForExploitation {
    Active = "Active",
    Planned = "Planned",
}

export interface FixedAtLocationPoco {
    location?: number[] | undefined;
    fixedAt: string;
}

export interface CarBidsInfoForExploitationModel {
    id: number;
    /** Номер машины */
    carNumber?: string | undefined;
    lastLocation?: FixedAtLocationPoco;
    /** Активные и запланированные заявки */
    bids?: BidInfoForExploitationModel[] | undefined;
}

export interface BidsServiceWorkApproveModel {
    bidIds?: number[] | undefined;
}

export interface DeleteBidServiceWorkModel {
    id: number;
    bidId: number;
}

export interface RequestMessage {
    query?: { [key: string]: string[] } | undefined;
    headers?: { [key: string]: string[] } | undefined;
    requestUri?: string | undefined;
    readonly queryParameters?: { [key: string]: string } | undefined;
}

export interface BidInfoForExploitationModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface LastBidPointForExploitationModel {
    planEnterDateOffset: string;
    enteredAtByLogist?: string | undefined;
    autoEnteredAt?: string | undefined;
    planLeaveDateOffset: string;
    leftAtByLogist?: string | undefined;
    autoLeftAt?: string | undefined;
    geozone?: MapObjectModel;
}

export interface LastBidExploitationModel {
    id: number;
    status: BidStatus;
    lastBidPoint?: LastBidPointForExploitationModel;
}

export interface UserFullNameSplitModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    patronymic?: string | undefined;
}

export interface BidGetForCrWaybillModel {
    id: number;
    carNumber?: string | undefined;
    driver?: UserFullNameSplitModel;
    bidPointId: number;
    loadDate: string;
    organizationId: number;
}

export interface BidGetForCrEBillModel extends BidGetForCrWaybillModel {}

export interface BidGetForCrWaybillModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface BidGetForCrEBillModelQueryMetadata extends BidGetForCrWaybillModelQueryMetadata {}

export interface BidMarkPointsAsProcessingModel {
    id: number;
    bidPointIds?: number[] | undefined;
}

export interface BidsMarkPointsAsProcessingModel {
    bids?: BidMarkPointsAsProcessingModel[] | undefined;
}

export enum TitleType {
    T1 = "T1",
    T2 = "T2",
    T3 = "T3",
    T4 = "T4",
    T5 = "T5",
    T6 = "T6",
}

export interface TitleRemarksJsonObject {
    factEnteredAt?: string | null | undefined;
    factLeftAt?: string | null | undefined;
    factLoadUnloadAt?: string | null | undefined;
    cargoConditionNotes?: string | null | undefined;
    cargoWeightNotes?: string | null | undefined;
    cargoPlacesNotes?: string | null | undefined;
    loadingUnloadingNotes?: string | null | undefined;
    note?: string | null | undefined;
}

export interface TitleGetForCrWaybillModel {
    id: number;
    externalId?: string | undefined;
    type: TitleType;
    remarks?: TitleRemarksJsonObject | null | undefined;
}

export interface TitleGetForCrEBillModel extends TitleGetForCrWaybillModel {}

export interface BidMarkTitlesAsProcessingModel {
    id: number;
    titleExternalIds?: string[] | undefined;
}

export interface BidsMarkTitlesAsProcessingModel {
    bids?: BidMarkTitlesAsProcessingModel[] | undefined;
}

export interface QrCodeApplyWebModel {
    description?: string | undefined;
    file?: string | undefined;
}

export interface FileModel {
    id: number;
    /** Original file name */
    originalFileName?: string | undefined;
    /** Mangled file name (unique id or whatever) */
    fileName?: string | undefined;
    /** Normalized extension */
    extension?: string | undefined;
    /** File size in bytes */
    size: number;
    /** Absolute or relative url which allows direct access to this file */
    accessUrlLink?: string | undefined;
    /** Hashsum */
    hashsum?: string | undefined;
    relativePath?: string | undefined;
    lastAccessedAt?: string | undefined;
}

export enum ShippingOrderStatus {
    Received = "Received",
    DistributionBidCreated = "DistributionBidCreated",
    FailedToCreateDistributionBid = "FailedToCreateDistributionBid",
    FailedToGenerateResponseTitle = "FailedToGenerateResponseTitle",
    ResponseTitleGenerated = "ResponseTitleGenerated",
    FailedToSendResponseTitle = "FailedToSendResponseTitle",
    ResponseTitleSent = "ResponseTitleSent",
    Completed = "Completed",
    ManuallyDistributionBidCreated = "ManuallyDistributionBidCreated",
    ManuallyDistributionBidAttached = "ManuallyDistributionBidAttached",
    ManuallyDistributionBidDetached = "ManuallyDistributionBidDetached",
}

export enum ShippingOrderFlags {
    None = 0,
    CreatedWithDisabledMatching = 1,
    IsDecline = 2,
}

export enum ShippingOrderUnmatchingReason {
    MissingAddressPointPlanEnterDateOffset = "MissingAddressPointPlanEnterDateOffset",
    CounterpartyCreationFailed = "CounterpartyCreationFailed",
    CounterpartyExternalIdSetFailed = "CounterpartyExternalIdSetFailed",
    AddressPointCounterpartyCreationFailed = "AddressPointCounterpartyCreationFailed",
    AddressPointGeozoneResolveFailed = "AddressPointGeozoneResolveFailed",
    DistributionBidApplyFailed = "DistributionBidApplyFailed",
}

export enum ShippingOrderOperationType {
    Loading = "Loading",
    Unloading = "Unloading",
}

export enum ShippingOrderTitleType {
    T1 = "T1",
    T2 = "T2",
}

export enum ShippingOrderTitleStatus {
    ReceivedOrCreated = "ReceivedOrCreated",
    Signed = "Signed",
}

export enum ShippingDocumentProviderType {
    ProviderEmulator = "ProviderEmulator",
    Astral = "Astral",
    Kontur = "Kontur",
}

export interface ShippingOrderVehicleModel {
    type?: string | undefined;
    loadCapacity?: number | undefined;
    capacity?: number | undefined;
    loadingType?: string | undefined;
    bodyType?: string | undefined;
    otherParams?: string | null | undefined;
}

export interface ShippingOrderAddressPointModel {
    order: number;
    operation: ShippingOrderOperationType;
    address?: string | undefined;
    coordinates?: Point | null | undefined;
    planEnterDateOffset?: string | undefined;
    secondaryPlanEnterDateOffset?: string | null | undefined;
    counterpartyName?: string | null | undefined;
    counterpartyInn?: string | null | undefined;
}

export interface ShippingOrderCargoModel {
    name?: string | undefined;
    weight?: number | undefined;
    volume?: number | undefined;
    length?: number | undefined;
    height?: number | undefined;
    width?: number | undefined;
    packType?: string | undefined;
    placesCount: number;
}

export interface ShippingOrderDetailsModel {
    gisId?: string | null | undefined;
    orderNumber?: string | undefined;
    orderDate?: string | undefined;
    otherConditions?: string | null | undefined;
    temperatureMinimum?: number | null | undefined;
    temperatureMaximum?: number | null | undefined;
    vehicle?: ShippingOrderVehicleModel;
    addressPoints?: ShippingOrderAddressPointModel[] | undefined;
    cargos?: ShippingOrderCargoModel[] | undefined;
}

export interface ShippingOrderParticipantViewModel {
    fullName?: string | undefined;
    inn?: string | undefined;
    kpp?: string | undefined;
    ogrnip?: string | undefined;
    address?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
}

export interface ShippingOrderParticipantListModel {
    fullName?: string | null | undefined;
    inn?: string | null | undefined;
    kpp?: string | null | undefined;
    ogrnip?: string | null | undefined;
}

export interface ShippingOrderListModel {
    id: number;
    orderNumber?: string | null | undefined;
    orderDate?: string | null | undefined;
    status: ShippingOrderStatus;
    flags: string;
    readonly intFlags: number;
    lastTitleType?: ShippingOrderTitleType | null | undefined;
    lastTitleStatus?: ShippingOrderTitleStatus | null | undefined;
    firstAddress?: string | null | undefined;
    lastAddress?: string | null | undefined;
    shipper?: ShippingOrderParticipantListModel | null | undefined;
    carrier?: ShippingOrderParticipantListModel | null | undefined;
    distributionBidId?: number | null | undefined;
    bidId?: number | null | undefined;
}

export interface ShippingOrderParticipantBidModel {
    fullName?: string | null | undefined;
    inn?: string | null | undefined;
    kpp?: string | null | undefined;
    ogrnip?: string | null | undefined;
}

export interface ShippingOrderBidModel {
    id: number;
    orderNumber?: string | null | undefined;
    orderDate?: string | null | undefined;
    status: ShippingOrderStatus;
    lastTitleType?: ShippingOrderTitleType | null | undefined;
    lastTitleStatus?: ShippingOrderTitleStatus | null | undefined;
    firstAddress?: string | null | undefined;
    lastAddress?: string | null | undefined;
    shipper?: ShippingOrderParticipantBidModel | null | undefined;
    carrier?: ShippingOrderParticipantBidModel | null | undefined;
    distributionBidId?: number | null | undefined;
    bidId?: number | null | undefined;
}

export interface ShippingOrderTitle1AddressPointViewModel {
    order: number;
    operation: ShippingOrderOperationType;
    address?: string | undefined;
    coordinates?: number[] | undefined;
    planEnterDateOffset?: string | undefined;
    secondaryPlanEnterDateOffset?: string | null | undefined;
    counterpartyName?: string | null | undefined;
    counterpartyInn?: string | null | undefined;
}

export interface ShippingOrderTitle1ViewModel {
    gisId?: string | null | undefined;
    orderNumber?: string | undefined;
    orderDate?: string | undefined;
    otherConditions?: string | null | undefined;
    temperatureMinimum?: number | null | undefined;
    temperatureMaximum?: number | null | undefined;
    shipper?: ShippingOrderParticipantViewModel;
    carrier?: ShippingOrderParticipantViewModel;
    vehicle?: ShippingOrderVehicleModel;
    addressPoints?: ShippingOrderTitle1AddressPointViewModel[] | undefined;
    cargos?: ShippingOrderCargoModel[] | undefined;
}

export interface ShippingOrderTitle2DriverViewModel {
    fullName?: string | undefined;
    phones?: string[] | undefined;
    inn?: string | undefined;
    licenseNumber?: string | undefined;
    licenseSeries?: string | undefined;
    licenseDate?: string | undefined;
}

export interface ShippingOrderTitle2TransportViewModel {
    number?: string | undefined;
    registrationNumber?: string | undefined;
    vin?: string | undefined;
    ownershipType?: string | undefined;
    type?: string | undefined;
    brand?: string | undefined;
    weightCapacity?: number | undefined;
    volumeCapacity?: number | undefined;
}

export interface ShippingOrderTitle2FeeViewModel {
    currencyCode?: string | undefined;
    currencyName?: string | undefined;
    subtotal?: number | undefined;
    subtotalWithVatExcluded?: number | undefined;
    taxRate?: string | undefined;
}

export interface ShippingOrderTitle2ViewModel {
    documentCreator?: string | undefined;
    senderFnsParticipantId?: string | undefined;
    recipientFnsParticipantId?: string | undefined;
    receivingOperation?: string | undefined;
    rejectionReason?: string | undefined;
    organizerCarrierName?: string | undefined;
    organizerCarrierPhones?: string[] | undefined;
    drivers?: ShippingOrderTitle2DriverViewModel[] | undefined;
    vehicle?: ShippingOrderTitle2TransportViewModel;
    trailers?: ShippingOrderTitle2TransportViewModel[] | undefined;
    transportFee?: ShippingOrderTitle2FeeViewModel;
}

export interface ShippingOrderTitleModel {
    id: number;
    shippingOrderId: number;
    fileId?: number | undefined;
    signatureFileId?: number | null | undefined;
    titleType: ShippingOrderTitleType;
    status: ShippingOrderTitleStatus;
    externalId?: string | null | undefined;
    name?: string | undefined;
    signatureExternalId?: string | null | undefined;
    createDate?: string | undefined;
    titleFile?: FileModel | null | undefined;
    signatureFile?: FileModel | null | undefined;
}

export interface ShippingOrderModel {
    id: number;
    organizationId: number;
    distributionBidId?: number | null | undefined;
    bidId?: number | null | undefined;
    legalPersonId?: number | null | undefined;
    externalId?: string | undefined;
    externalSenderId?: string | undefined;
    reason?: ShippingOrderUnmatchingReason | null | undefined;
    providerType: ShippingDocumentProviderType;
    status: ShippingOrderStatus;
    flags: string;
    readonly intFlags: number;
    /** @deprecated Legacy payload; new view responses use title1Content. */
    details?: ShippingOrderDetailsModel;
    titles?: ShippingOrderTitleModel[] | undefined;
    title1Content?: ShippingOrderTitle1ViewModel | null | undefined;
    title2Content?: ShippingOrderTitle2ViewModel | null | undefined;
}

export interface ShippingOrderBindModel {
    shippingOrderId: number;
    distributionBidId?: number | null | undefined;
    bidId?: number | null | undefined;
}

export interface OrganizationShippingOrderProcessingSettingEditModel {
    disableMatching: boolean;
}

export interface ShippingOrderGenerateResponseTitleByBidModel {
    bidId: number;
    powerOfAttorneyId?: number | null | undefined;
    signatory?: TitleSignatoryModel;
}

export interface ShippingOrderGenerateDeclineResponseTitleModel {
    shippingOrderId: number;
    powerOfAttorneyId?: number | null | undefined;
    rejectionReason: string;
    signatory: TitleSignatoryModel;
}

export interface InfoToGenerateTitleValidationMetadata {
    errorMessages?: string[] | undefined;
    requiredProperties?: string[] | undefined;
    unfilledRequiredProperties?: string[] | undefined;
    hasUnfilledRequiredProperties: boolean;
}

export interface PartyInfoToGenerateTitleModel extends InfoToGenerateTitleValidationMetadata {
    id: number;
    name?: string | undefined;
    inn?: string | undefined;
}

export interface DriverLicenseInfoToGenerateTitleModel extends InfoToGenerateTitleValidationMetadata {
    issuingCountry?: "Belarus" | "RussianFederation" | "Uzbekistan" | "Kazakhstan" | null | undefined;
    series?: string | undefined;
    number?: string | undefined;
    dateOfIssue?: string | null | undefined;
    expirationDate?: string | null | undefined;
}

export interface DriverInfoToGenerateTitleModel extends InfoToGenerateTitleValidationMetadata {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    patronymic?: string | null | undefined;
    phoneNumber?: string | undefined;
    inn?: string | undefined;
    driverLicense?: DriverLicenseInfoToGenerateTitleModel | null | undefined;
}

export interface VehicleOwnershipBasisDocumentToGenerateTitleModel extends InfoToGenerateTitleValidationMetadata {
    id: number;
    name?: string | undefined;
    number?: string | undefined;
    date?: string | null | undefined;
    externalId?: string | null | undefined;
    additionalInfo?: string | null | undefined;
    organization?: PartyInfoToGenerateTitleModel | null | undefined;
    legalPerson?: PartyInfoToGenerateTitleModel | null | undefined;
    counterparty?: PartyInfoToGenerateTitleModel | null | undefined;
}

export interface CarInfoToGenerateTitleModel extends InfoToGenerateTitleValidationMetadata {
    id: number;
    typeId?: number | null | undefined;
    brandTypeId: number;
    number?: string | undefined;
    carrying?: number | null | undefined;
    volume?: number | null | undefined;
    ownershipType?: VehicleOwnershipType | null | undefined;
    ownershipBasisDocuments?: VehicleOwnershipBasisDocumentToGenerateTitleModel[] | undefined;
    propertyErrorMessages?: Record<string, string> | undefined;
}

export interface TrailerInfoToGenerateTitleModel extends InfoToGenerateTitleValidationMetadata {
    id: number;
    typeId?: number | null | undefined;
    brandTypeId?: number | null | undefined;
    number?: string | undefined;
    carrying?: number | null | undefined;
    volume?: number | null | undefined;
    ownershipType?: VehicleOwnershipType | null | undefined;
    ownershipBasisDocuments?: VehicleOwnershipBasisDocumentToGenerateTitleModel[] | undefined;
    propertyErrorMessages?: Record<string, string> | undefined;
}

export interface BidInfoToGenerateTitleModel {
    driver: DriverInfoToGenerateTitleModel;
    car: CarInfoToGenerateTitleModel;
    trailer?: TrailerInfoToGenerateTitleModel | null | undefined;
    errorMessage?: string | null | undefined;
    hasUnfilledRequiredProperties: boolean;
}

export interface DriverLicenseInfoToGenerateTitleEditModel {
    issuingCountry: "Belarus" | "RussianFederation" | "Uzbekistan" | "Kazakhstan";
    series: string;
    number: string;
    dateOfIssue: string;
    expirationDate: string;
}

export interface DriverInfoToGenerateTitleEditModel {
    id: number;
    firstName: string;
    lastName: string;
    patronymic?: string | null | undefined;
    phoneNumber: string;
    inn: string;
    driverLicense: DriverLicenseInfoToGenerateTitleEditModel;
}

export interface VehicleOwnershipBasisDocumentToGenerateTitleEditModel {
    id: number;
    name: string;
    number: string;
    date?: string | null | undefined;
    externalId?: string | null | undefined;
    additionalInfo?: string | null | undefined;
    legalPersonId?: number | null | undefined;
    counterpartyId: number;
}

export interface CarInfoToGenerateTitleEditModel {
    id: number;
    number: string;
    typeId?: number | null | undefined;
    brandTypeId: number;
    carrying?: number | null | undefined;
    volume?: number | null | undefined;
    ownershipType?: VehicleOwnershipType | null | undefined;
    ownershipBasisDocuments?: VehicleOwnershipBasisDocumentToGenerateTitleEditModel[] | undefined;
}

export interface TrailerInfoToGenerateTitleEditModel {
    id: number;
    number: string;
    typeId?: number | null | undefined;
    brandTypeId?: number | null | undefined;
    carrying?: number | null | undefined;
    volume?: number | null | undefined;
    ownershipType?: VehicleOwnershipType | null | undefined;
    ownershipBasisDocuments?: VehicleOwnershipBasisDocumentToGenerateTitleEditModel[] | undefined;
}

export interface BidInfoToGenerateTitleEditModel {
    id: number;
    driver: DriverInfoToGenerateTitleEditModel;
    car: CarInfoToGenerateTitleEditModel;
    trailer?: TrailerInfoToGenerateTitleEditModel | null | undefined;
}

export interface TitleSignatureGetModel {
    id: number;
    externalId?: string | undefined;
    bidId: number;
    type: TitleType;
    signatureFile?: FileModel;
    titleFile?: FileModel;
}

export interface BidMarkTitleSignaturesAsSentModel {
    id: number;
    titleExternalIds?: string[] | undefined;
}

export interface BidsMarkTitleSignaturesAsSentModel {
    bids?: BidMarkTitleSignaturesAsSentModel[] | undefined;
}

export interface BidPaymentDetailsModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface BidPaymentDetailsModel {
    id: number;
    /** Price */
    price?: number | undefined;
    /** VAT value */
    vat?: string | undefined;
}

export interface BidPaymentModel {
    invoiceDate?: string | undefined;
    planPaymentDate?: string | undefined;
    factPaymentDate?: string | undefined;
    paymentStatus: BidPaymentStatus;
    remainingPayment?: number | undefined;
    comment?: string | undefined;
}

export interface BidPaymentGetModel extends BidPaymentModel {
    isPaymentOverdue: boolean;
    updatedAt: string;
}

export enum BidPaymentStatus {
    NotPaid = "NotPaid",
    Paid = "Paid",
    PartiallyPaid = "PartiallyPaid",
}

export enum DistributionBidPaymentType {
    Customer = "Customer",
    HiredCar = "HiredCar",
}

export enum AccountsReceivableReportSource {
    OwnFleet = "OwnFleet",
    HiredCar = "HiredCar",
    All = "All",
}

export interface OpenBidListItemModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface MapObjectViewModel {
    id: number;
    /** Город */
    city?: string | undefined;
    /** Деревня/поселок */
    village?: string | undefined;
    /** Область */
    state?: string | undefined;
    /** Округ/регион */
    county?: string | undefined;
    /** Полный, точный адрес */
    address?: string | undefined;
    /** Идентификатор для поиска по городам */
    worldSubjectId?: number | undefined;
    /** Идентификатор для поиска по федеральным субъектам/областям */
    regionId?: number | undefined;
    /** Идентификатор для поиска по странам */
    countryId?: number | undefined;
    /** Идентификатор для поиска по ФО */
    federalDistrictId?: number | undefined;
    /** Идентификатор для поиска по штатам/областям */
    stateId?: number | undefined;
    /** Id часового пояса */
    timezoneId?: string | undefined;
}

export interface BidPointListItemModel {
    id: number;
    /** Порядок точки */
    order: number;
    type: BidPointType;
    /** Идентификатор заявки */
    bidId: number;
    geozone?: MapObjectViewModel;
    /** Плановая дата загрузки/выгрузки, вычисленная по плановой локальной дате, учитывая часовой пояс точки. */
    planEnterDateOffset: string;
    /** Фактическая дата въезда в точку (ручная) */
    enteredAtByLogist?: string | undefined;
    /** Фактическая дата въезда в точку (автоматическая) */
    autoEnteredAt?: string | undefined;
    /** Фактическая дата выезда из точки (ручная) */
    loadUnloadedAtByLogist?: string | undefined;
    /** Фактическая дата въезда из точки (автоматическая) */
    autoLeftAt?: string | undefined;
    /** Дата выезда из точки от водителя */
    loadUnloadedAt?: string | undefined;
}

export interface CargoBidListModel {
    typeId?: number | undefined;
    temperatureHint?: string | undefined;
    temperatureMinimum?: number | undefined;
    temperatureMaximum?: number | undefined;
    name?: string | undefined;
    weight?: number | undefined;
}

/** Open bid list item (rate, non-owner bids) */
export interface OpenBidListItemModel {
    id: number;
    /** Цена */
    price?: number | undefined;
    status: BidStatus;
    /** Дата создания заявки */
    createdAt: string;
    /** Дата обновления из 1с */
    externalUpdatedAt?: string | undefined;
    /** Заявка отправлена на факторинг? */
    hasFactoring: boolean;
    firstBidPoint?: BidPointListItemModel;
    lastBidPoint?: BidPointListItemModel;
    /** Грузы */
    cargos?: CargoBidListModel[] | undefined;
    /** Set rates count */
    participantsCount?: number | undefined;
    /** Set if the current organization is a participant for this bid */
    isParticipant: boolean;
    organization?: OrganizationSimpleModel;
}

export interface UserGetModel {
    id: number;
    /** Email */
    email?: string | undefined;
    /** Номер телефона */
    phoneNumber?: string | undefined;
    /** Полное ФИО */
    fullName?: string | undefined;
}

export interface ContactPersonViewModel {
    name?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface BidCancelModel {
    /** Идентификатор заявки. */
    bidId: number;
}

export interface BidDeleteModel {
    /** Идентификатор заявки. */
    bidId: number;
}

export interface OpenBidSimpleModel {
    id: number;
    createdById: number;
    organizationId: number;
    truckingOrganizationId?: number | undefined;
    paymentTypeId: number;
    ndsTypeId: number;
    hourlyPrice?: number | undefined;
    price?: number | undefined;
}

export interface OpenBidWithRateIdModel {
    bidRateId?: number | undefined;
    status: BidRateStatus;
    bid?: OpenBidSimpleModel;
}

export enum ChatType {
    Simple = "Simple",
    System = "System",
    BidChat = "BidChat",
    DriverChat = "DriverChat",
    DocumentFlowChat = "DocumentFlowChat",
}

export enum BidChatDomainType {
    Default = "Default",
    Rate = "Rate",
    Secondary = "Secondary",
}

export interface BidChatGetModel {
    type: BidChatDomainType;
    /** Id заявки */
    bidId: number;
    carNumber?: string | undefined;
}

export interface UserInChatModel {
    id: number;
    isOnline: boolean;
    isDriver: boolean;
    fullName?: string | undefined;
    lastSignInAt?: string | undefined;
}

/** Information about some chat */
export interface ChatInfoModel {
    id: number;
    type: ChatType;
    description?: string | undefined;
    isParticipant: boolean;
    bidChat?: BidChatGetModel;
    users?: UserInChatModel[] | undefined;
    isFavorite: boolean;
}

/** Файл чата */
export interface ChatFileModel {
    /** File id */
    fileId: number;
    chatId: number;
    /** Original file name */
    fileName?: string | undefined;
    /** File extension */
    extension?: string | undefined;
    /** Hashsum for a file */
    hashsum?: string | undefined;
    /** Creation date */
    createdAt: string;
    relativePath?: string | undefined;
    /** Direct access link */
    accessUrlLink?: string | undefined;
    isDeleted: boolean;
}

export interface BidRestoreModel {
    id: number;
}

/** Используется для ручной синхронизации заявки с внешними системами. */
export interface BidRefreshModel {
    id: number;
}

export interface BidPointSetPlanDatesModel {
    id: number;
    /** Плановая дата выезда, указанная логистом */
    planLeaveDate?: string | undefined;
}

export interface BidPricesInPeriodQueryModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface BidPricesInPeriodModel {
    bidId: number;
    price: number;
    priceWithoutVat: number;
    activeMileage: number;
}

export enum TrackerRelationType {
    Default = "Default",
    Car = "Car",
    Mobile = "Mobile",
    Trailer = "Trailer",
}

export interface TrackerHistoryItemModel {
    id: number;
    type: TrackerRelationType;
    trackerId: number;
    carId?: number | undefined;
    trailerId?: number | undefined;
    startedAt: string;
    endedAt?: string | undefined;
}

export interface DriverBidHistoryItemPeriodModel {
    id: number;
    bidId: number;
    startedAt: string;
    endedAt?: string | undefined;
    driverId: number;
}

/** Detailed information for bid-car relation */
export interface BidCarPeriodInfoModel {
    carId: number;
    bidId: number;
    startedAt: string;
    endedAt?: string | undefined;
}

export interface BidPointAutoDatesModel {
    id: number;
    /** Автоматическая дата въезда в точку */
    autoEnteredAt?: string | undefined;
    /** Автоматическая дата выезда из точки */
    autoLeavedAt?: string | undefined;
}

/** Relation for tracker-car/driver-bid */
export interface BidCarDriverTrackerInfoModel {
    /** Car-tracker/driver intersection */
    startedAt: string;
    /** Car-tracker/driver intersection */
    endedAt?: string | undefined;
    /** Bid period to analyze */
    startTrackingAt: string;
    /** Bid period to analyze */
    endTrackingAt: string;
    routeId?: number | undefined;
    firstPlanEnterDateOffset: string;
    lastPlanEnterDateOffset: string;
    isFirstPeriod: boolean;
    isLastPeriod: boolean;
    carTracker?: TrackerHistoryItemModel;
    driverPeriod?: DriverBidHistoryItemPeriodModel;
    carInfo?: BidCarPeriodInfoModel;
    /** Limit count of bid points to analyze */
    bidPointsLimit?: number | undefined;
    /** Previous bid points state (used to compare dates, etc) */
    previousBidPointsState?: BidPointAutoDatesModel[] | undefined;
}

/** Next tracked bid info (the started one after this bid) */
export interface NextTrackedBidModel {
    bidId: number;
    /** By this car the bid is found, so it may not be the current car */
    carId: number;
    carNumber?: string | undefined;
    firstPointLeftAt?: string | undefined;
    closestCarPeriodStartedAt?: string | undefined;
    firstPlanEnterDate: string;
    lastPlanEnterDate: string;
}

/** Previous tracked bid info (the completed one before this bid) */
export interface PreviousTrackedBidModel {
    bidId: number;
    /** By this car the bid is found, so it may not be the current car */
    carId: number;
    carNumber?: string | undefined;
    lastPointEnteredAt?: string | undefined;
    closestCarPeriodEndedAt?: string | undefined;
    firstPlanEnterDate: string;
    lastPlanEnterDate: string;
}

export interface BidRecalculationInfoModel {
    bidCarDriverTrackerRelations?: BidCarDriverTrackerInfoModel[] | undefined;
    /** Plan enter date of start or first point - recalculation offset */
    minAnalyzeDate: string;
    /** Plan enter date of last point + recalculation offset */
    maxAnalyzeDate: string;
    /** Date of the previous bid fact point end or car change */
    readonly startTrackingAt?: string | undefined;
    /** Date of the next bid fact point start or car change */
    readonly endTrackingAt?: string | undefined;
    nextTrackedBid?: NextTrackedBidModel;
    previousTrackedBid?: PreviousTrackedBidModel;
}

export interface DriverBidListModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export enum BidCalculationStatus {
    NoCoordinates = "NoCoordinates",
    NoActivity = "NoActivity",
    InProgress = "InProgress",
    HasPlanMileageDeviation = "HasPlanMileageDeviation",
}

export interface BidPointForDriverModel {
    id: number;
    order: number;
    planEnterDateTime: string;
    factEnteredAt?: string | undefined;
    address?: string | undefined;
    shortAddress?: string | undefined;
}

/** Список запланированных/завершенных/неучтенных заявок водителя */
export interface DriverBidListModel {
    calculationStatus?: BidCalculationStatus;
    firstBidPoint?: BidPointForDriverModel;
    lastBidPoint?: BidPointForDriverModel;
    /** Номер заявки из 1C */
    externalId?: string | undefined;
    /** Есть ли точка сервисных работ */
    hasServicePoint: boolean;
    /** Номер договора */
    contractNumber?: string | undefined;
    /** Принята ли водителем */
    acceptedByDriverAt?: string | undefined;
    id: number;
    status: BidStatus;
    /** Плановый километраж */
    routeDistance?: number | undefined;
    /** Фактический километраж */
    factDistance: number;
    /** Порожняя заявка? */
    isEmptyMileageBid: boolean;
    /** Id сборной заявки */
    compoundBidId?: number | undefined;
}

export interface DriverPlannedAndDoneBidListModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

/** Запланированные и выполненные заявки водителя */
export interface DriverPlannedAndDoneBidListModel {
    bidPoints?: BidPointForDriverModel[] | undefined;
    id: number;
    status: BidStatus;
    /** Плановый километраж */
    routeDistance?: number | undefined;
    /** Фактический километраж */
    factDistance: number;
    /** Порожняя заявка? */
    isEmptyMileageBid: boolean;
    /** Id сборной заявки */
    compoundBidId?: number | undefined;
}

export enum SourceType {
    Web = "Web",
    Enterprise = "Enterprise",
    Forwarding = "Forwarding",
    Exploitation = "Exploitation",
}

export enum PaymentPeriodType {
    InCalendarDays = "InCalendarDays",
    InBankingDays = "InBankingDays",
}

export enum InvoiceTriggerType {
    ByOriginal = "ByOriginal",
    ByScan = "ByScan",
    AtUnloading = "AtUnloading",
}

export interface RelatedDocumentModel {
    id: number;
    name?: string | undefined;
    count: number;
}

export interface CatalogItemSimpleViewModel {
    id: number;
    /** Отображаемое имя */
    displayName: string | undefined;
    isHidden: boolean;
}

export interface TypeOptionViewModel {
    /** Идентификатор типа */
    id: number;
    /** Идентификатор опции сущности */
    entityOptionId: number;
    displayName?: string | undefined;
    value?: string | undefined;
}

export interface ExtendedPropertyKeyValueModel {
    displayName?: string | undefined;
    value?: string | undefined;
}

/** Модель груза для заявки водителя */
export interface CargoDriverModel {
    id: number;
    /** Наименование */
    name: string | undefined;
    /** Вес */
    weight?: number | undefined;
    /** Обьем */
    volume?: number | undefined;
    /** Длина */
    length?: number | undefined;
    /** Высота */
    height?: number | undefined;
    /** Ширина */
    width?: number | undefined;
    /** Комментарий */
    comment?: string | undefined;
    /** Температура */
    temperatureHint?: string | undefined;
    /** Минимальная температура */
    temperatureMinimum?: number | undefined;
    /** Максимальная температура */
    temperatureMaximum?: number | undefined;
    createdById: number;
    /** Идентификатор типа Тип груза */
    typeId?: number | undefined;
    /** Идентификатор типа Тип загрузки */
    loadingTypeId?: number | undefined;
    /** Идентификатор типа Тип выгрузки */
    unloadingTypeId?: number | undefined;
    type?: CatalogItemSimpleViewModel;
    loadingType?: CatalogItemSimpleViewModel;
    unloadingType?: CatalogItemSimpleViewModel;
    /** Тип упаковки */
    packType?: string | undefined;
    /** Количество грузовых мест */
    placesCount: number;
    /** Дополнительные опции типов для груза */
    typeOptions?: TypeOptionViewModel[] | undefined;
    /** Дополнителные поля груза, с полями необходимыми мобильному приложению */
    extendedProperties?: ExtendedPropertyKeyValueModel[] | undefined;
}

/** Bid point model for driver client */
export interface BidPointDriverModel {
    id: number;
    /** Порядок точки */
    order: number;
    type: BidPointType;
    customPointTypeId?: number | undefined;
    /** Дата въезда в геозону от водителя */
    enteredAt?: string | undefined;
    /** Дата загрузки/выгрузки от водителя */
    loadUnloadedAt?: string | undefined;
    /** Дата получения документов, от водителя */
    documentsReceivedAt?: string | undefined;
    /** Автоматическая дата въезда в точку */
    autoEnteredAt?: string | undefined;
    /** Автоматическая дата выезда из точки */
    autoLeavedAt?: string | undefined;
    /** Дата въезда в точку, проставленная логистом */
    enteredAtByLogist?: string | undefined;
    /** Дата выгрузки/выезда из точки, проставленная логистом */
    loadUnloadedAtByLogist?: string | undefined;
    axisLoadAfterLeaving?: AverageAxisLoadValueModel;
    servicePoint?: ServicePointViewModel;
    /** Сценарий для водителя */
    scenarioId?: number | undefined;
    /** Плановое расстояние от предыдущей точки до текущей (метры) */
    planDistance?: number | undefined;
    /** Фактическое расстояние от предыдущей точки до текущей (метры) */
    factDistance?: number | undefined;
    /** Опции точки */
    readonly intOptions?: number | undefined;
    client?: string | undefined;
    /** Комментарий к точке */
    comment?: string | undefined;
    /** Внешний ид точки */
    externalId?: string | undefined;
    /** Плановая локальная дата загрузки/выгрузки (по местному времени адреса точки). */
    planEnterDate: string;
    /** Плановая дата загрузки/выгрузки, вычисленная по плановой локальной дате, учитывая часовой пояс точки. */
    planEnterDateOffset: string;
    /** Плановая дата выезда. Если модуль планирования включен, вычисляется как плановая дата въезда + X часов. */
    planLeaveDateOffset?: string | undefined;
    /** Вторая плановая дата въезда */
    secondaryPlanEnterDate?: string | undefined;
    /** Вторая плановая дата загрузки/выгрузки, вычисленная по плановой локальной дате, учитывая часовой пояс точки. */
    secondaryPlanEnterDateOffset?: string | undefined;
    /** Плановая дата выезда */
    planLeaveDate?: string | undefined;
    createdById: number;
    geozone?: MapObjectModel;
    contactPerson?: ContactPersonModel;
    counterparty?: CounterpartyViewModel;
    /** Типы загрузок/выгрузок на точке */
    loadOptions?: LoadOptionModel[] | undefined;
    customPointType?: CustomPointTypeSimpleModel;
    /** True если эта точка была посещена используя gps/mobile трекер */
    readonly hasAutoEnterDate: boolean;
    /** Дата въезда в точку, автоматическая или дата логиста */
    enteredAtByLogistOrAuto?: string | undefined;
    /** Дата и время последнего обновления сценария, привязанного к точке */
    scenarioUpdatedAt?: string | undefined;
    /** True если опрос пройден */
    isScenarioCompleted: boolean;
    /** Дополнителные поля точки с полями, необходимыми мобильному приложению */
    extendedProperties?: ExtendedPropertyKeyValueModel[] | undefined;
    /** Дополнительные опции типов для точки */
    typeOptions?: TypeOptionViewModel[] | undefined;
}

/** Информация о сборной заявки, для отображения */
export interface DriverBidCompoundModel {
    id: number;
    /** Второстепенный чат (водитель). */
    secondaryChatId?: number | undefined;
    /** Грузы */
    cargos?: CargoDriverModel[] | undefined;
    /** Точки, минимум две */
    bidPoints?: BidPointDriverModel[] | undefined;
    /** Конфигурируемые, дополнительные опции для заявки */
    typeOptions?: TypeOptionViewModel[] | undefined;
    /** Дополнителные поля заявки, с полями необходимыми мобильному приложению */
    extendedProperties?: ExtendedPropertyKeyValueModel[] | undefined;
    /** true если можно принять заявку */
    canAcceptBid: boolean;
}

export interface TemperatureValueForMobileModel {
    /** Value */
    readonly value: number;
    /** Values */
    values?: number[] | undefined;
    /** Fixed at date */
    fixedAt: string;
}

export interface BidTemperatureRegimeModel {
    temperatureMinimum?: number | undefined;
    temperatureMaximum?: number | undefined;
}

export interface UserShortNameViewModel {
    id: number;
    /** ФИО в коротком виде */
    shortName?: string | undefined;
}

export interface CarSimpleModel {
    id: number;
    number?: string | undefined;
    typeId: number;
    trackerId?: number | undefined;
}

export interface TrailerSimpleModel {
    id: number;
    trackerId?: number | undefined;
    number?: string | undefined;
}

export enum WaybillTitleStatus {
    ReceivedOrCreated = "ReceivedOrCreated",
    Accepted = "Accepted",
    Signed = "Signed",
    Sent = "Sent",
    Processed = "Processed",
    Declined = "Declined",
    Failed = "Failed",
    FailedToSend = "FailedToSend",
    InvalidSignature = "InvalidSignature",
}

export type TitleStatus = WaybillTitleStatus;

export interface DriverTitleBidModel {
    id: number;
    type: TitleType;
    receivedAt: string;
    signedAt?: string | undefined;
    readonly signed: boolean;
    status: WaybillTitleStatus;
    data?: any | undefined;
    remarks?: TitleRemarksJsonObject | null | undefined;
}

export interface DriverWaybillBidModel {
    id: number;
    titles?: DriverTitleBidModel[] | undefined;
}

export interface DriverEBillBidModel extends DriverWaybillBidModel {}

/** Driver bid model */
export interface DriverBidModel {
    /** Type identifier payment type */
    paymentTypeId?: number | undefined;
    /** Type identifier vat type */
    ndsTypeId?: number | undefined;
    /** Hourly price */
    hourlyPrice?: number | undefined;
    /** Price */
    price?: number | undefined;
    /** Price without VAT on top */
    priceWithoutVatOnTop?: number | undefined;
    /** Does VAT go on top of price */
    isVatTop?: boolean | undefined;
    externalId?: string | undefined;
    /** Contract number */
    contractNumber?: string | undefined;
    sourceType: SourceType;
    /** Срок оплаты в днях */
    paymentPeriodInDays?: number | undefined;
    paymentPeriodType?: PaymentPeriodType;
    /** Bid documents */
    documents?: RelatedDocumentModel[] | undefined;
    status: BidStatus;
    /** Второстепенный чат (водитель). */
    secondaryChatId?: number | undefined;
    /** Плановый пробег */
    routeDistance?: number | undefined;
    /** Включен ли контроль геозон? */
    isDriverGeozoneControlEnabled: boolean;
    /** Фактический пробег */
    activeMileage: number;
    /** Текущее значение ДУТ */
    trackerSensorValue?: number | undefined;
    isEmptyMileageBid: boolean;
    /** Идентификатор маршрута */
    routeId?: number | undefined;
    /** Дата последнего обновления маршрута */
    routeUpdatedAt?: string | undefined;
    /** Вложенные заявки, больше 0 если эта заявка сборная */
    compoundBids?: DriverBidCompoundModel[] | undefined;
    paymentType?: CatalogItemSimpleViewModel;
    ndsType?: CatalogItemSimpleViewModel;
    /** Точки, минимум две */
    bidPoints?: BidPointDriverModel[] | undefined;
    /** Точки, минимум две */
    cargos?: CargoDriverModel[] | undefined;
    /** Конфигурируемые, дополнительные опции для заявки */
    typeOptions?: TypeOptionViewModel[] | undefined;
    /** Дополнителные поля заявки, с полями необходимыми мобильному приложению */
    extendedProperties?: ExtendedPropertyKeyValueModel[] | undefined;
    temperature?: TemperatureValueForMobileModel;
    readonly hasDriverShift: boolean;
    /** true если можно принять заявку */
    canAcceptBid: boolean;
    hasSecondaryDriver: boolean;
    temperatureRegime?: BidTemperatureRegimeModel;
    /** Опции заявки */
    readonly intStateFlags: number;
    responsible?: UserShortNameViewModel;
    salesManager?: UserShortNameViewModel;
    car?: CarSimpleModel;
    trailer?: TrailerSimpleModel;
    /** ЭТрН */
    waybills?: DriverWaybillBidModel[] | undefined;
    id: number;
}

export interface DriverBidContactModel {
    /** Название контакта */
    displayName?: string | undefined;
    /** ФИО */
    fullName?: string | undefined;
    /** Номер телефона */
    phoneNumber?: string | undefined;
    /** Добавочный номер телефона */
    phoneNumberExtension?: string | undefined;
}

/** Модель отметки даты принятия у запланированной заявки */
export interface AcceptBidModel {
    /** ID заявки */
    bidId: number;
}

/** Used for manual events (driver click, etc) */
export interface BidPointForManualEventModel {
    planEnterDateOffset: string;
    id: number;
    bidId: number;
    geozone?: string | undefined;
    timezoneId?: string | undefined;
    type: BidPointType;
    customPointTypeId?: number | undefined;
    loadUnloadedAt?: string | undefined;
    enteredAt?: string | undefined;
    autoEnteredAt?: string | undefined;
    autoLeavedAt?: string | undefined;
    notifyOnlyLeaveDates: boolean;
}

/** Data transfer object between validator and commands */
export interface DriverLoadUnloadActionModel {
    driverId: number;
}

/** Data transfer object between validator and commands */
export interface DriverVisitActionModel {
    driverId: number;
}

/** Информация о пробеге для водителя */
export interface DriverMileageInfoModel {
    /** Общий пробег, в метрах */
    overallMileage: number;
}

export interface DocumentsReceivedActionModel {}

export interface ShiftPassModel {
    bidId: number;
}

export interface ShiftAcceptModel {}

/** Механик */
export interface MechanicModel {
    /** Номер телефона, если такой контакт был введен ранее, существующие данные будут использованы */
    phoneNumber?: string | undefined;
    /** Имя */
    name?: string | undefined;
    id: number;
}

export enum FuelTankType {
    Diesel = "Diesel",
    Gas = "Gas",
}

/** Fuel tank model */
export interface FuelTankModel {
    id: number;
    /** Name */
    name?: string | undefined;
    /** Current volume */
    currentVolume?: number | undefined;
    /** Total volume */
    totalVolume: number;
    /** Fuel consumption (liters/100km) */
    fuelConsumption: number;
    /** Minimum fuel volume level, in liters */
    minimumVolume: number;
    /** Maximum fuel volume to visit gas station (using by STR) */
    maximumVolumeToVisitStation: number;
    type: FuelTankType;
}

export enum VehicleOwnershipType {
    Own = "Own",
    SpousesJointProperty = "SpousesJointProperty",
    Rent = "Rent",
    Leasing = "Leasing",
    FreeUse = "FreeUse",
}

/** Документ владения транспортным средством */
export interface VehicleOwnershipBasisDocumentModel {
    id: number;
    /** Наименование документа */
    name?: string | undefined;
    /** Номер документа */
    number?: string | undefined;
    /** Дата документа */
    date?: string | undefined;
    /** Внешний идентификатор документа */
    externalId?: string | undefined;
    /** Дополнительные сведения */
    additionalInfo?: string | undefined;
    legalPersonId?: number | null | undefined;
    counterpartyId: number;
}

export interface CarOwnershipBasisDocumentModel extends VehicleOwnershipBasisDocumentModel {}

export interface TrailerOwnershipBasisDocumentModel extends VehicleOwnershipBasisDocumentModel {}

export interface CarEditModel {
    /** Идентификатор пользователя, логиста машины. Необязательное поле. */
    logistId?: number | undefined;
    isLogistRemoval: boolean;
    /** Id транспортной колонны */
    transportColumnId?: number | undefined;
    mechanic?: MechanicModel;
    /** Комментарий о необходимости ремонта или ТО
Если указать null, то не изменится, но если указать пустую строку - изменится. */
    needsMaintenanceComment?: string | undefined;
    /** Необходим срочный ремонт или ТО */
    needsUrgentMaintenance: boolean;
    /** Топливные баки */
    fuelTanks?: FuelTankModel[] | undefined;
    /** Находится ли в белом списке планирования АЗС? */
    isInRefuelingSyncList?: boolean | undefined;
    /** Идентификатор типа Тип машины. */
    typeId?: number | undefined;
    /** Номер машины. */
    number: string | undefined;
    /** Идентификатор типа Бренд машины. */
    brandTypeId: number;
    /** Грузоподъемность, т */
    carrying?: number | undefined;
    /** Вместимость, м³ */
    volume?: number | undefined;
    /** Тип владения */
    ownershipType?: VehicleOwnershipType | undefined;
    /** Комментарий к машине
Если указать null, то не изменится, но если указать пустую строку - изменится. */
    comment?: string | undefined;
    winterFuelMode?: number | undefined;
    summerFuelMode?: number | undefined;
    /** Документы-основания владения */
    ownershipBasisDocuments?: CarOwnershipBasisDocumentModel[] | undefined;
    id: number;
}

export interface CarListViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface MechanicNameModel {
    id: number;
    name?: string | undefined;
}

export interface CarFuelTankListViewModel {
    /** Объем бака */
    totalVolume: number;
    /** Расход топлива, л/100км */
    fuelConsumption: number;
}

/** Простая модель транспортной колонны */
export interface TransportColumnSimpleModel {
    id: number;
    /** Название */
    name?: string | undefined;
}

export interface ResourceInactivityInfoJsonObject {
    inactivityReason?: string | undefined;
    inactiveSince: string;
    inactiveUntil: string;
}

export interface CarListViewModel {
    id: number;
    /** Идентификатор типа Тип машины. */
    typeId: number;
    /** Номер машины. */
    number: string | undefined;
    /** Идентификатор типа Бренд машины. */
    brandTypeId: number;
    /** Логист */
    logistId: number;
    isDeleted: boolean;
    mechanic?: MechanicNameModel;
    /** ФИО или мейл логиста */
    logistFullNameOrEmail?: string | undefined;
    /** Номер трекера */
    trackerDeviceNumber?: string | undefined;
    /** Время первой фиксации координат с трекера */
    firstFixedAt?: string | undefined;
    /** Время последней фиксации координат с трекера */
    lastFixedAt?: string | undefined;
    /** Время удаления машины */
    deletedAt?: string | undefined;
    /** Комментарий к машине */
    comment?: string | undefined;
    carFuelTank?: CarFuelTankListViewModel;
    /** Время последней фиксации ДУТ */
    lastDieselSensorValueFixedAt?: string | undefined;
    transportColumn?: TransportColumnSimpleModel;
    /** Activity sign */
    isActive: boolean;
    resourceInactivityInfo?: ResourceInactivityInfoJsonObject;
    /** Находится ли в белом списке планирования АЗС? */
    isInRefuelingSyncList?: boolean | undefined;
}

export interface CarNumberViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CarNumberViewModel {
    id: number;
    /** Номер машины. */
    number?: string | undefined;
    organizationId?: number | undefined;
    /** Идентификатор транспортной колонны */
    transportColumnId?: number | undefined;
    /** Название транспортной колонны */
    transportColumnName?: string | undefined;
    /** Отображаемая марка машины */
    brandTypeDisplayName?: string | undefined;
    isDeleted: boolean;
}

export interface MechanicViewModel {
    name?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface IFuelCardNumber {
    number?: string | undefined;
    id?: number;
}

export interface CarGetModel {
    /** Идентификатор типа Тип машины. */
    typeId?: number | undefined;
    /** Номер машины. */
    number: string | undefined;
    /** Идентификатор типа Бренд машины. */
    brandTypeId: number;
    /** Комментарий к машине
Если указать null, то не изменится, но если указать пустую строку - изменится. */
    comment?: string | undefined;
    winterFuelMode?: number | undefined;
    summerFuelMode?: number | undefined;
    /** Грузоподъемность */
    carrying?: number | undefined;
    /** Объем */
    volume?: number | undefined;
    /** Тип владения */
    ownershipType?: VehicleOwnershipType | undefined;
    /** Прикрепленный трекер */
    trackerId?: number | undefined;
    /** Прикрепленный пользователь/логист к машине */
    logistId?: number | undefined;
    fuelTanks?: FuelTankModel[] | undefined;
    /** Транспортная колонна */
    transportColumnId?: number | undefined;
    mechanic?: MechanicViewModel;
    /** Комментарий о необходимости ремонта или ТО */
    needsMaintenanceComment?: string | undefined;
    /** Need for an urgent car repair or maintenance */
    needsUrgentMaintenance: boolean;
    /** Activity sign */
    isActive: boolean;
    resourceInactivityInfo?: ResourceInactivityInfoJsonObject;
    /** Топливные карты */
    fuelCards?: IFuelCardNumber[] | undefined;
    /** Находится ли в белом списке планирования АЗС? */
    isInRefuelingSyncList?: boolean | undefined;
    /** Удален? */
    isDeleted: boolean;
    /** Документы-основания владения */
    ownershipBasisDocuments?: CarOwnershipBasisDocumentModel[] | undefined;
    id: number;
}

export interface CarFuelTankViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CarFuelTankViewModel {
    id: number;
    /** Топливные баки */
    fuelTanks?: FuelTankModel[] | undefined;
}

export interface CarStopViewSimpleModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

/** Остановка машины */
export interface CarStopViewSimpleModel {
    id: number;
    /** Id машины */
    carId: number;
    /** Простой */
    mileage: number;
    /** Локация */
    location?: number[] | undefined;
    /** Время простоя */
    duration: string;
    /** Дата начала остановки */
    startedAt: string;
    /** Дата конца остановки */
    endedAt?: string | undefined;
}

export interface CarDeleteModel {
    id: number;
}

export interface CarRestoreModel {
    id: number;
}

export interface CarEditableListModel {
    ids?: number[] | undefined;
}

export enum CarStatus {
    Idle = "Idle",
    Busy = "Busy",
}

/** Информация о доступности машины */
export interface CarAvailabilityStatusModel {
    /** Идентификатор заявки, по которой едет или ехала машина */
    lastBidId?: number | undefined;
    /** Дата освобождения машинны */
    releaseDate?: string | undefined;
    status: CarStatus;
}

export interface CarChangeResourceActivityModel {
    /** Car ID */
    carId: number;
    /** Activity sign */
    isActive: boolean;
    resourceInactivityInfo?: ResourceInactivityInfoJsonObject;
}

export interface DriverUserMapViewModel {
    shortName?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface TrailerMapViewModel {
    id: number;
    /** Номер. */
    number?: string | undefined;
    /** Тип трейлера. */
    typeId?: number | undefined;
}

export interface BidCarMapInfoModel {
    bidId: number;
    driver?: DriverUserMapViewModel;
    trailer?: TrailerMapViewModel;
}

export interface CarInfoViewModel {
    /** Имя организации */
    organizationName?: string | undefined;
    /** Общее кол-во машин организации */
    carsCount: number;
    /** Кол-во машин, у которых был активный пробег за отчетный период */
    activeCarsCount: number;
    /** % машин, у которых был активный пробег за отчетный период */
    percentOfActiveCars: number;
    /** Кол-во машин, в общем отчете за отчетный период */
    carsInOverallReportCount: number;
    /** % машин, в общем отчете за отчетный период от общего кол-ва машин */
    percentOfCarsInOverallReport: number;
    /** Выработка, Руб/км. */
    output: number;
    /** Выработка, руб/час */
    outputPerHour: number;
    /** % использования приложения водителями */
    driverAppUsageAveragePercent: number;
    /** % своевременного заведения заявок */
    bidsCreatedOnTimePercent: number;
}

export interface CarMileageForPeriodModel {
    mileage: number;
}

export interface CarPlanningCommentEditModel {
    id: number;
    /** Комментарий для планирования */
    planningComment?: string | undefined;
}

export enum SensorType {
    DieselFuelLevel = "DieselFuelLevel",
    GasFuelLevel = "GasFuelLevel",
}

export interface SensorEditModel {
    id: number;
    searchKey?: string | undefined;
    type: SensorType;
}

export interface CarSensorEditModel {
    id: number;
    carId: number;
    externalId: number;
    sensors?: SensorEditModel[] | undefined;
}

export interface CarSensorViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface SensorViewModel {
    id: number;
    searchKey?: string | undefined;
    type: SensorType;
}

export interface CarSensorViewModel {
    id: number;
    carId: number;
    carNumber?: string | undefined;
    externalId: number;
    isDeleted: boolean;
    sensors?: SensorViewModel[] | undefined;
}

export interface CarSensorGetModel {
    id: number;
    carId: number;
    externalId: number;
    sensors?: SensorViewModel[] | undefined;
}

export interface CarSensorDeleteModel {
    id: number;
}

export interface CarBookingCommentModel {
    id: number;
    /** Комментарий для брони */
    bookingComment?: string | undefined;
}

export interface CarLogistViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CarLogistViewModel {
    id: number;
    /** Id логиста */
    logistId: number;
    /** ФИО логиста */
    displayName?: string | undefined;
    startedAt: string;
    endedAt?: string | undefined;
}

export interface CarLogistEditModel {
    id: number;
    carId: number;
    logistId: number;
    startedAt: string;
    endedAt?: string | undefined;
}

export interface CarLogistDeleteModel {
    id: number;
}

export interface AddCarsToRefuelingSyncListModel {
    carIds?: number[] | undefined;
}

export interface RemoveCarsFromRefuelingSyncListModel {
    carIds?: number[] | undefined;
}

export interface ExpressBidSettingsJsonObject {
    averageSpeed: number;
    workHours: number;
    dayStart: string;
    /** Время нахождения в точках в порожних заявках (часов) */
    emptyMileagePointStayPeriod?: string | undefined;
    /** Использовать текущее местоположение машины при создании порожних заявок */
    useLastCarLocationForEmptyMileageBid?: boolean | undefined;
}

export interface ExpressBidModel {
    settings?: ExpressBidSettingsJsonObject;
}

export interface BidServicePointEditModel {
    /** Наименование СТО */
    serviceStationName?: string | undefined;
    /** Тип сервисной работы */
    serviceType?: string | undefined;
    /** Внешний идентификатор */
    externalId?: string | undefined;
    /** Cотовый телефон */
    phoneNumber?: string | undefined;
    /** Инициатор */
    initiator?: string | undefined;
    /** Опция "Без груза" */
    withoutCargo: boolean;
}

/** Модель для создания/редактирования точки заявки */
export interface BidPointEditModel {
    id: number;
    /** Порядок точки */
    order: number;
    type: BidPointType;
    /** Тип произвольной точки */
    customPointTypeId?: number | undefined;
    /** Идентификатор точки контрагента, для установки даты её последнего использования */
    counterpartyPointId?: number | undefined;
    /** Плановая локальная дата загрузки/выгрузки (по местному времени адреса точки).- */
    planEnterDate?: string | undefined;
    /** Плановая локальная дата выезда */
    planLeaveDate?: string | undefined;
    /** Внешний ид точки заявки */
    externalId?: string | undefined;
    /** Клиент */
    client?: string | undefined;
    /** Комментарий к точке */
    comment?: string | undefined;
    /** Сценарий для водителя */
    scenarioId?: number | undefined;
    /** Контрагент/Грузовладелец */
    cargoOwnerDictionaryItemId?: number | undefined;
    /** Опции точки заявки */
    intOptions?: number | undefined;
    /** Плановая дата загрузки/выгрузки, вычисленная по плановой локальной дате, учитывая часовой пояс точки. */
    planEnterDateOffset?: string | undefined;
    /** Плановая вторая дата выезда, вычисленная по плановой локальной дате выезда, учитывая часовой пояс точки. */
    secondaryPlanEnterDateOffset?: string | undefined;
    /** Плановая локальная вторая дата загрузки/выгрузки (по местному времени адреса точки).- */
    secondaryPlanEnterDate?: string | undefined;
    /** Плановая дата выезда, вычисленная по плановой локальной дате выезда, учитывая часовой пояс точки. */
    planLeaveDateOffset?: string | undefined;
    geozone?: MapObjectEditModel;
    contactPerson?: ContactPersonModel;
    typeOptions?: TypeOptionModel[] | undefined;
    loadOptions?: LoadOptionModel[] | undefined;
    /** Дополнительные поля точки заявки */
    extendedProperties?: ExtendedPropertyJsonObject[] | undefined;
    servicePoint?: BidServicePointEditModel;
}

export interface CargoModel {
    id: number;
    /** Наименование */
    name: string | undefined;
    /** Вес */
    weight?: number | undefined;
    /** Обьем */
    volume?: number | undefined;
    /** Длина */
    length?: number | undefined;
    /** Высота */
    height?: number | undefined;
    /** Ширина */
    width?: number | undefined;
    /** Комментарий */
    comment?: string | undefined;
    /** Температура */
    temperatureHint?: string | undefined;
    /** Минимальная температура */
    temperatureMinimum?: number | undefined;
    /** Максимальная температура */
    temperatureMaximum?: number | undefined;
    /** Идентификатор типа Тип груза */
    typeId?: number | undefined;
    /** Идентификатор типа Тип загрузки */
    loadingTypeId?: number | undefined;
    /** Идентификатор типа Тип выгрузки */
    unloadingTypeId?: number | undefined;
    /** Тип упаковки */
    packType?: string | undefined;
    /** Количество грузовых мест */
    placesCount?: number | undefined;
    /** Дополнительные поля груза заявки */
    extendedProperties?: ExtendedPropertyJsonObject[] | undefined;
    /** Дополнительные опции типов для груза */
    typeOptions?: TypeOptionModel[] | undefined;
}

/** Модель, которая используется для взаимодействия с заявкой от лица грузовладельца. */
export interface BidCargoEditModel {
    /** Type identifier payment type */
    paymentTypeId?: number | undefined;
    /** Type identifier vat type */
    ndsTypeId?: number | undefined;
    /** Hourly price */
    hourlyPrice?: number | undefined;
    /** Price */
    price?: number | undefined;
    /** Does VAT go on top of price */
    isVatTop?: boolean | undefined;
    externalId?: string | undefined;
    /** Contract number */
    contractNumber?: string | undefined;
    /** Срок оплаты в днях */
    paymentPeriodInDays?: number | undefined;
    paymentPeriodType?: PaymentPeriodType;
    /** Основание для выставления счета заказчику */
    invoiceTriggerType?: InvoiceTriggerType;
    /** Bid documents */
    documents?: RelatedDocumentModel[] | undefined;
    /** Идентификатор партнера-организации */
    partnerId?: number | undefined;
    /** Нужно ли создавать задание сдачи документов водителю после завершения заявки? */
    createDocumentAssignment: boolean;
    expressBid?: ExpressBidModel;
    /** Точки, минимум две */
    bidPoints?: BidPointEditModel[] | undefined;
    /** Грузы */
    cargos?: CargoModel[] | undefined;
    extendedProperties?: ExtendedPropertyJsonObject[] | undefined;
    /** Дополнительные опции заявки */
    typeOptions?: TypeOptionModel[] | undefined;
    id: number;
}

export interface BidPointGetModel {
    id: number;
    /** Порядок точки */
    order: number;
    type: BidPointType;
    /** Идентификатор пользователя, создавшего точку */
    createdById: number;
    /** Клиент */
    client?: string | undefined;
    /** Комментарий */
    comment?: string | undefined;
    geozone?: MapObjectModel;
    contactPerson?: ContactPersonModel;
    /** Плановая локальная дата загрузки/выгрузки (по местному времени адреса точки, без часового пояса, используется для редактирования даты). */
    planEnterDate: string;
    /** Вторая плановая локальная дата загрузки/выгрузки (диапазон). */
    secondaryPlanEnterDate?: string | undefined;
    /** Вторая плановая дата загрузки/выгрузки, вычисленная по плановой локальной дате, учитывая часовой пояс точки. */
    secondaryPlanEnterDateOffset?: string | undefined;
    /** Плановая локальная дата выезда (по местному времени адреса точки, без часового пояса, используется для редактирования даты). */
    planLeaveDate?: string | undefined;
    /** Fact load/unload date. Auto leave date set in priority. */
    factLoadUnloadedAt?: string | undefined;
    /** Fact date for entered date. Auto enter date set in priority. */
    factEnteredAt?: string | undefined;
    /** Плановая дата загрузки/выгрузки, вычисленная по плановой локальной дате, учитывая часовой пояс точки. */
    planEnterDateOffset: string;
    /** Плановая дата выезда, либо если модуль планирования включен, вычисляется как плановая дата въезда + X часов. */
    planLeaveDateOffset?: string | undefined;
    /** Id контрагента */
    cargoOwnerDictionaryItemId?: number | undefined;
    /** Опции точки заявки */
    readonly intOptions?: number | undefined;
    /** Типы загрузки/выгрузки на точке */
    loadOptions?: LoadOptionModel[] | undefined;
    /** Конфигурируемые, дополнительные опции для точки заявки */
    typeOptions?: TypeOptionModel[] | undefined;
    /** Дополнителные поля заявки */
    extendedProperties?: ExtendedPropertyJsonObject[] | undefined;
    customPointType?: CustomPointTypeSimpleModel;
    /** Сценарий для водителя */
    scenarioId?: number | undefined;
    /** Внешний ид точки заявки */
    externalId?: string | undefined;
    /** Есть ли у точки фактические даты или даты логиста? */
    hasLogistOrAutoDates: boolean;
}

/** Модель, которая используется для взаимодействия с заявкой от лица грузовладельца. */
export interface BidCargoGetModel {
    status: BidStatus;
    /** Идентификатор типа Организация */
    organizationId: number;
    /** Says whether this cargo owner bid belongs to a trucking organization */
    isAccepted: boolean;
    /** Точки заявки */
    bidPoints?: BidPointGetModel[] | undefined;
    /** Грузы */
    cargos?: CargoModel[] | undefined;
    /** Type identifier payment type */
    paymentTypeId?: number | undefined;
    /** Type identifier vat type */
    ndsTypeId?: number | undefined;
    /** Hourly price */
    hourlyPrice?: number | undefined;
    /** Price */
    price?: number | undefined;
    /** Price without VAT on top */
    priceWithoutVatOnTop?: number | undefined;
    /** Does VAT go on top of price */
    isVatTop?: boolean | undefined;
    externalId?: string | undefined;
    /** Contract number */
    contractNumber?: string | undefined;
    sourceType: SourceType;
    /** Срок оплаты в днях */
    paymentPeriodInDays?: number | undefined;
    paymentPeriodType?: PaymentPeriodType;
    /** Bid documents */
    documents?: RelatedDocumentModel[] | undefined;
    id: number;
}

export interface CounterpartyListModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export enum CounterpartyStatus {
    None = "None",
    Insolvent = "Insolvent",
    Priority = "Priority",
    Suspended = "Suspended",
}

export interface CounterpartyDocumentModel {
    id: number;
    /** Количество */
    count: number;
}

export interface CounterpartyPointModel {
    id: number;
    /** Идентификатор контрагента */
    counterpartyId: number;
    /** Наименование */
    name?: string | undefined;
    geozone?: MapObjectModel;
    /** Дата последнего использования */
    lastUsedAt: string;
}

export interface CounterpartyListModel {
    id: number;
    /** Наименование */
    name?: string | undefined;
    /** ИНН */
    inn?: string | undefined;
    /** КПП */
    kpp?: string | undefined;
    /** E-mail организации */
    email?: string | undefined;
    /** Есть ли доступ к просмотру заявок? */
    hasAccess: boolean;
    /** Идентификатор прикрепленной организации */
    linkedOrganizationId?: number | undefined;
    /** Offset at which visits to the bid point are taken into account. */
    analyzeStrictOffsetHours?: number | undefined;
    /** Комментарий */
    comment?: string | undefined;
    status: CounterpartyStatus;
    /** Id группы контрагента */
    counterpartyGroupId?: number | undefined;
    /** Наименование группы контрагента */
    counterpartyGroupName?: string | undefined;
    /** Список документов */
    documents?: CounterpartyDocumentModel[] | undefined;
    /** Список точек */
    points?: CounterpartyPointModel[] | undefined;
    /** Удален? */
    isDeleted: boolean;
}

export interface CounterpartyViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CounterpartyForSelectModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CounterpartyForSelectModel {
    id: number;
    name?: string | undefined;
    inn?: string | undefined;
    kpp?: string | undefined;
    comment?: string | undefined;
    hasPoints: boolean;
    hasAccessToBids: boolean;
    status: CounterpartyStatus;
}

export enum CounterpartyFlag {
    None = "None",
    HasAccessToBids = "HasAccessToBids",
}

export interface CounterpartyContactPersonModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    patronymic?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
}

export interface CounterpartyManagementModel {
    position?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    patronymic?: string | undefined;
}

/** Counterparty */
export interface CounterpartyModel {
    id: number;
    isForeign?: boolean | undefined;
    /** Наименование */
    name?: string | undefined;
    /** ИНН */
    inn?: string | undefined;
    /** КПП */
    kpp?: string | undefined;
    /** ОГРН */
    ogrn?: string | undefined;
    /** Город (юридический адрес) */
    city?: string | undefined;
    /** Улица (юридический адрес) */
    street?: string | undefined;
    /** Дом (юридический адрес) */
    houseNumber?: string | undefined;
    /** Юридический адрес (полный) */
    address?: string | undefined;
    /** Руководитель */
    management?: CounterpartyManagementModel;
    /** E-mail организации */
    email?: string | undefined;
    flags: CounterpartyFlag;
    contactPerson?: CounterpartyContactPersonModel;
    /** Есть ли доступ к просмотру заявок? */
    hasAccess: boolean;
    /** Идентификатор прикрепленной организации */
    linkedOrganizationId?: number | undefined;
    /** Offset at which visits to the bid point are taken into account. */
    analyzeStrictOffsetHours?: number | undefined;
    /** Комментарий */
    comment?: string | undefined;
    status: CounterpartyStatus;
    /** Id группы контрагента */
    counterpartyGroupId?: number | undefined;
    /** Наименование группы контрагента */
    counterpartyGroupName?: string | undefined;
    /** Список документов */
    documents?: CounterpartyDocumentModel[] | undefined;
    /** Список точек */
    points?: CounterpartyPointModel[] | undefined;
    /** Удален? */
    isDeleted: boolean;
}

/** Restricts bid access features for a shared counterparty */
export interface RestrictCounterpartyAccessModel {
    id: number;
}

export interface ShareCounterpartyAccessModel {
    id: number;
    /** Email, для которого открывается доступ к просмотру заявок */
    email?: string | undefined;
}

export interface GiveCounterpartyAccessToBidsModel {
    kpp?: string | undefined;
    contactPerson?: CounterpartyContactPersonModel;
    id: number;
}

export interface RemoveCounterpartyAccessToBidsModel {
    id: number;
}

/** Модель для редактирования контрагента */
export interface CounterpartyEditModel {
    isForeign?: boolean | undefined;
    /** Наименование */
    name?: string | undefined;
    /** ИНН */
    inn?: string | undefined;
    /** КПП */
    kpp?: string | undefined;
    /** ОГРН */
    ogrn?: string | undefined;
    /** Город (юридический адрес) */
    city?: string | undefined;
    /** Улица (юридический адрес) */
    street?: string | undefined;
    /** Дом (юридический адрес) */
    houseNumber?: string | undefined;
    /** Юридический адрес (полный) */
    address?: string | undefined;
    /** Руководитель */
    management?: CounterpartyManagementModel;
    counterpartyGroupId?: number | undefined;
    /** Комментарий */
    comment?: string | undefined;
    /** Offset at which visits to the bid point are taken into account. */
    analyzeStrictOffsetHours?: number | undefined;
    status?: CounterpartyStatus;
    /** Список документов */
    documents?: CounterpartyDocumentModel[] | undefined;
    contactPerson?: CounterpartyContactPersonModel;
    id: number;
}

export interface CounterpartyDeleteModel {
    id: number;
}

export interface CounterpartyRestoreModel {
    id: number;
}

export interface CounterpartySyncLegalInformationModel {
    id: number;
}

export interface CounterpartyPointEditModel {
    id: number;
    /** Идентификатор контрагента */
    counterpartyId: number;
    /** Идентификатор организации */
    organizationId: number;
    /** Наименование */
    name?: string | undefined;
    geozone?: MapObjectEditModel;
    /** Дата последнего использования */
    lastUsedAt: string;
}

export interface CounterpartyPointModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CounterpartyPointModelICollatedCollection {
    collection?: CounterpartyPointModel[] | undefined;
    totalCount?: number | undefined;
}

export interface CounterpartyPointDeleteModel {
    id: number;
}

export interface CounterpartyPointRestoreModel {
    id: number;
}

export interface CounterpartyContractModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CounterpartyContractModel {
    id: number;
    name?: string | undefined;
    number?: string | undefined;
    date: string;
    /** Валюта взаиморасчета */
    settlementCurrency?: string | undefined;
    /** Идентификатор варианта выставления счета */
    billingOptionId?: number | undefined;
    /** Идентификатор организации (юр. лица) */
    legalPersonId?: number | undefined;
    /** Наименование организации (юр. лица) */
    legalPersonName?: string | undefined;
    /** Срок оплаты */
    paymentPeriod?: number | undefined;
    paymentPeriodType?: PaymentPeriodType;
    /** Лимит задолженности */
    debtCeiling?: number | undefined;
    /** Текущая задолженность */
    currentDebt?: number | undefined;
    /** Основной договор? */
    isMain: boolean;
}

export interface CounterpartyContractModelICollatedCollection {
    collection?: CounterpartyContractModel[] | undefined;
    totalCount?: number | undefined;
}

export interface CounterpartyContractForSelectModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CounterpartyContractForSelectModel {
    id: number;
    name?: string | undefined;
    debtCeiling?: number | undefined;
    legalPersonId?: number | undefined;
    paymentPeriod?: number | undefined;
    paymentPeriodType?: PaymentPeriodType;
    isMain: boolean;
}

export interface CounterpartyContractForSelectModelICollatedCollection {
    collection?: CounterpartyContractForSelectModel[] | undefined;
    totalCount?: number | undefined;
}

export interface CounterpartyContractForFilterModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CounterpartyContractForFilterModel {
    id: number;
    number?: string | undefined;
}

export interface CounterpartyContractForFilterModelICollatedCollection {
    collection?: CounterpartyContractForFilterModel[] | undefined;
    totalCount?: number | undefined;
}

export interface CounterpartyContractEditModel {
    id: number;
    name?: string | undefined;
    number?: string | undefined;
    date: string;
    /** Валюта взаиморасчета */
    settlementCurrency?: string | undefined;
    /** Идентификатор варианта выставления счета */
    billingOptionId?: number | undefined;
    /** Идентификатор организации (юр. лица) */
    legalPersonId: number;
    /** Срок оплаты */
    paymentPeriod?: number | undefined;
    paymentPeriodType?: PaymentPeriodType;
    /** Лимит задолженности */
    debtCeiling?: number | undefined;
    /** Текущая задолженность */
    currentDebt?: number | undefined;
    counterpartyId: number;
    /** Основной договор? */
    isMain?: boolean | undefined;
}

export interface CounterpartyContractDeleteModel {
    id: number;
    counterpartyId: number;
}

export interface CatalogListWithItemsModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export enum CatalogType {
    CarType = "CarType",
    TrailerType = "TrailerType",
    TrailerLoadingType = "TrailerLoadingType",
    LoadingType = "LoadingType",
    UnloadingType = "UnloadingType",
    LoadUnloadType = "LoadUnloadType",
    CargoType = "CargoType",
    NDSType = "NDSType",
    PaymentType = "PaymentType",
    DocumentType = "DocumentType",
    CarBrandType = "CarBrandType",
    TrailerBrandType = "TrailerBrandType",
    ExcessMileageReasonType = "ExcessMileageReasonType",
    BillingOption = "BillingOption",
    RefuelingProblemType = "RefuelingProblemType",
}

export interface CatalogItemEntityOptionSimpleModel {
    id: number;
    propertyName?: string | undefined;
    displayName?: string | undefined;
    valueCatalogType?: CatalogType;
    valueClrType?: string | undefined;
}

export interface CatalogListItemSimpleModel {
    id: number;
    /** Отображаемое имя */
    displayName: string | undefined;
    propertyName?: string | undefined;
    isDeleted: boolean;
    isHidden: boolean;
    itemEntityOptions?: CatalogItemEntityOptionSimpleModel[] | undefined;
    options: {};
}

export enum EntityType {
    TrailerOption = "TrailerOption",
    CarOption = "CarOption",
    Cargo = "Cargo",
    TruckingBid = "TruckingBid",
    CargoOwnerBid = "CargoOwnerBid",
    ForwarderBid = "ForwarderBid",
    BidPoint = "BidPoint",
    DistributionBid = "DistributionBid",
    DistributionBidCargo = "DistributionBidCargo",
    DistributionBidPoint = "DistributionBidPoint",
}

export enum CatalogEntityOptionFlags {
    None = "None",
    Required = "Required",
    Invisible = "Invisible",
    ShowInMobileApp = "ShowInMobileApp",
}

export interface CatalogEntityOptionModel {
    id: number;
    organizationId?: number | undefined;
    referencedCatalogId?: number | undefined;
    displayName?: string | undefined;
    propertyName?: string | undefined;
    flags: CatalogEntityOptionFlags;
}

export enum CatalogFlag {
    None = "None",
    ShowInMobileApp = "ShowInMobileApp",
    IsApprovedByRoot = "IsApprovedByRoot",
}

export interface CatalogListWithItemsModel {
    /** Элементы справочника */
    items?: CatalogListItemSimpleModel[] | undefined;
    id: number;
    displayName?: string | undefined;
    propertyName?: string | undefined;
    type?: CatalogType;
    entityType?: EntityType;
    entityOptions?: CatalogEntityOptionModel[] | undefined;
    flags: CatalogFlag;
    readonly intFlags: number;
    organizationId?: number | undefined;
    description?: string | undefined;
    externalId?: string | undefined;
    /** Версия */
    version?: string | undefined;
}

export interface CatalogListModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CatalogListModel {
    id: number;
    displayName?: string | undefined;
    propertyName?: string | undefined;
    type?: CatalogType;
    entityType?: EntityType;
    entityOptions?: CatalogEntityOptionModel[] | undefined;
    flags: CatalogFlag;
    readonly intFlags: number;
    organizationId?: number | undefined;
    description?: string | undefined;
    externalId?: string | undefined;
    /** Версия */
    version?: string | undefined;
}

export interface CatalogListItemSimpleViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CatalogListItemSimpleViewModel {
    id: number;
    /** Отображаемое имя */
    displayName: string | undefined;
    propertyName?: string | undefined;
    isDeleted: boolean;
    isHidden: boolean;
    externalId?: string | undefined;
}

export interface CatalogListSimpleModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CatalogListSimpleModel {
    id: number;
    displayName?: string | undefined;
    propertyName?: string | undefined;
    type?: CatalogType;
    entityType?: EntityType;
    entityOptions?: CatalogEntityOptionModel[] | undefined;
    flags: CatalogFlag;
    readonly intFlags: number;
}

export interface CatalogItemModel {
    id: number;
    /** Имя переменной латиницей */
    propertyName?: string | undefined;
    /** Отображаемое имя */
    displayName: string | undefined;
    isHidden?: boolean | undefined;
    catalogType: CatalogType;
    entityType?: EntityType;
    /** Идентификатор каталога */
    catalogId: number;
}

export interface ApplyCatalogEntityOptionsModel {
    /** Идентификатор элемента каталога */
    itemId: number;
    /** Список опций, которые необходимы для элемента каталога */
    values?: number[] | undefined;
}

export interface CatalogItemDeleteModel {
    id: number;
}

export interface RestoreCatalogItemContext {
    id: number;
    readonly unitType?: string | undefined;
    readonly options?: number | undefined;
    readonly instanceId: number;
    readonly compoundKey?: string | undefined;
    state?: any | undefined;
}

export interface CatalogItemViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CatalogUserEntityOptionModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

/** Настройка для видимости/обязательности и прочего для полей при создании/обновлении */
export interface CatalogUserEntityOptionModel {
    /** Идентификатор опции сущности */
    entityOptionId: number;
    /** Имя свойства (латиницей) */
    propertyName?: string | undefined;
    /** Отображаемое имя */
    displayName?: string | undefined;
    typeName?: string | undefined;
    entityType: EntityType;
    flags: CatalogEntityOptionFlags;
    relationFlags: CatalogEntityOptionFlags;
    /** Название свойства справочника, где находится опция сущности (латиницей) */
    catalogPropertyName?: string | undefined;
    /** Опции свойства */
    readonly intFlags: number;
    readonly intRelationFlags: number;
    order: number;
}

/** Модель для редактирования свойств полей */
export interface CatalogUserEntityOptionEditModel {
    id: number;
    /** Id опции сущности */
    entityOptionId: number;
    /** Опции свойства */
    flags: number;
    relationFlags: number;
}

/** Модель редактирования справочника для организации */
export interface CatalogOrganizationEditModel {
    /** Отображаемое имя */
    displayName: string;
    /** Краткое описание поля */
    description?: string | undefined;
    entityType: EntityType;
    flags: CatalogFlag;
    externalId: string;
    id: number;
}

export interface CatalogItemEditModel {
    id: number;
    /** Идентификатор справочника */
    catalogId: number;
    /** Отображаемое имя */
    displayName?: string | undefined;
    isHidden?: boolean | undefined;
}

export interface CatalogOrganizationEntityOptionEditModel {
    id: number;
    /** Отображаемое имя */
    displayName?: string | undefined;
    /** Идентификатор справочника, который используется для исходных значений для этой опции */
    referencedCatalogId: number;
    entityType: EntityType;
    /** Идентификатор организации, к которой необходимо прикрепить эту опцию */
    organizationId: number;
    flags: number;
    relationFlags: number;
}

export interface CatalogOrganizationEntityOptionDeleteModel {
    id: number;
}

export interface CatalogOrganizationEntityOptionRestoreModel {
    id: number;
}

export interface CatalogDeleteModel {
    id: number;
}

export interface CatalogRestoreModel {
    id: number;
}

export enum BidType {
    Private = "Private",
    Public = "Public",
}

export enum BidPointLoadUnloadStatus {
    AtLoading = "AtLoading",
    Loaded = "Loaded",
    AtUnloading = "AtUnloading",
    Unloaded = "Unloaded",
}

export enum SyncEntityStatus {
    NotSynchronized = "NotSynchronized",
    Success = "Success",
    Failed = "Failed",
}

export enum LegalPersonFlag {
    None = "None",
    Main = "Main",
}

export interface LegalPersonViewModel {
    flags: LegalPersonFlag;
    name?: string | undefined;
    inn?: string | undefined;
    id: number;
}

export interface AxisLoadValueModel {
    trackerId: number;
    /** Value */
    value: number;
    /** Secondary value (optional) */
    secondaryValue?: number | undefined;
    /** Average value (optional) */
    averageValue?: number | undefined;
    /** Trailer value (optional) */
    trailerValue?: number | undefined;
    /** Fixed at date */
    fixedAt: string;
}

export interface TemperatureValueModel {
    /** Values */
    values?: number[] | undefined;
    /** Fixed at date */
    fixedAt: string;
}

export interface BidFactoringModel {
    factoringCompanyId: number;
    factoringCompanyName?: string | undefined;
    sentAt: string;
}

export interface BidCreatedByViewModel {
    id: number;
    /** ФИО в коротком виде */
    shortName?: string | undefined;
    /** True если создано оператором */
    isOperator: boolean;
}

/** Trailer option */
export interface TrailerOptionPreviewModel {
    /** Trailer id */
    trailerId: number;
    /** Trailer type */
    typeId?: number | undefined;
    /** Tracker id */
    trackerId?: number | undefined;
    /** Number */
    number?: string | undefined;
    /** Trailer comment */
    comment?: string | undefined;
}

export interface CarOutputModel {
    bidId?: number | undefined;
    planOutput?: number | undefined;
    factOutput?: number | undefined;
    differenceBetweenPlanAndWantedOutput?: number | undefined;
    wantedOutput?: number | undefined;
    updatedAt: string;
}

export interface CarOptionViewModel {
    /** Идентификатор машины */
    carId?: number | undefined;
    /** Идентификатор типа Тип */
    typeId?: number | undefined;
    /** Номер */
    number?: string | undefined;
    /** Идентификатор типа Марка */
    brandTypeId?: number | undefined;
    /** Идентификатор трекера */
    trackerId?: number | undefined;
    /** Комментарий к машине */
    comment?: string | undefined;
    /** Комментарий планирования к машине */
    planningComment?: string | undefined;
    /** Логист */
    logistDisplayName?: string | undefined;
    /** Идентификатор логиста */
    logistId?: number | undefined;
    carOutput?: CarOutputModel;
    mechanic?: MechanicViewModel;
}

export enum ConnectionState {
    Offline = "Offline",
    Online = "Online",
}

/** Пользователь */
export interface UserModel {
    /** Email */
    email: string | undefined;
    /** Имя */
    firstName: string | undefined;
    /** Фамилия */
    lastName: string | undefined;
    /** Отчество */
    patronymic?: string | undefined;
    /** Номер телефона */
    phoneNumber?: string | undefined;
    /** Добавочный номер телефона */
    phoneNumberExtension?: string | undefined;
    lastSignInAt?: string | undefined;
    connectionState: ConnectionState;
    id: number;
}

/** Водитель */
export interface DriverViewModel {
    id: number;
    user?: UserModel;
    /** ИНН физического лица */
    inn?: string | undefined;
    /** Дата последнего входа */
    readonly lastSignInAt?: string | undefined;
    /** Показывает если водитель онлайн */
    isOnline: boolean;
    /** Комментарий к водителю */
    comment?: string | undefined;
}

export interface CounterpartyBidViewModel {
    id: number;
    isForeign?: boolean | undefined;
    /** Наименование */
    name?: string | undefined;
    /** ИНН */
    inn?: string | undefined;
    /** КПП */
    kpp?: string | undefined;
    /** E-mail организации */
    email?: string | undefined;
    /** Есть ли у контрагента доступ к заявкам? */
    hasAccessToBids: boolean;
    contactPerson?: CounterpartyContactPersonModel;
}

export interface CounterpartyContractNumberModel {
    id: number;
    number?: string | undefined;
}

export enum DocumentAssignmentStatus {
    Created = "Created",
    DocumentsUploaded = "DocumentsUploaded",
    DocumentsRejected = "DocumentsRejected",
    DocumentsApproved = "DocumentsApproved",
    EnvelopeScanned = "EnvelopeScanned",
    PostamatScanned = "PostamatScanned",
    Completed = "Completed",
}

export interface DocumentAssignmentStatusDriverModel {
    id: number;
    status: DocumentAssignmentStatus;
}

export interface BidChatModel {
    id: number;
    type: BidChatDomainType;
    readonly intChatFlags: number;
}

export enum ItemChangePointStatus {
    NoVisits = "NoVisits",
    MissingVisit = "MissingVisit",
    Completed = "Completed",
}

export interface CarNumberModel {
    id: number;
    number?: string | undefined;
}

export interface TrailerNumberModel {
    id: number;
    number?: string | undefined;
}

export interface DriverUserSimpleModel {
    id: number;
    shortName?: string | undefined;
}

export interface ItemChangePointVisitModel {
    /** Car id */
    carId: number;
    /** Duration, if there's no enter date then it's Date.Now - EnterDate */
    readonly duration: string;
    /** Is mobile device visit? */
    isMobile: boolean;
    /** Enter date */
    enterDate: string;
    /** Leave date */
    leaveDate?: string | undefined;
}

export interface ItemChangePointListModel {
    id: number;
    /** Id геозоны */
    mapObjectId: number;
    /** Id пользователя, создавшего эту точку */
    createdById: number;
    /** Id машины, которая будет использована в перецепке */
    shiftCarId?: number | undefined;
    /** Id прицепа, который будет использован в перецепке */
    shiftTrailerId?: number | undefined;
    /** Id водителя, который будет использован в перецепке */
    shiftDriverId?: number | undefined;
    status: ItemChangePointStatus;
    /** Плановая дата вьезда / плановая дата начала перецепки */
    planEnterDateOffset: string;
    /** Плановая дата выезда / плановая дата окончания перецепки */
    planLeaveDateOffset?: string | undefined;
    /** Дата вьезда */
    autoEnteredAt?: string | undefined;
    /** Дата выезда */
    autoLeftAt?: string | undefined;
    /** Дата старта перецепки, установленная логистом */
    manualStartAt?: string | undefined;
    /** Дата конца перецепки, установленная логистом */
    manualEndAt?: string | undefined;
    mapObject?: MapObjectModel;
    planEnterDate: string;
    planLeaveDate?: string | undefined;
    parallelBidId?: number | undefined;
    lastError?: string | undefined;
    creatorDisplayName?: string | undefined;
    shiftCar?: CarNumberModel;
    shiftTrailer?: TrailerNumberModel;
    shiftDriver?: DriverUserSimpleModel;
    visits?: ItemChangePointVisitModel[] | undefined;
}

export interface TitleBidModel {
    id: number;
    type: TitleType;
    receivedAt: string;
    signedAt?: string | undefined;
    readonly signed: boolean;
    status: WaybillTitleStatus;
    remarks?: TitleRemarksJsonObject | null | undefined;
    rejectionReason?: string | null;
}

export interface WaybillBidModel {
    id: number;
    billNumber: string;
    billDate: string;
    unloadComment?: string | null;
    titles?: TitleBidModel[] | undefined;
    readonly intStateFlags: number;
    externalLink?: string | null | undefined;
}

export interface EBillBidModel extends WaybillBidModel {}

/** Модель для просмотра заявки */
export interface BidViewModel {
    /** Идентификатор организации-исполнителя этой заявки */
    truckingOrganizationId?: number | undefined;
    /** Идентификатор организации, создавшей эту заявку */
    organizationId: number;
    /** Идентификатор пользователя, создавшего эту заявку */
    createdById: number;
    /** Идентификатор заказа, из которого была создана эта заявка */
    distributionBidId?: number | undefined;
    shippingOrder?: ShippingOrderBidModel | null | undefined;
    bidRateStatus?: BidRateStatus;
    /** Дата создания заявки */
    createdAt: string;
    /** Дата старта заявки */
    startedAt?: string | undefined;
    /** Первая дата старта заявки */
    firstStartedAt?: string | undefined;
    /** Дата завершения заявки */
    endedAt?: string | undefined;
    /** Дата последнего изменения заявки */
    updatedAt: string;
    status: BidStatus;
    type: BidType;
    /** Заявка с порожним пробегом (не учитывается в отчетах, в планировании и т.д.) */
    isEmptyMileageBid: boolean;
    /** Экспресс-заявка (заявки с индивидуальными настройками РТО) */
    isExpressBid: boolean;
    /** Водитель-экспедитор */
    isDriverForwarder: boolean;
    /** Заявка отправлена на факторинг? */
    hasFactoring: boolean;
    calculationStatus?: BidCalculationStatus;
    bidPointLoadUnloadStatus?: BidPointLoadUnloadStatus;
    /** Активный пробег */
    activeMileage: number;
    /** Плановый порожний пробег до текущей заявки от предыдущей (метры) */
    planEmptyMileageBefore: number;
    /** Фактический порожний пробег до текущей заявки от предыдущей (метры) */
    factEmptyMileageBefore: number;
    /** Расчетная информация по заявке (опоздание, дата прибытия) */
    estimations?: BidEstimateGetModel[] | undefined;
    /** Перепробег по вине водителя */
    excessMileage?: number | undefined;
    /** Причина перепробега */
    excessMileageReason?: string | undefined;
    /** Идентификатор типа причины перепробега */
    excessMileageReasonTypeId?: number | undefined;
    /** Опции заявки */
    readonly intStateFlags: number;
    /** Дата согласования логистом */
    approvedAt?: string | undefined;
    /** Текущее значение ДУТ */
    trackerSensorValue?: number | undefined;
    /** true если заявка является удалённой */
    isDeleted: boolean;
    lastSyncStatus: SyncEntityStatus;
    /** true если есть перецепка/пересменка */
    hasItemsChange: boolean;
    /** Plan mileage */
    planMileage: number;
    expressBid?: ExpressBidModel;
    /** Дата принятия заявки водителем */
    acceptedByDriverAt?: string | undefined;
    approvedBy?: UserShortNameViewModel;
    startedBy?: UserShortNameViewModel;
    responsible?: UserShortNameViewModel;
    salesManager?: UserShortNameViewModel;
    legalPerson?: LegalPersonViewModel;
    axisLoad?: AxisLoadValueModel;
    temperature?: TemperatureValueModel;
    factoring?: BidFactoringModel;
    organization?: OrganizationSimpleModel;
    temperatureRegime?: BidTemperatureRegimeModel;
    createdBy?: BidCreatedByViewModel;
    trailer?: TrailerOptionPreviewModel;
    car?: CarOptionViewModel;
    driver?: DriverViewModel;
    secondaryDriver?: DriverViewModel;
    cargoOwnerDictionaryItem?: CounterpartyBidViewModel;
    /** Открыт ли доступ к заявке? */
    sharedAccess: boolean;
    contract?: CounterpartyContractNumberModel;
    documentAssignment?: DocumentAssignmentStatusDriverModel;
    /** ID других заявок из сборной */
    compoundBidIds?: number[] | undefined;
    /** Чаты заявки */
    chats?: BidChatModel[] | undefined;
    /** Дополнительные поля заявки */
    extendedProperties?: ExtendedPropertyJsonObject[] | undefined;
    /** Точки заявки */
    bidPoints?: BidPointViewModel[] | undefined;
    /** Точки перецепки/пересменки */
    itemChangePoints?: ItemChangePointListModel[] | undefined;
    /** Грузы заявки */
    cargos?: CargoModel[] | undefined;
    /** Дополнительные опции типов для заявки */
    typeOptions?: TypeOptionModel[] | undefined;
    /** Нужно ли создавать задание сдачи документов водителю после завершения заявки? */
    createDocumentAssignment: boolean;
    /** true если есть подобранные внешние заказы без отклика по текущей машине */
    hasExternalBid: boolean;
    /** Наибольшая ставка (руб/км) по подобранным внешним заказам */
    externalBidOutput?: number | undefined;
    waybills?: WaybillBidModel[] | undefined;
    startPointBidId?: number | undefined;
    /** Type identifier payment type */
    paymentTypeId?: number | undefined;
    /** Type identifier vat type */
    ndsTypeId?: number | undefined;
    /** Hourly price */
    hourlyPrice?: number | undefined;
    /** Price */
    price?: number | undefined;
    /** Цена с учётом затрат */
    priceWithoutCosts?: number | undefined;
    /** Расшифровка затрат */
    costs?: BidCostsModel;
    /** Price without VAT on top */
    priceWithoutVatOnTop?: number | undefined;
    /** Does VAT go on top of price */
    isVatTop?: boolean | undefined;
    externalId?: string | undefined;
    /** Contract number */
    contractNumber?: string | undefined;
    sourceType: SourceType;
    /** Срок оплаты в днях */
    paymentPeriodInDays?: number | undefined;
    paymentPeriodType?: PaymentPeriodType;
    /** Bid documents */
    documents?: RelatedDocumentModel[] | undefined;
    id: number;
}

export interface BidListItemModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

/** Информация о машине в просмотре заявки */
export interface BidCarViewModel {
    id: number;
    /** Идентификатор типа машины */
    typeId?: number | undefined;
    /** Идентификатор трекера машины */
    trackerId?: number | undefined;
    /** Номер машины */
    number?: string | undefined;
    /** Идентификатор логиста */
    logistId?: number | undefined;
    /** Идентификатор транспортной колонны */
    transportColumnId?: number | undefined;
}

/** Bid estimation info (e.g. bid lateness period) */
export interface BidEstimateListModel {
    /** Car late period (difference between fact/calculated and plan dates) */
    latePeriod: string;
    /** Расчетная дата прибытия авто */
    estimatedDate?: string | undefined;
}

export interface DriverSimpleModel {
    id: number;
    shortName?: string | undefined;
}

export interface BidWaybillListItemModel {
    id: number;
    bidId?: number | null | undefined;
    billNumber?: string | undefined;
    lastTitleType?: string | null | undefined;
    lastTitleStatus?: WaybillTitleStatus | null | undefined;
    lastTitleSignatureFileId?: number | null | undefined;
}

/** Only owner bids list item */
export interface BidListItemModel {
    id: number;
    /** Цена */
    price?: number | undefined;
    /** Цена с учётом затрат */
    priceWithoutCosts?: number | undefined;
    status: BidStatus;
    /** Дата создания заявки */
    createdAt: string;
    /** Дата обновления из 1с */
    externalUpdatedAt?: string | undefined;
    /** Заявка отправлена на факторинг? */
    hasFactoring: boolean;
    firstBidPoint?: BidPointListItemModel;
    lastBidPoint?: BidPointListItemModel;
    /** Грузы */
    cargos?: CargoBidListModel[] | undefined;
    /** True если текущая заявка принята другой организацией */
    isAccepted: boolean;
    /** True если на текущей заявке прикреплена машина, где логист является текущим пользователем */
    isMyBid: boolean;
    /** True если текущая заявка создана текущим пользователем */
    isCreatedByMe: boolean;
    /** Идентификатор создателя заявки */
    createdById: number;
    /** Порожняя заявка */
    isEmptyMileageBid: boolean;
    /** Экспресс-заявка */
    isExpressBid: boolean;
    /** Водитель-экспедитор */
    isDriverForwarder: boolean;
    /** True если заявка согласована */
    isApproved: boolean;
    type: BidType;
    /** Идентификатор текущего водителя заявки */
    driverId?: number | undefined;
    /** ФИО текущего водителя заявки */
    driverName?: string | undefined;
    /** Идентификатор второго водителя заявки */
    secondaryDriverId?: number | undefined;
    /** ФИО второго водителя заявки */
    secondaryDriverName?: string | undefined;
    /** Внешний идентификатор заявки */
    externalId?: string | undefined;
    /** Идентификатор машины */
    carId?: number | undefined;
    car?: BidCarViewModel;
    /** Список данных по рассчетным датам/опозданиям по заявке */
    estimations?: BidEstimateListModel[] | undefined;
    /** Опоздание по ближайшей к текущей дате точке */
    firstLatePeriod?: string | undefined;
    bidPointLoadUnloadStatus?: BidPointLoadUnloadStatus;
    calculationStatus?: BidCalculationStatus;
    /** Признак сборной заявки */
    isCompoundBid: boolean;
    /** True если заявка была создана оператором */
    isCreatedByOperator: boolean;
    /** Идентификатор ответственного по заявке, может быть null */
    responsibleId?: number | undefined;
    /** Идентификатор менеджера по продажам заявки, может быть null */
    salesManagerId?: number | undefined;
    counterparty?: CounterpartyViewModel;
    counterpartyId?: number | undefined;
    /** Договор контрагента */
    contractId?: number | undefined;
    /** Открыт ли доступ к заявке? */
    sharedAccess: boolean;
    /** Идентификатор логиста, который был привязан к машине на момент создания заявки */
    carLogistId?: number | undefined;
    /** ФИО логиста, который был привязан к машине на момент создания заявки */
    carLogistName?: string | undefined;
    legalPerson?: LegalPersonViewModel;
    /** Если true, то заявка была закрыта вручную логистом */
    isClosedByLogist: boolean;
    readonly intStateFlags: number;
    lastSyncStatus: SyncEntityStatus;
    /** true если есть перецепка/пересменка */
    hasItemsChange: boolean;
    /** Дата принятия заявки водителем. */
    acceptedByDriverAt?: string | undefined;
    /** true если есть подобранные внешние заказы без отклика по текущей машине */
    hasExternalBid: boolean;
    /** Наибольшая ставка (руб/км) по подобранным внешним заказам */
    externalBidOutput?: number | undefined;
    /** true если есть точки сервисных работ */
    hasServicePoints: boolean;
    /** true если есть ЭТрН */
    hasWaybills: boolean;
    /** true если есть титул ЭТрН, ожидающий подписания */
    titleSignAwaiting: boolean;
    /** Электронные транспортные накладные */
    waybills?: BidWaybillListItemModel[] | undefined;
    /** Номер договора */
    contractNumber?: string | undefined;
    /** Минимальная температура */
    temperatureMinimum?: number | undefined;
    /** Максимальная температура */
    temperatureMaximum?: number | undefined;
    /** Последнее значение температуры */
    lastTemperatureValue?: TemperatureValueModel | undefined;
    /** Информация по всем машинам заявки */
    cars?: CarNumberModel[] | undefined;
    /** Информация по всем водителям заявки */
    drivers?: DriverSimpleModel[] | undefined;
    /** Адреса точек */
    pointAddresses?: string[] | undefined;
    /** Название транспортной колонны */
    carTransportColumnName?: string | undefined;
}

export interface BidForExternalSyncModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface LoadUnloadOptionModel {
    id: number;
}

export interface TrailerListViewModel {
    id: number;
    /** Идентификатор трекера */
    trackerId?: number | undefined;
    /** Тип прицепа. */
    typeId?: number | undefined;
    /** Марка прицепа. */
    brandTypeId?: number | undefined;
    /** Номер. */
    number?: string | undefined;
    /** Номер трекера */
    trackerDeviceNumber?: string | undefined;
    comment?: string | undefined;
    /** Типы загрузки/выгрузки */
    loadUnloadOptions?: LoadUnloadOptionModel[] | undefined;
    /** Activity sign */
    isActive: boolean;
    resourceInactivityInfo?: ResourceInactivityInfoJsonObject;
    transportColumn?: TransportColumnSimpleModel;
    mechanic?: MechanicNameModel;
    /** Is deleted? */
    isDeleted: boolean;
}

export interface IdModel {
    id: number;
}

export interface BidEstimationModel {
    /** Расчетная дата вьезда */
    estimatedDate?: string | undefined;
    /** Ручная дата выезда из точки */
    manualEstimatedLeaveDate?: string | undefined;
}

/** Модель заявки для синхронизации с внешними сервисами */
export interface BidForExternalSyncModel {
    id: number;
    /** Цена */
    price?: number | undefined;
    status: BidStatus;
    /** Дата создания заявки */
    createdAt: string;
    /** Дата обновления из 1с */
    externalUpdatedAt?: string | undefined;
    /** Заявка отправлена на факторинг? */
    hasFactoring: boolean;
    /** Идентификатор пользователя, кто создал заявку */
    createdById: number;
    /** Идентификатор Типа оплаты */
    paymentTypeId: number;
    /** Идентификатор Типа ндс */
    ndsTypeId: number;
    /** НДС сверху */
    isVatTop: boolean;
    /** Контрагент */
    counterpartyId?: number | undefined;
    /** Договор контрагента */
    contractId?: number | undefined;
    /** Порожняя заявка? */
    isEmptyMileageBid: boolean;
    /** Текущий водитель заявки */
    driverId?: number | undefined;
    /** Второй водитель заявки */
    secondaryDriverId?: number | undefined;
    /** Идентификатор пользователя-оператора, который согласовал заявку (используется если у организации включен модуль согласования заявок) */
    approvedById?: number | undefined;
    /** Дата согласования оператором (используется если у организации включен модуль согласования заявок) */
    approvedAt?: string | undefined;
    /** Идентификатор ответственного */
    responsibleId?: number | undefined;
    /** Идентификатор менеджера по продажам */
    salesManagerId?: number | undefined;
    /** Идентификатор логиста, который был привязан к машине на момент создания заявки */
    carLogistId?: number | undefined;
    /** Идентификатор заказа, из которого создана эта заявка */
    distributionBidId?: number | undefined;
    /** Идентификатор маршрута */
    routeId?: number | undefined;
    /** Плановый пробег (метры) */
    planMileage: number;
    /** Фактический пробег (метры) */
    factMileage: number;
    /** Плановый порожний пробег до текущей заявки от предыдущей (метры) */
    planEmptyMileageBefore: number;
    /** Фактический порожний пробег до текущей заявки от предыдущей (метры) */
    factEmptyMileageBefore: number;
    /** Дата обновления */
    updatedAt: string;
    car?: CarSimpleModel;
    trailer?: TrailerListViewModel;
    legalPerson?: IdModel;
    estimation?: BidEstimationModel;
    bidPointLoadUnloadStatus?: BidPointLoadUnloadStatus;
    /** Точки загрузки */
    bidPoints?: BidPointViewModel[] | undefined;
    /** Грузы */
    cargos?: CargoModel[] | undefined;
    /** Дополнительные опции типов для заявки */
    typeOptions?: TypeOptionModel[] | undefined;
    temperatureRegime?: BidTemperatureRegimeModel;
    temperature?: TemperatureValueModel;
    /** Список документов */
    documents?: RelatedDocumentModel[] | undefined;
    /** Дополнительные поля заявки */
    extendedProperties?: ExtendedPropertyJsonObject[] | undefined;
    externalId?: string | undefined;
    /** Номер договора */
    contractNumber?: string | undefined;
    /** Срок оплаты в днях */
    paymentPeriodInDays?: number | undefined;
    paymentPeriodType?: PaymentPeriodType;
    sourceType: SourceType;
    /** Дата принятия заявки водителем */
    acceptedByDriverAt?: string | undefined;
    /** true если есть перецепка/пересменка */
    hasItemsChange: boolean;
    /** Является ли сущность удаленной? */
    isDeleted: boolean;
    /** Нужно ли создавать задание сдачи документов водителю после завершения заявки? */
    createDocumentAssignment: boolean;
    /** true если есть точки сервисных работ */
    hasServicePoints: boolean;
}

export interface RouteSimpleModel {
    id: number;
    /** Дистанция маршрута в метрах */
    distance: number;
    /** Продолжительность маршрута в секундах */
    duration: number;
    /** Дистанция маршрута от первой точки до последней, в метрах */
    distanceWithoutEmptyMileage: number;
    /** Дистанция маршрута от нулевой точки до первой точки, в метрах */
    emptyMileageDistance: number;
    /** Продолжительность маршрута от первой точки до последней, в секундах */
    durationWithoutEmptyMileage: number;
    routeOptions?: RouteOptions;
}

export interface TraveledRouteFixedAtPartModel {
    coordinate?: number[] | undefined;
    fixedAt: string;
}

export enum RouteType {
    Main = "Main",
    EmptyMileage = "EmptyMileage",
}

export interface CarRouteControlPoint {
    index: number;
    routeType: RouteType;
}

export interface CarRouteViewModel {
    /** Пройденный маршрут (координаты) */
    readonly traveledRouteCoordinates?: number[][] | undefined;
    /** Пройденный маршрут (координаты + время фиксации каждые Х минут) */
    traveledRouteFixedAtParts?: TraveledRouteFixedAtPartModel[] | undefined;
    controlPoints?: CarRouteControlPoint[] | undefined;
    /** Идентификатор машины */
    carId: number;
    /** Номер машины */
    carNumber?: string | undefined;
    /** У заявки есть активный пробег (заехала в первую точку по заявке) */
    hasActiveMileage: boolean;
    /** Данная часть маршрута построена из мобильных координат */
    isMobile: boolean;
}

export interface RouteTemplateViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface RouteTemplateViewModel {
    id: number;
    name?: string | undefined;
    /** Координаты промежуточных точек */
    supportPoints?: number[][] | undefined;
}

/** Модель для редактирования группы контрагента */
export interface CounterpartyGroupEditModel {
    /** Наименование */
    name?: string | undefined;
    id: number;
}

export interface CounterpartyGroupDeleteModel {
    id: number;
}

export interface CounterpartyGroupNameModel {
    id: number;
    name?: string | undefined;
}

export interface CounterpartyGroupNameModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CounterpartyGroupListItemModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CounterpartyGroupListItemModel {
    id: number;
    name?: string | undefined;
    count: number;
}

export interface AddCounterpartiesWithoutGroupModel {
    id: number;
}

export interface SetGroupForCounterpartiesModel {
    counterpartyGroupId?: number | undefined;
    counterpartyIds?: number[] | undefined;
}

export interface ClearCounterpartyGroupModel {
    id: number;
}

export interface CustomPointTypeViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CustomPointTypeViewModel {
    id: number;
    name?: string | undefined;
    /** Плановое время нахождения на точке (ч) */
    planStayPeriod: number;
}

export interface CustomPointTypeEditModel {
    name?: string | undefined;
    /** Плановое время нахождения на точке (ч) */
    planStayPeriod: number;
    id: number;
}

export interface CustomPointTypeDeleteModel {
    id: number;
}

export interface CustomPointTypeRestoreModel {
    id: number;
}

export enum ExternalIdSource {
    Kontur = "Kontur",
    ExternalIntegration = "ExternalIntegration",
    AtiSu = "AtiSu",
}

export enum ExternalDistributionBidStatus {
    None = "None",
    Accepted = "Accepted",
    Declined = "Declined",
    AwaitForwardingRequest = "AwaitForwardingRequest",
}

export interface DistributionBidCargoModel {
    id: number;
    /** Наименование */
    name: string | undefined;
    /** Вес */
    weight?: number | undefined;
    /** Обьем */
    volume?: number | undefined;
    /** Длина */
    length?: number | undefined;
    /** Высота */
    height?: number | undefined;
    /** Ширина */
    width?: number | undefined;
    /** Комментарий */
    comment?: string | undefined;
    /** Температура */
    temperatureHint?: string | undefined;
    /** Минимальная температура */
    temperatureMinimum?: number | undefined;
    /** Максимальная температура */
    temperatureMaximum?: number | undefined;
    /** Идентификатор типа Тип груза */
    typeId?: number | undefined;
    /** Идентификатор типа Тип загрузки */
    loadingTypeId?: number | undefined;
    /** Идентификатор типа Тип выгрузки */
    unloadingTypeId?: number | undefined;
    /** Тип упаковки */
    packType?: string | undefined;
    /** Количество грузовых мест */
    placesCount?: number | undefined;
    /** Дополнительные поля груза заявки */
    extendedProperties?: ExtendedPropertyJsonObject[] | undefined;
    /** Дополнительные опции типов для груза */
    typeOptions?: TypeOptionModel[] | undefined;
}

/** Точка заказа */
export interface DistributionBidPointEditModel {
    id: number;
    /** Порядок точки */
    order: number;
    /** Контрагент */
    counterpartyId?: number | undefined;
    type: BidPointType;
    /** Тип произвольной точки */
    customPointTypeId?: number | undefined;
    /** Идентификатор точки контрагента, для установки даты её последнего использования */
    counterpartyPointId?: number | undefined;
    /** Сценарий для водителя */
    scenarioId?: number | undefined;
    /** Плановая локальная дата загрузки/выгрузки (по местному времени адреса точки).- */
    planEnterDate?: string | undefined;
    /** Плановая локальная дата выезда */
    planLeaveDate?: string | undefined;
    /** Внешний ид точки заявки */
    externalId?: string | undefined;
    /** Клиент */
    client?: string | undefined;
    /** Комментарий к точке */
    comment?: string | undefined;
    /** Плановая дата загрузки/выгрузки, вычисленная по плановой локальной дате, учитывая часовой пояс точки. */
    planEnterDateOffset?: string | undefined;
    /** Плановая вторая дата выезда, вычисленная по плановой локальной дате выезда, учитывая часовой пояс точки. */
    secondaryPlanEnterDateOffset?: string | undefined;
    /** Плановая локальная вторая дата загрузки/выгрузки (по местному времени адреса точки).- */
    secondaryPlanEnterDate?: string | undefined;
    /** Плановая дата выезда, вычисленная по плановой локальной дате выезда, учитывая часовой пояс точки. */
    planLeaveDateOffset?: string | undefined;
    geozone?: MapObjectEditModel;
    contactPerson?: ContactPersonModel;
    typeOptions?: TypeOptionModel[] | undefined;
    loadOptions?: LoadOptionModel[] | undefined;
    /** Дополнительные поля точки заявки */
    extendedProperties?: ExtendedPropertyJsonObject[] | undefined;
}

/** Заказа */
export interface DistributionBidEditModel {
    /** Опции */
    intOptions?: number | undefined;
    /** Комментарий */
    comment?: string | undefined;
    /** Type identifier payment type */
    paymentTypeId?: number | undefined;
    /** Type identifier vat type */
    ndsTypeId?: number | undefined;
    /** Hourly price */
    hourlyPrice?: number | undefined;
    /** Price */
    price?: number | undefined;
    /** Does VAT go on top of price */
    isVatTop?: boolean | undefined;
    externalId?: string | undefined;
    /** Contract number */
    contractNumber?: string | undefined;
    /** Срок оплаты в днях */
    paymentPeriodInDays?: number | undefined;
    paymentPeriodType?: PaymentPeriodType;
    /** Основание для выставления счета заказчику */
    invoiceTriggerType?: InvoiceTriggerType;
    /** Bid documents */
    documents?: RelatedDocumentModel[] | undefined;
    /** Контрагент */
    counterpartyId?: number | undefined;
    /** Договор контрагента */
    contractId?: number | undefined;
    /** Юр. лицо */
    legalPersonId?: number | undefined;
    /** Источник внешнего заказа (Экспедиция) */
    sourceId?: number | undefined;
    /** Обязательность заказа */
    isMandatory: boolean;
    /** Экспресс заявка? */
    isExpressBid: boolean;
    /** Используется ли наемный транспорт */
    hasHiredCar: boolean;
    /** Перевозчик наемного транспорта */
    hiredCarCounterpartyId?: number | undefined;
    /** Стоимость наемного транспорта */
    hiredCarPrice?: number | undefined;
    /** Тип оплаты перевозчику */
    hiredCarPaymentTypeId?: number | undefined;
    /** Основание для выставления счета перевозчику */
    hiredCarInvoiceTriggerType?: InvoiceTriggerType;
    /** Вид срока оплаты перевозчику */
    hiredCarPaymentPeriodType?: PaymentPeriodType;
    /** Срок оплаты перевозчику */
    hiredCarPaymentPeriodInDays?: number | undefined;
    /** Ручная дата выполнения с часовым поясом */
    hiredCarCompletedAtOffset?: string | undefined;
    /** Ручная дата выполнения */
    hiredCarCompletedAt?: string | undefined;
    /** Тип прицепа. */
    trailerTypeId?: number | undefined;
    expressBid?: ExpressBidModel;
    contactPerson?: ContactPersonModel;
    /** Нужно ли создавать задание сдачи документов водителю после завершения заявки? */
    createDocumentAssignment: boolean;
    carId?: number | undefined;
    externalStatus: ExternalDistributionBidStatus;
    /** Информация о грузе */
    cargos?: DistributionBidCargoModel[] | undefined;
    /** Точки заказа */
    bidPoints?: DistributionBidPointEditModel[] | undefined;
    /** Дополнительные опции типов */
    typeOptions?: TypeOptionModel[] | undefined;
    extendedProperties?: ExtendedPropertyJsonObject[] | undefined;
    /** Расходы */
    expenses?: ExpenseSimpleModel[] | undefined;
    /** Расчёты с заказчиком */
    customerPayment?: BidPaymentModel | undefined;
    /** Расчёты с перевозчиком */
    hiredCarPayment?: BidPaymentModel | undefined;
    key?: string | undefined;
    id: number;
}

export interface ShippingOrderDistributionBidEditModel extends DistributionBidEditModel {
    shippingOrderId: number;
}

export interface ApplyBidResultModel {
    id: number;
    isRouteBuilt: boolean;
}

export interface DistributionBidBatchEditModel {
    /** Заказы на распределение */
    items?: DistributionBidEditModel[] | undefined;
}

export interface DistributionBidDeleteModel {
    id: number;
}

export interface DistributionBidRevertModel {
    id: number;
}

export interface DistributionBidRestoreModel {
    id: number;
}

export interface DistributionBidCancelModel {
    /** Идентификатор заказа */
    id: number;
    cancelComment?: string | undefined;
}

export interface DistributionBidListModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export enum DistributionBidStatus {
    New = "New",
    Canceled = "Canceled",
}

/** Точка заказа */
export interface DistributionBidPointListModel {
    id: number;
    order: number;
    type: BidPointType;
    planEnterDate: string;
    secondaryPlanEnterDate?: string | undefined;
    /** Опции точки */
    intOptions?: number | undefined;
    geozone?: MapObjectViewModel;
    /** Тип произвольной точки */
    customPointTypeId?: number | undefined;
    /** Плановая дата загрузки/выгрузки, вычисленная по плановой локальной дате, учитывая часовой пояс точки. */
    planEnterDateOffset: string;
    /** Плановая дата загрузки/выгрузки, вычисленная по плановой локальной дате, учитывая часовой пояс точки. */
    secondaryPlanEnterDateOffset?: string | undefined;
}

export interface DistributionBidSourceViewModel {
    id: number;
    name?: string | undefined;
    knowledgeBaseUrl?: string | undefined;
    iconUrl?: string | undefined;
}

export interface CargoSimpleModel {
    /** Тип груза */
    typeId?: number | undefined;
    name?: string | undefined;
    weight?: number | undefined;
}

/** Модель для отображения в списке */
export interface DistributionBidListModel {
    /** Идентификатор заявки, созданной на этом заказе, если null - заказ не распределен */
    bidId?: number | undefined;
    counterparty?: CounterpartyViewModel;
    /** Идентификатор контрагента */
    counterpartyId?: number | undefined;
    contractId?: number | undefined;
    contactPerson?: ContactPersonViewModel;
    contactPersonId?: number | undefined;
    /** Дата создания */
    createdAt: string;
    /** Дата обновления */
    updatedAt: string;
    /** Опции */
    intOptions?: number | undefined;
    /** Комментарий */
    comment?: string | undefined;
    /** Type identifier payment type */
    paymentTypeId?: number | undefined;
    /** Type identifier vat type */
    ndsTypeId?: number | undefined;
    /** Hourly price */
    hourlyPrice?: number | undefined;
    /** Price */
    price?: number | undefined;
    /** Price without VAT on top */
    priceWithoutVatOnTop?: number | undefined;
    /** Цена с учётом затрат */
    priceWithoutCosts?: number | undefined;
    /** Does VAT go on top of price */
    isVatTop?: boolean | undefined;
    externalId?: string | undefined;
    /** Contract number */
    contractNumber?: string | undefined;
    sourceType: SourceType;
    /** Срок оплаты в днях */
    paymentPeriodInDays?: number | undefined;
    paymentPeriodType?: PaymentPeriodType;
    /** Bid documents */
    documents?: RelatedDocumentModel[] | undefined;
    /** Обязательность заказа */
    isMandatory: boolean;
    /** Заказ создан по электронной заказ-заявке */
    isShippingOrder?: boolean | undefined;
    /** Используется ли наемный транспорт */
    hasHiredCar: boolean;
    isDeleted: boolean;
    /** Расстояние от первой точки заказа до последней */
    distance?: number | undefined;
    /** Выработка заказа (руб/км) (без учета порожнего пробега до первой точки заказа) */
    output?: number | undefined;
    /** Выработка заказа с учётом затрат */
    outputWithoutCosts?: number | undefined;
    cancelComment?: string | undefined;
    lastSyncStatus: SyncEntityStatus;
    externalStatus: ExternalDistributionBidStatus;
    status: DistributionBidStatus;
    /** Ручная дата выполнения c часовым поясом */
    hiredCarCompletedAtOffset?: string | undefined;
    /** Ручная дата выполнения */
    hiredCarCompletedAt?: string | undefined;
    firstBidPoint?: DistributionBidPointListModel;
    lastBidPoint?: DistributionBidPointListModel;
    source?: DistributionBidSourceViewModel;
    /** Информация о грузе */
    cargos?: CargoSimpleModel[] | undefined;
    /** Адреса точек */
    pointAddresses?: string[] | undefined;
    /** Расчёты с заказчиком */
    customerPayment?: BidPaymentGetModel | undefined;
    /** Расчёты с перевозчиком */
    hiredCarPayment?: BidPaymentGetModel | undefined;
    id: number;
}

export interface DistributionBidPointViewModel {
    id: number;
    /** Порядок точки */
    order: number;
    type: BidPointType;
    customPointTypeId?: number | undefined;
    /** Сценарий для водителя */
    scenarioId?: number | undefined;
    /** Опции точки */
    readonly intOptions?: number | undefined;
    client?: string | undefined;
    /** Комментарий к точке */
    comment?: string | undefined;
    /** Внешний ид точки */
    externalId?: string | undefined;
    /** Плановая локальная дата загрузки/выгрузки (по местному времени адреса точки). */
    planEnterDate: string;
    /** Плановая дата загрузки/выгрузки, вычисленная по плановой локальной дате, учитывая часовой пояс точки. */
    planEnterDateOffset: string;
    /** Плановая дата выезда. Если модуль планирования включен, вычисляется как плановая дата въезда + X часов. */
    planLeaveDateOffset?: string | undefined;
    /** Вторая плановая дата въезда */
    secondaryPlanEnterDate?: string | undefined;
    /** Вторая плановая дата загрузки/выгрузки, вычисленная по плановой локальной дате, учитывая часовой пояс точки. */
    secondaryPlanEnterDateOffset?: string | undefined;
    /** Плановая дата выезда */
    planLeaveDate?: string | undefined;
    createdById: number;
    geozone?: MapObjectModel;
    contactPerson?: ContactPersonModel;
    counterparty?: CounterpartyViewModel;
    /** Типы загрузок/выгрузок на точке */
    loadOptions?: LoadOptionModel[] | undefined;
    /** Дополнительные опции типов для точки */
    typeOptions?: TypeOptionModel[] | undefined;
    /** Дополнительные поля точки заявки */
    extendedProperties?: ExtendedPropertyJsonObject[] | undefined;
    customPointType?: CustomPointTypeSimpleModel;
}

export interface DistributionBidViewModel {
    /** Опции */
    intOptions?: number | undefined;
    /** Комментарий */
    comment?: string | undefined;
    /** Type identifier payment type */
    paymentTypeId?: number | undefined;
    /** Type identifier vat type */
    ndsTypeId?: number | undefined;
    /** Hourly price */
    hourlyPrice?: number | undefined;
    /** Price */
    price?: number | undefined;
    /** Price without VAT on top */
    priceWithoutVatOnTop?: number | undefined;
    /** Цена с учётом затрат */
    priceWithoutCosts?: number | undefined;
    /** Расшифровка затрат */
    costs?: BidCostsModel;
    /** Does VAT go on top of price */
    isVatTop?: boolean | undefined;
    externalId?: string | undefined;
    /** Contract number */
    contractNumber?: string | undefined;
    sourceType: SourceType;
    /** Срок оплаты в днях */
    paymentPeriodInDays?: number | undefined;
    paymentPeriodType?: PaymentPeriodType;
    /** Основание для выставления счета заказчику */
    invoiceTriggerType?: InvoiceTriggerType;
    /** Bid documents */
    documents?: RelatedDocumentModel[] | undefined;
    /** Идентификатор юр. лица */
    legalPersonId?: number | undefined;
    /** Идентификатор заявки, которая была создана из данного заказа */
    bidId?: number | undefined;
    shippingOrder?: ShippingOrderModel | null | undefined;
    /** Когда заявка по заказу была завершена */
    bidCompletedAt?: string | undefined;
    /** Контрагент */
    counterpartyId?: number | undefined;
    /** Дата создания заказа */
    createdAt: string;
    /** Дата обновления заказа */
    updatedAt: string;
    contactPerson?: ContactPersonViewModel;
    legalPerson?: LegalPersonViewModel;
    counterparty?: CounterpartyViewModel;
    contract?: CounterpartyContractNumberModel;
    createdBy?: BidCreatedByViewModel;
    /** Информация о грузе */
    cargos?: CargoModel[] | undefined;
    /** Точки заказа */
    bidPoints?: DistributionBidPointViewModel[] | undefined;
    /** Используется ли наемный транспорт */
    hasHiredCar: boolean;
    /** Перевозчик наемного транспорта */
    hiredCarCounterpartyId?: number | undefined;
    hiredCarCounterparty?: CounterpartyViewModel;
    /** Стоимость наемного транспорта */
    hiredCarPrice?: number | undefined;
    /** Тип оплаты перевозчику */
    hiredCarPaymentTypeId?: number | undefined;
    /** Основание для выставления счета перевозчику */
    hiredCarInvoiceTriggerType?: InvoiceTriggerType;
    /** Вид срока оплаты перевозчику */
    hiredCarPaymentPeriodType?: PaymentPeriodType;
    /** Срок оплаты перевозчику */
    hiredCarPaymentPeriodInDays?: number | undefined;
    /** Ручная дата выполнения */
    hiredCarCompletedAtOffset?: string | undefined;
    /** Ручная дата выполнения */
    hiredCarCompletedAt?: string | undefined;
    lastSyncStatus: SyncEntityStatus;
    /** Тип прицепа */
    trailerTypeId?: number | undefined;
    /** Обязательность заказа */
    isMandatory: boolean;
    car?: CarOptionViewModel;
    externalStatusChangedBy?: UserShortNameViewModel;
    externalStatus: ExternalDistributionBidStatus;
    /** Расстояние от первой точки заказа до последней */
    distance: number;
    /** Выработка заказа (руб/км) (без учета порожнего пробега до первой точки заказа) */
    output: number;
    status: DistributionBidStatus;
    cancelComment?: string | undefined;
    isDeleted: boolean;
    /** Нужно ли создавать задание сдачи документов водителю после завершения заявки? */
    createDocumentAssignment: boolean;
    expressBid?: ExpressBidModel;
    source?: DistributionBidSourceViewModel;
    typeOptions?: TypeOptionModel[] | undefined;
    /** Дополнительные поля */
    extendedProperties?: ExtendedPropertyJsonObject[] | undefined;
    /** Идентификатор наёмного ТС */
    hiredCarId?: number | undefined;
    /** Расчёты с заказчиком */
    customerPayment?: BidPaymentGetModel | undefined;
    /** Расчёты с перевозчиком */
    hiredCarPayment?: BidPaymentGetModel | undefined;
    /** Идентификатор наёмного прицепа */
    hiredTrailerId?: number | undefined;
    /** Идентификатор наёмного водителя */
    hiredDriverId?: number | undefined;
    hiredCar?: HiredCarViewModel;
    hiredTrailer?: HiredTrailerViewModel;
    hiredDriver?: HiredDriverViewModel;
    /** Расходы */
    expenses?: ExpenseSimpleModel[] | undefined;
    id: number;
}

export interface BidCostsModel {
    platonCost: number;
    tollRoadsCost: number;
    expensesCost: number;
}

export interface ExpenseSimpleModel {
    id: number;
    typeId: number;
    value: number;
    comment?: string | undefined;
}

export interface HiredCarViewModel {
    id: number;
    number: string;
    typeId: number;
    brandTypeId: number;
}

export interface HiredTrailerViewModel {
    id: number;
    number: string;
    typeId: number;
    brandTypeId: number;
}

export interface HiredDriverViewModel {
    id: number;
    firstName: string;
    lastName: string;
    patronymic?: string | undefined;
    phoneNumber: string;
    passportIssuingCountry?: "Belarus" | "RussianFederation" | "Uzbekistan" | "Kazakhstan" | null | undefined;
    licenseIssuingCountry?: "Belarus" | "RussianFederation" | "Uzbekistan" | "Kazakhstan" | null | undefined;
    passportSeries?: string | undefined;
    passportNumber?: string | undefined;
    passportIssuedBy?: string | undefined;
    passportDateOfIssue?: string | undefined;
    passportSubdivisionCode?: string | undefined;
    licenseSeries?: string | undefined;
    licenseNumber?: string | undefined;
    licenseDateOfIssue?: string | undefined;
    licenseExpirationDate?: string | undefined;
}

export interface HiredCarEditModel {
    id: number;
    number: string;
    typeId: number;
    brandTypeId: number;
    isDeleted: boolean;
}

export interface HiredTrailerEditModel {
    id: number;
    number: string;
    typeId: number;
    brandTypeId: number;
    isDeleted: boolean;
}

export interface HiredDriverEditModel {
    id: number;
    firstName: string;
    lastName: string;
    patronymic?: string | undefined;
    phoneNumber: string;
    passportIssuingCountry?: "Belarus" | "RussianFederation" | "Uzbekistan" | "Kazakhstan" | null | undefined;
    licenseIssuingCountry?: "Belarus" | "RussianFederation" | "Uzbekistan" | "Kazakhstan" | null | undefined;
    passportSeries?: string | undefined;
    passportNumber?: string | undefined;
    passportIssuedBy?: string | undefined;
    passportDateOfIssue?: string | undefined;
    passportSubdivisionCode?: string | undefined;
    licenseSeries?: string | undefined;
    licenseNumber?: string | undefined;
    licenseDateOfIssue?: string | undefined;
    licenseExpirationDate?: string | undefined;
    fullName: string;
    isDeleted: boolean;
}

/** Информация о пользователе */
export interface UserEditModel {
    /** Email */
    email: string | undefined;
    /** Имя */
    firstName: string | undefined;
    /** Фамилия */
    lastName: string | undefined;
    /** Отчество */
    patronymic?: string | undefined;
    /** Номер телефона */
    phoneNumber?: string | undefined;
    /** Добавочный номер телефона */
    phoneNumberExtension?: string | undefined;
    lastSignInAt?: string | undefined;
    connectionState: ConnectionState;
    id: number;
}

/** Водитель */
export interface DriverModel {
    id: number;
    user?: UserEditModel;
    /** ИНН физического лица */
    inn?: string | undefined;
}

export interface TrailerOptionModel {
    trailerId?: number | undefined;
    typeId?: number | undefined;
    number?: string | undefined;
    carrying?: number | undefined;
    volume?: number | undefined;
    length?: number | undefined;
    height?: number | undefined;
    width?: number | undefined;
    axleLoad?: number | undefined;
    wheelBase?: number | undefined;
    curbWeight?: number | undefined;
    grossWeight?: number | undefined;
    axesDistance?: number | undefined;
    fifthWheelLoad?: number | undefined;
    containerCount?: number | undefined;
    wheelFormula?: string | undefined;
    wheelsDescription?: string | undefined;
    brandTypeId?: number | undefined;
}

export interface CarOptionCarIdModel {
    /** Идентификатор машины */
    carId?: number | undefined;
}

export enum NotificationType {
    BidPointArrival = "BidPointArrival",
    BidLateness = "BidLateness",
    TrackerLogsStopped = "TrackerLogsStopped",
    SystemNotification = "SystemNotification",
    CarStopped = "CarStopped",
    RouteEvents = "RouteEvents",
    BidStart = "BidStart",
    BidPlannedRefuelings = "BidPlannedRefuelings",
    AxisLoadMonitoring = "AxisLoadMonitoring",
    BidApproved = "BidApproved",
    BidRefuelingPointArrival = "BidRefuelingPointArrival",
    DriverControlPoints = "DriverControlPoints",
    CarStaysAtBidPoint = "CarStaysAtBidPoint",
    BidLoadLateness = "BidLoadLateness",
    TemperatureMonitoring = "TemperatureMonitoring",
    DriverMessage = "DriverMessage",
    ItemChangePointArrival = "ItemChangePointArrival",
    ServicePoints = "ServicePoints",
    BidAcceptLateness = "BidAcceptLateness",
    TitleSignAwaiting = "TitleSignAwaiting",
    RefuelingSkipped = "RefuelingSkipped",
    BidPointEstimatedLateness = "BidPointEstimatedLateness",
    LogistTasks = "LogistTasks",
    BidPlanMileageDeviation = "BidPlanMileageDeviation",
}

export enum BidRole {
    Creator = "Creator",
    Responsible = "Responsible",
    CarLogist = "CarLogist",
    SalesManager = "SalesManager",
}

export interface LogistTaskSettingViewModel {
    id: number;
    name?: string | undefined;
    notificationType: NotificationType;
    bidRole?: BidRole;
    commentRequired: boolean;
    isActive: boolean;
}

/** Модель заявки грузоперевозчика */
export interface BidTruckingGetModel {
    /** Type identifier payment type */
    paymentTypeId?: number | undefined;
    /** Type identifier vat type */
    ndsTypeId?: number | undefined;
    /** Hourly price */
    hourlyPrice?: number | undefined;
    /** Price */
    price?: number | undefined;
    /** Price without VAT on top */
    priceWithoutVatOnTop?: number | undefined;
    /** Does VAT go on top of price */
    isVatTop?: boolean | undefined;
    externalId?: string | undefined;
    /** Contract number */
    contractNumber?: string | undefined;
    sourceType: SourceType;
    /** Срок оплаты в днях */
    paymentPeriodInDays?: number | undefined;
    paymentPeriodType?: PaymentPeriodType;
    /** Bid documents */
    documents?: RelatedDocumentModel[] | undefined;
    /** An owner organization id */
    organizationId: number;
    /** An executor organization (e.g. this bid was created by a forwarder) */
    truckingOrganizationId?: number | undefined;
    type: BidType;
    counterparty?: CounterpartyBidViewModel;
    contract?: CounterpartyContractForSelectModel;
    /** Заявка с порожним пробегом (не учитывается в отчетах, в планировании и т.д.) */
    isEmptyMileageBid: boolean;
    /** Дата обновления из 1с */
    externalUpdatedAt?: string | undefined;
    /** Идентификатор юр. лица */
    legalPersonId?: number | undefined;
    /** Идентификатор ответственного */
    responsibleId?: number | undefined;
    /** Идентификатор менеджера по продажам */
    salesManagerId?: number | undefined;
    /** Идентификатор создавшего заявку */
    createdById: number;
    /** Дата согласования оператором (null если не согласовано или не включено согласование) */
    approvedAt?: string | undefined;
    /** True если заявка была создана оператором */
    isCreatedByOperator: boolean;
    /** Экспресс-заявка */
    isExpressBid: boolean;
    /** Водитель-экспедитор */
    isDriverForwarder: boolean;
    status: BidStatus;
    driver?: DriverModel;
    secondaryDriver?: DriverModel;
    trailerOption?: TrailerOptionModel;
    carOption?: CarOptionCarIdModel;
    /** Точки заявки */
    bidPoints?: BidPointGetModel[] | undefined;
    /** Грузы заявки */
    cargos?: CargoModel[] | undefined;
    temperatureRegime?: BidTemperatureRegimeModel;
    /** Дополнителные поля заявки */
    extendedProperties?: ExtendedPropertyJsonObject[] | undefined;
    /** Конфигурируемые, дополнительные опции для заявки */
    typeOptions?: TypeOptionModel[] | undefined;
    expressBid?: ExpressBidModel;
    /** Признак сборной заявки */
    isCompoundBid: boolean;
    /** Нужно ли создавать задание сдачи документов водителю после завершения заявки? */
    createDocumentAssignment: boolean;
    /** Настройки задач логистам */
    logistTaskSettings?: LogistTaskSettingViewModel[] | undefined;
    id: number;
}

export interface DistributionBidMatchListModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

/** Counterparty */
export interface CounterpartyPriorityModel {
    id: number;
    /** Приоритетен ли */
    isPriority: boolean;
    /** Наименование */
    name?: string | undefined;
}

/** Информация о подходящем заказе по параметрам */
export interface DistributionBidMatchListModel {
    id: number;
    /** Расстояние до первой точки заказа, в км */
    emptyMileage: number;
    /** Стоимость */
    price?: number | undefined;
    /** Стоимость без НДС сверху */
    priceWithoutVatOnTop?: number | undefined;
    /** Идентификатор типа Тип НДС */
    ndsTypeId?: number | undefined;
    /** Идентификатор типа Тип оплаты */
    paymentTypeId?: number | undefined;
    /** НДС сверху стоимости */
    isVatTop?: boolean | undefined;
    firstBidPoint?: DistributionBidPointListModel;
    lastBidPoint?: DistributionBidPointListModel;
    /** Расстояние от первой точки заказа до последней, в км */
    distance?: number | undefined;
    /** Используется ли наемный транспорт */
    hasHiredCar: boolean;
    counterparty?: CounterpartyPriorityModel;
    /** Идентификатор контрагента */
    counterpartyId?: number | undefined;
    /** Выработка (руб/км) без учета порожнего пробега */
    outputWithoutEmptyMileage?: number | undefined;
    /** Выработка (руб/км) с учетом порожнего пробега */
    outputWithEmptyMileage?: number | undefined;
    /** Расчетное время прибытия на точку загрузки */
    estimatedEnterDateOffset: string;
    /** Идентификатор типа Тип прицепа */
    trailerTypeId?: number | undefined;
    /** Обязательный заказ */
    isMandatory: boolean;
    createdBy?: UserShortNameViewModel;
}

export interface DistributionBidCloneModel {
    /** Идентификатор заказа. */
    id: number;
}

export interface DistributionBidForExternalSyncModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface DistributionBidForExternalSyncModel {
    /** Идентификатор заявки, созданной на этом заказе, если null - заказ не распределен */
    bidId?: number | undefined;
    counterparty?: CounterpartyViewModel;
    /** Идентификатор контрагента */
    counterpartyId?: number | undefined;
    contractId?: number | undefined;
    contactPerson?: ContactPersonViewModel;
    contactPersonId?: number | undefined;
    /** Дата создания */
    createdAt: string;
    /** Дата обновления */
    updatedAt: string;
    /** Опции */
    intOptions?: number | undefined;
    /** Комментарий */
    comment?: string | undefined;
    /** Type identifier payment type */
    paymentTypeId?: number | undefined;
    /** Type identifier vat type */
    ndsTypeId?: number | undefined;
    /** Hourly price */
    hourlyPrice?: number | undefined;
    /** Price */
    price?: number | undefined;
    /** Price without VAT on top */
    priceWithoutVatOnTop?: number | undefined;
    /** Does VAT go on top of price */
    isVatTop?: boolean | undefined;
    externalId?: string | undefined;
    /** Contract number */
    contractNumber?: string | undefined;
    sourceType: SourceType;
    /** Срок оплаты в днях */
    paymentPeriodInDays?: number | undefined;
    paymentPeriodType?: PaymentPeriodType;
    /** Основание для выставления счета заказчику */
    invoiceTriggerType?: InvoiceTriggerType;
    /** Bid documents */
    documents?: RelatedDocumentModel[] | undefined;
    /** Используется ли наемный транспорт */
    hasHiredCar: boolean;
    /** Перевозчик наемного транспорта */
    hiredCarCounterpartyId?: number | undefined;
    /** Стоимость наемного транспорта */
    hiredCarPrice?: number | undefined;
    /** Тип оплаты перевозчику */
    hiredCarPaymentTypeId?: number | undefined;
    /** Основание для выставления счета перевозчику */
    hiredCarInvoiceTriggerType?: InvoiceTriggerType;
    /** Вид срока оплаты перевозчику */
    hiredCarPaymentPeriodType?: PaymentPeriodType;
    /** Срок оплаты перевозчику */
    hiredCarPaymentPeriodInDays?: number | undefined;
    /** Ручная дата выполнения c часовым поясом */
    hiredCarCompletedAtOffset?: string | undefined;
    /** Ручная дата выполнения */
    hiredCarCompletedAt?: string | undefined;
    lastSyncStatus: SyncEntityStatus;
    /** Идентификатор создателя */
    createdById: number;
    /** Идентификатор юр. лица */
    legalPersonId?: number | undefined;
    /** Обязательный заказ? */
    isMandatory: boolean;
    /** Заказ удален? */
    isDeleted: boolean;
    /** Нужно ли создавать задание сдачи документов водителю после завершения заявки? */
    createDocumentAssignment: boolean;
    /** Дополнительные поля */
    extendedProperties?: ExtendedPropertyJsonObject[] | undefined;
    hiredCarCounterparty?: CounterpartyViewModel;
    /** Грузы */
    cargos?: CargoModel[] | undefined;
    /** Точки заказа */
    bidPoints?: DistributionBidPointViewModel[] | undefined;
    /** Настраиваемые опции */
    typeOptions?: TypeOptionModel[] | undefined;
    createdBy?: BidCreatedByViewModel;
    id: number;
}

export interface AcceptExternalDistributionBidModel {
    id: number;
}

export interface DeclineExternalDistributionBidModel {
    id: number;
}

export interface ExternalDistributionBidBatchEditModel {
    ids?: number[] | undefined;
}

export interface ExternalDistributionBidBatchDeclineModel {
    items?: DistributionBidCancelModel[] | undefined;
}

export interface ExternalDistributionBidStatusModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface ExternalDistributionBidStatusModel {
    id: number;
    externalStatusChangedById?: number | undefined;
    logistFullName?: string | undefined;
    logistPhoneNumber?: string | undefined;
    driver?: DriverUserSimpleModel;
    trailer?: TrailerNumberModel;
    car?: CarNumberModel;
    externalStatus: ExternalDistributionBidStatus;
}

export interface ExternalDistributionBidPlanningModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface ExternalDistributionBidPlanningModel {
    id: number;
    /** Точки заказа */
    bidPoints?: DistributionBidPointViewModel[] | undefined;
    car?: CarOptionViewModel;
    /** Выработка заказа (руб/км) (без учета порожнего пробега до первой точки заказа) */
    output: number;
    /** Стоимость */
    price?: number | undefined;
    counterparty?: CounterpartyViewModel;
    /** Время согласования */
    acceptedAt?: string | undefined;
    externalStatus: ExternalDistributionBidStatus;
    source?: DistributionBidSourceViewModel;
}

export interface ExternalDistributionBidInfoModel {
    id: number;
    /** Расстояние до первой точки заказа, в км */
    emptyMileage?: number | undefined;
    /** Стоимость */
    price?: number | undefined;
    /** Стоимость без НДС сверху */
    priceWithoutVatOnTop?: number | undefined;
    /** Идентификатор типа Тип НДС */
    ndsTypeId?: number | undefined;
    /** Идентификатор типа Тип оплаты */
    paymentTypeId?: number | undefined;
    /** НДС сверху стоимости */
    isVatTop?: boolean | undefined;
    firstBidPoint?: DistributionBidPointViewModel;
    lastBidPoint?: DistributionBidPointViewModel;
    /** Расстояние от первой точки заказа до последней, в км */
    distance?: number | undefined;
    counterparty?: CounterpartyPriorityModel;
    /** Идентификатор контрагента */
    counterpartyId?: number | undefined;
    /** Выработка (руб/км) без учета порожнего пробега */
    outputWithoutEmptyMileage?: number | undefined;
    /** Выработка (руб/км) с учетом порожнего пробега */
    outputWithEmptyMileage?: number | undefined;
    /** Идентификатор машины */
    carId?: number | undefined;
    source?: DistributionBidSourceViewModel;
}

export interface DistributionBidSourceModel {
    id: number;
    name?: string | undefined;
    knowledgeBaseUrl?: string | undefined;
}

export interface SourceClearIconModel {
    id: number;
}

export interface DistributionBidSourceViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface DistributionBidSourceDeleteModel {
    id: number;
}

export interface DocumentAssignmentForExternalModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface DocumentAssignmentForExternalModel {
    id: number;
    bidId: number;
    status: DocumentAssignmentStatus;
    envelopeCode?: string | undefined;
    postamatCode?: string | undefined;
    updatedAt: string;
    documentsUploadedAt?: string | undefined;
    documentsApprovedAt?: string | undefined;
    envelopeScannedAt?: string | undefined;
    postamatScannedAt?: string | undefined;
    completedAt?: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
}

export enum DocumentAssignmentFileStatus {
    Uploaded = "Uploaded",
    Approved = "Approved",
    Rejected = "Rejected",
}

export interface DocumentAssignmentFileModel {
    id: number;
    fileId: number;
    documentAssignmentId: number;
    status: DocumentAssignmentFileStatus;
    file?: FileModel;
}

export interface DocumentAssignmentForExternalViewModel {
    documentAssignmentFiles?: DocumentAssignmentFileModel[] | undefined;
    id: number;
    bidId: number;
    status: DocumentAssignmentStatus;
    envelopeCode?: string | undefined;
    postamatCode?: string | undefined;
    updatedAt: string;
    documentsUploadedAt?: string | undefined;
    documentsApprovedAt?: string | undefined;
    envelopeScannedAt?: string | undefined;
    postamatScannedAt?: string | undefined;
    completedAt?: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
}

export interface DocumentAssignmentFilesGetModel {
    documentAssignmentIds?: number[] | undefined;
}

export interface DocumentAssignmentStatusExternalModel {
    id: number;
    status: DocumentAssignmentStatus;
}

export interface DocumentAssignmentFileStatusModel {
    id: number;
    status: DocumentAssignmentFileStatus;
}

export interface DocumentAssignmentWithFileStatusesModel {
    id: number;
    documentAssignmentFiles?: DocumentAssignmentFileStatusModel[] | undefined;
}

export interface DocumentAssignmentForceCompleteModel {
    id: number;
}

export interface DocumentAssignmentDeleteModel {
    id: number;
}

export interface PostamatPointEditModel {
    name?: string | undefined;
    brand?: string | undefined;
    code?: string | undefined;
    geozone?: MapObjectEditModel;
    schedule?: string | undefined;
    id: number;
}

export interface PostamatPointDeleteModel {
    id: number;
}

export interface PostamatPointModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface PostamatPointModel {
    id: number;
    name?: string | undefined;
    brand?: string | undefined;
    code?: string | undefined;
    geozone?: MapObjectModel;
    schedule?: string | undefined;
}

export interface DocumentAssignmentDriverModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface DocumentAssigmentPointViewModel {
    shortAddress?: string | undefined;
}

export interface DocumentAssignmentBidViewModel {
    firstPoint?: DocumentAssigmentPointViewModel;
    lastPoint?: DocumentAssigmentPointViewModel;
}

export interface DocumentAssignmentFileSimpleModel {
    id: number;
    fileId: number;
    documentAssignmentId: number;
    status: DocumentAssignmentFileStatus;
}

export interface DocumentAssignmentDriverModel {
    id: number;
    bidId: number;
    status: DocumentAssignmentStatus;
    envelopeCode?: string | undefined;
    bid?: DocumentAssignmentBidViewModel;
    documentAssignmentFiles?: DocumentAssignmentFileSimpleModel[] | undefined;
}

export interface DocumentAssignmentViewModel {
    id: number;
    bidId: number;
    status: DocumentAssignmentStatus;
    envelopeCode?: string | undefined;
    postamatCode?: string | undefined;
    bid?: DocumentAssignmentBidViewModel;
    documentAssignmentFiles?: DocumentAssignmentFileModel[] | undefined;
}

export interface DocumentAssignmentFilesDeleteModel {
    documentAssignmentId: number;
    documentAssignmentFileIds?: number[] | undefined;
}

export interface DocumentAssignmentEditModel {
    envelopeCode?: string | undefined;
    postamatCode?: string | undefined;
    id: number;
}

export interface ResetDocumentAssignmentModel {
    id: number;
}

/** Simple coordinate model containing X (longitude) and Y (latitude) */
export interface CoordinateModel {
    /** Longitude */
    x: number;
    /** Latitude */
    y: number;
}

export interface CheckPostamatCodeModel {
    code?: string | undefined;
    coordinate?: CoordinateModel;
}

export interface DocumentViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface DocumentViewModel {
    id: number;
    name?: string | undefined;
}

export interface DocumentEditModel {
    name?: string | undefined;
    id: number;
}

export interface DocumentDeleteModel {
    id: number;
}

export interface DocumentRestoreModel {
    id: number;
}

export enum MobileOsType {
    Android = "Android",
    IOS = "iOS",
}

export enum MobileAppType {
    Driver = "Driver",
    Logist = "Logist",
    Director = "Director",
}

export interface MobileDeviceViewModel {
    model?: string | undefined;
    osType: MobileOsType;
    osVersion?: string | undefined;
    appType: MobileAppType;
    appVersion?: string | undefined;
}

export interface DriverEditModel {
    /** Имя */
    firstName: string | undefined;
    /** Фамилия */
    lastName: string | undefined;
    /** Отчество */
    patronymic?: string | undefined;
    /** Номер телефона */
    phoneNumber: string | undefined;
    /** ИНН физического лица */
    inn?: string | undefined;
    /** Удален? */
    isDeleted: boolean;
    /** Комментарий к водителю
Если указать null, то не изменится, но если указать пустую строку - изменится. */
    comment?: string | undefined;
    /** Комментарий о необходимости пересменки
Если указать null, то не изменится, но если указать пустую строку - изменится. */
    needsShiftChangeComment?: string | undefined;
    /** Необходима срочная пересменка */
    needsUrgentShiftChange: boolean;
    /** Внешний ид, изменяется только если передан */
    wialonId?: string | undefined;
    /** Id транспортной колонны */
    transportColumnId?: number | undefined;
    /** Топливные карты */
    fuelCards?: IFuelCardNumber[] | undefined;
    deviceInfo?: MobileDeviceViewModel;
    id: number;
}

export interface DriverRestoreModel {
    id: number;
}

export interface DriverSendSmsModel {
    id: number;
    phoneNumber?: string | undefined;
}

export interface DriverListViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface DriverTransportColumnModel {
    id: number;
    /** Название */
    name?: string | undefined;
}

/** Водитель */
export interface DriverListViewModel {
    id: number;
    user?: UserGetModel;
    /** ИНН физического лица */
    inn?: string | undefined;
    /** Показывает если водитель онлайн */
    isOnline: boolean;
    isDeleted: boolean;
    /** Дата последнего входа в приложение */
    lastSignInAt?: string | undefined;
    /** Отправленно ли сообщение? */
    isSmsSent: boolean;
    /** Комментарий к водителю */
    comment?: string | undefined;
    /** Activity sign */
    isActive: boolean;
    /** Статус мессенджера */
    isMessengerActive: boolean;
    resourceInactivityInfo?: ResourceInactivityInfoJsonObject;
    transportColumn?: DriverTransportColumnModel;
    password?: string | undefined;
}

export interface DriverForSelectModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface DriverForSelectModel {
    id: number;
    fullName?: string | undefined;
    isDeleted: boolean;
}

export interface DriverDeleteModel {
    id: number;
}

export interface DriverEditableListModel {
    ids?: number[] | undefined;
}

export interface DriverChangeResourceActivityModel {
    /** Driver ID */
    driverId: number;
    /** Activity sign */
    isActive: boolean;
    resourceInactivityInfo?: ResourceInactivityInfoJsonObject;
}

export interface DriverControlPointViewModel {
    id: number;
    visitedAt?: string | undefined;
    readonly coordinate?: number[] | undefined;
}

export interface TitleGetModel {
    id: number;
    type: TitleType;
    file?: FileModel;
    status: WaybillTitleStatus;
}

export interface TitleSignatoryModel {
    lastName?: string | undefined;
    firstName?: string | undefined;
    patronymic?: string | undefined;
    position?: string | undefined;
}

export interface GenerateResponseTitleModel {
    waybillId: number;
    titleId: number;
    signatory?: TitleSignatoryModel;
    powerOfAttorneyId?: number | null | undefined;
}

export interface QrCodeGetModel {
    id: number;
    description?: string | undefined;
    file?: FileModel;
}

export interface BidQrCodesModel {
    id: number;
    waybillQrCodes?: { [key: string]: QrCodeGetModel[] } | undefined;
}

export interface TitleStatusApplyModel {
    id: number;
    status: WaybillTitleStatus;
    remarks?: TitleRemarksJsonObject | null | undefined;
}

export interface WaybillTitleStatusApplyModel {
    id: number;
    status: WaybillTitleStatus;
    remarks?: TitleRemarksJsonObject | null | undefined;
}

export interface WaybillStatusApplyModel {
    waybillId: number;
    driverId?: number | null | undefined;
    titles?: WaybillTitleStatusApplyModel[] | undefined;
}

export interface AcceptInviteModel {
    /** Секретный ключ, пришедший на почту */
    key: string | undefined;
    password?: string | undefined;
}

export interface UserSimpleViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface UserSimpleViewModel {
    id: number;
    /** Full name with a user id */
    fullNameWithId?: string | undefined;
    /** Full name or email */
    fullNameOrEmail?: string | undefined;
}

export interface UserSimpleWithRoleViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface UserSimpleWithRoleViewModel {
    id: number;
    /** Full name with a user id */
    fullNameWithId?: string | undefined;
    /** Full name or email */
    fullNameOrEmail?: string | undefined;
}

export interface ExtendedPropertyViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export enum ExtendedPropertyKind {
    Bid = "Bid",
    BidPoint = "BidPoint",
    BidCargo = "BidCargo",
}

export enum SimplifiedTypeCode {
    Integer = "Integer",
    Float = "Float",
    Boolean = "Boolean",
    String = "String",
    DateTime = "DateTime",
}

/** Дополнительное поле для сущности */
export interface ExtendedPropertyViewModel {
    /** Настройки поля */
    readonly intFlags: number;
    /** Настройки поля, которое относится к подсущностям */
    readonly intRelationFlags: number;
    /** Порядок поля */
    order: number;
    version?: string | undefined;
    kind: ExtendedPropertyKind;
    /** Код справочника */
    domainCode?: string | undefined;
    /** Значение по умолчанию */
    defaultValue?: string | undefined;
    /** Идентификатор организации */
    organizationId: number;
    typeCode: SimplifiedTypeCode;
    /** Отображаемое имя */
    displayName?: string | undefined;
    /** Имя дополнительного свойства */
    propertyName?: string | undefined;
    /** Краткое описание поля */
    description?: string | undefined;
    /** Валидационная маска, regex */
    validationRegexMask?: string | undefined;
    isDeleted: boolean;
    id: number;
}

/** Модель для редактирования дополнительного поля для сущности */
export interface ExtendedPropertyEditModel {
    /** Настройки поля */
    intFlags: number;
    kind: ExtendedPropertyKind;
    /** Код справочника */
    domainCode?: string | undefined;
    /** Значение по умолчанию */
    defaultValue?: string | undefined;
    /** Идентификатор организации */
    organizationId: number;
    typeCode: SimplifiedTypeCode;
    /** Отображаемое имя */
    displayName?: string | undefined;
    /** Имя дополнительного свойства */
    propertyName?: string | undefined;
    /** Краткое описание поля */
    description?: string | undefined;
    /** Валидационная маска, regex */
    validationRegexMask?: string | undefined;
    isDeleted: boolean;
    id: number;
}

export interface ExtendedPropertyFlagsModel {
    id: number;
    /** Настройки поля */
    flags: number;
    /** Настройки поля */
    relationFlags: number;
}

/** Модель для удаления дополнительного поля для сущности */
export interface ExtendedPropertyDeleteModel {
    id: number;
}

/** Модель для восстановления дополнительного поля для сущности */
export interface ExtendedPropertyRestoreModel {
    id: number;
}

export interface BidListItemForFactoringModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

/** Counterparty */
export interface CounterpartySimpleModel {
    id: number;
    isForeign?: boolean | undefined;
    /** Наименование */
    name?: string | undefined;
    /** ИНН */
    inn?: string | undefined;
    /** КПП */
    kpp?: string | undefined;
    /** E-mail организации */
    email?: string | undefined;
}

export interface BidPointForwardingModel {
    id: number;
    /** Порядок точки */
    order: number;
    type: BidPointType;
    /** План дата выезда */
    planLeaveDateOffset?: string | undefined;
    /** План дата въезда */
    planEnterDateOffset: string;
    /** Факт дата въезда */
    autoEnteredAtOffset?: string | undefined;
    /** Факт дата выезда */
    autoLeftAtOffset?: string | undefined;
    geozone?: MapObjectModel;
    /** Id часового пояса */
    timezoneId?: string | undefined;
}

export interface BidChatFileModel {
    /** File id */
    fileId: number;
    chatId: number;
    /** Original file name */
    fileName?: string | undefined;
    /** File extension */
    extension?: string | undefined;
    /** Hashsum for a file */
    hashsum?: string | undefined;
    /** Creation date */
    createdAt: string;
    relativePath?: string | undefined;
    /** Direct access link */
    accessUrlLink?: string | undefined;
    isDeleted: boolean;
}

/** Модель для файлов в чате */
export interface BidChatFilesModel {
    /** Id чата */
    chatId: number;
    type: BidChatDomainType;
    /** Файлы из чата */
    files?: BidChatFileModel[] | undefined;
}

export enum CurrencyType {
    RUB = "RUB",
    KZT = "KZT",
    EUR = "EUR",
    USD = "USD",
}

/** Модель для заявок с факторингом */
export interface BidListItemForFactoringModel {
    id: number;
    /** Стоимость */
    price?: number | undefined;
    car?: CarOptionViewModel;
    trailer?: TrailerOptionPreviewModel;
    /** Id организации */
    organizationId: number;
    driver?: DriverViewModel;
    cargoOwnerDictionaryItem?: CounterpartySimpleModel;
    /** Дата создания заявки */
    createdAt: string;
    createdBy?: BidCreatedByViewModel;
    /** Дата старта заявки */
    startedAt?: string | undefined;
    startedBy?: UserShortNameViewModel;
    /** Дата последнего изменения заявки */
    updatedAt: string;
    /** Точки заявки */
    bidPoints?: BidPointForwardingModel[] | undefined;
    /** Грузы заявки */
    cargos?: CargoModel[] | undefined;
    /** Список документов заявки */
    documents?: RelatedDocumentModel[] | undefined;
    /** Чаты с документами */
    chats?: BidChatFilesModel[] | undefined;
    firstBidPoint?: BidPointForwardingModel;
    lastBidPoint?: BidPointForwardingModel;
    currency: CurrencyType;
}

export interface FactoringCompanyModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface FactoringCompanyModel {
    id: number;
    name?: string | undefined;
}

export enum FeatureModuleType {
    None = "None",
    PlanningCarSchedule = "PlanningCarSchedule",
    OverallReportWithVat = "OverallReportWithVat",
    RefuelingPlanning = "RefuelingPlanning",
    AxisLoadMonitoring = "AxisLoadMonitoring",
    Scenarios = "Scenarios",
    CarSensorMonitoring = "CarSensorMonitoring",
    CounterpartiesSolvency = "CounterpartiesSolvency",
    PlanDistanceBetweenPoints = "PlanDistanceBetweenPoints",
    MultipleBidCargos = "MultipleBidCargos",
    BidPointPlanningLeaveDate = "BidPointPlanningLeaveDate",
    HereServices = "HereServices",
    PlanEmptyMileageBid = "PlanEmptyMileageBid",
    TripCoupling = "TripCoupling",
    DriverControlPoints = "DriverControlPoints",
    Wialon = "Wialon",
    TachographEstimationDate = "TachographEstimationDate",
    CarIdlesAtBidPointNotification = "CarIdlesAtBidPointNotification",
    DraftWithoutConstraintOnTheSequenceOfPoints = "DraftWithoutConstraintOnTheSequenceOfPoints",
    BidAverageRateRestriction = "BidAverageRateRestriction",
    Factoring = "Factoring",
    Forwarding = "Forwarding",
    CalculationLogisticSalary = "CalculationLogisticSalary",
    CalculationDriverSalary = "CalculationDriverSalary",
    TemperatureRegime = "TemperatureRegime",
    Payslips = "Payslips",
    ProfitabilityOfBid = "ProfitabilityOfBid",
    DocumentAssignment = "DocumentAssignment",
    DriverEducationResources = "DriverEducationResources",
    BidSalesManager = "BidSalesManager",
    Exploitation = "Exploitation",
    DriverMileageCalculation = "DriverMileageCalculation",
    BidAcceptLatenessNotification = "BidAcceptLatenessNotification",
    Waybills = "Waybills",
    TripScenarios = "TripScenarios",
    Marginality = "Marginality",
    NeuralNetwork = "NeuralNetwork",
    Messenger = "Messenger",
    DriverWorkAndRest = "DriverWorkAndRest",
    PairedCrew = "PairedCrew",
}

export interface FeatureModuleListItemModel {
    id: number;
    type: FeatureModuleType;
    isEnabled: boolean;
}

export interface FixRouteBidListModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export enum FixRouteBidStatus {
    Draft = "Draft",
    New = "New",
    InProgress = "InProgress",
    Completed = "Completed",
    Canceled = "Canceled",
}

export interface FixRouteBidListModel {
    id: number;
    createdAt: string;
    organizationId: number;
    organizationName?: string | undefined;
    driverId: number;
    driverName?: string | undefined;
    bidId: number;
    status: FixRouteBidStatus;
}

export interface OrganizationNameBaseModel {
    id: number;
    name?: string | undefined;
}

export interface FixedAtLocationModel {
    fixedAt: string;
    location?: Point;
}

export interface FixRouteBidChangeLogViewModel {
    fixedAt: string;
    status: FixRouteBidStatus;
    userId: number;
    userName?: string | undefined;
}

export interface FixRouteBidViewModel {
    id: number;
    bidId: number;
    organization?: OrganizationNameBaseModel;
    createdAt: string;
    status: FixRouteBidStatus;
    text?: string | undefined;
    location?: FixedAtLocationModel;
    logs?: FixRouteBidChangeLogViewModel[] | undefined;
    files?: FileModel[] | undefined;
}

export interface FixRouteBidStatusModel {
    id: number;
    status: FixRouteBidStatus;
}

export interface FixRouteBidForDriverListModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface FixRouteBidForDriverListModel {
    id: number;
    createdAt: string;
    status: FixRouteBidStatus;
}

export interface FixRouteBidForDriverViewModel {
    id: number;
    bidId: number;
    createdAt: string;
    status: FixRouteBidStatus;
    text?: string | undefined;
    files?: FileModel[] | undefined;
}

export interface FixRouteBidEditModel {
    bidId: number;
    text?: string | undefined;
    id: number;
}

export interface FixRouteBidPutToWorkModel {
    id: number;
}

export interface CarListItemForForwardingQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface Location {
    estimationTime?: string | undefined;
    planTime?: string | undefined;
    point?: MapObjectModel;
}

export interface FixedAtCoordinate {
    coordinate?: number[] | undefined;
    fixedAt: string;
}

export interface ForwardingUserModel {
    id: number;
    phoneNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    patronymic?: string | undefined;
    roleDisplayName?: string | undefined;
    role: BidRole;
}

export interface CarListItemForForwarding {
    id: number;
    trailerId?: number | undefined;
    driverId?: number | undefined;
    organizationId: number;
    trailerTypeId?: number | undefined;
    number?: string | undefined;
    location?: Location;
    carLocation?: FixedAtCoordinate;
    bidUsers?: ForwardingUserModel[] | undefined;
}

export interface BidOutputInfoModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface TrailerTypeIdModel {
    id: number;
    /** Тип прицепа */
    typeId?: number | undefined;
}

export interface MapObjectLocationModel {
    id: number;
    /** Город */
    city?: string | undefined;
    /** Деревня/поселок */
    village?: string | undefined;
    /** Область */
    state?: string | undefined;
    /** Округ/регион */
    county?: string | undefined;
    /** Полный, точный адрес */
    address?: string | undefined;
    location?: Point;
}

export interface BidPointPlanDistanceModel {
    id: number;
    geozone?: MapObjectLocationModel;
}

/** Превью организации */
export interface OrganizationIdNamePreviewModel {
    id: number;
    /** Название */
    name?: string | undefined;
    currency: CurrencyType;
}

export interface BidOutputInfoModel {
    id: number;
    /** ВАЛ */
    price?: number | undefined;
    trailer?: TrailerTypeIdModel;
    /** Точки загрузки/выгрузки */
    bidPoints?: BidPointPlanDistanceModel[] | undefined;
    organization?: OrganizationIdNamePreviewModel;
}

export interface OrganizationIdModel {
    id: number;
    organizationId: number;
}

export enum FuelCardType {
    NoCard = "NoCard",
    Gazpromneft = "Gazpromneft",
    AzimuthGazpromneft = "AzimuthGazpromneft",
    AzimuthTatneft = "AzimuthTatneft",
    AzimuthRosneft = "AzimuthRosneft",
    AzimuthLukoil = "AzimuthLukoil",
    AzimuthSmart = "AzimuthSmart",
    Rosneft = "Rosneft",
    Tatneft = "Tatneft",
    RusPetrol = "RusPetrol",
}

export interface FuelCardEditModel {
    /** Номер карты */
    number?: string | undefined;
    type: FuelCardType;
    /** Без управления лимитами? */
    hasNoLimitManagement: boolean;
    /** Идентификатор машины */
    carId?: number | undefined;
    /** Идентификатор водителя */
    driverId?: number | undefined;
    id: number;
}

export interface FuelCardIdModel {
    id: number;
}

export interface DriverUserFullNameViewModel {
    id: number;
    fullName?: string | undefined;
}

export interface FuelCardGetModel {
    /** Номер карты */
    number?: string | undefined;
    type: FuelCardType;
    /** Без управления лимитами? */
    hasNoLimitManagement: boolean;
    driver?: DriverUserFullNameViewModel;
    car?: CarNumberModel;
    id: number;
}

export interface FuelCardNumberModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface FuelCardNumberModel {
    id: number;
    number?: string | undefined;
}

export interface DriverFuelCardsEditModel {
    /** Идентификатор водителя */
    driverId: number;
    /** Идентификаторы топливных карт */
    cardIds?: number[] | undefined;
}

export interface CarFuelCardsEditModel {
    /** Идентификатор машины */
    carId: number;
    /** Идентификаторы топливных карт */
    cardIds?: number[] | undefined;
}

export interface CarFuelCardListModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CarFuelCardListModel {
    /** Номер карты */
    number?: string | undefined;
    type: FuelCardType;
    /** Без управления лимитами? */
    hasNoLimitManagement: boolean;
    /** Дата создания */
    createdAt: string;
    /** Дата изменения */
    updatedAt: string;
    car?: CarNumberModel;
    id: number;
}

export interface CarFuelCardsListModel {
    car?: CarNumberModel;
    /** Привязанные к машине карты */
    cards?: CarFuelCardListModel[] | undefined;
}

export interface DriverFuelCardListModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface DriverFullNameViewModel {
    id: number;
    fullName?: string | undefined;
}

export interface DriverFuelCardListModel {
    /** Номер карты */
    number?: string | undefined;
    type: FuelCardType;
    /** Без управления лимитами? */
    hasNoLimitManagement: boolean;
    /** Дата создания */
    createdAt: string;
    /** Дата изменения */
    updatedAt: string;
    driver?: DriverFullNameViewModel;
    id: number;
}

export interface DriverFuelCardsListModel {
    driver?: DriverFullNameViewModel;
    /** Привязанные к водителю топливные карты */
    cards?: DriverFuelCardListModel[] | undefined;
}

export interface FuelCardListModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface FuelCardListModel {
    /** Номер карты */
    number?: string | undefined;
    type: FuelCardType;
    /** Без управления лимитами? */
    hasNoLimitManagement: boolean;
    /** Дата создания */
    createdAt: string;
    /** Дата изменения */
    updatedAt: string;
    car?: CarNumberModel;
    driver?: DriverFullNameViewModel;
    id: number;
}

export enum GasStationSource {
    Test = "Test",
    Vink = "Vink",
}

export enum SecurityRuleSet {
    None = "None",
    Level1 = "Level1",
    Level2 = "Level2",
}

export interface RawQueryOptions {
    readonly filter?: string | undefined;
    readonly orderBy?: string | undefined;
    readonly top?: string | undefined;
    readonly skip?: string | undefined;
    readonly count?: string | undefined;
    readonly format?: string | undefined;
    readonly skipToken?: string | undefined;
    readonly deltaToken?: string | undefined;
}

export interface GasStationModelQueryOptions {}

export enum GasStationType {
    Unknown = "Unknown",
    Tatneft = "Tatneft",
    Gazpromneft = "Gazpromneft",
    Rosneft = "Rosneft",
}

export enum RoadSide {
    Left = "Left",
    Right = "Right",
    LeftRight = "LeftRight",
}

export interface GasStationPumpJsonObject {
    price: number;
    fuelName?: string | undefined;
}

export interface GasStationModel {
    id: number;
    isFullTankOnly: boolean;
    type: GasStationType;
    requiredRefuelSide?: RoadSide;
    side: RoadSide;
    source: GasStationSource;
    name?: string | undefined;
    externalId?: string | undefined;
    mapObject?: MapObjectModel;
    pumps?: GasStationPumpJsonObject[] | undefined;
}

export enum TileType {
    DoubleGisPaid = "DoubleGisPaid",
    DoubleGis = "DoubleGis",
    Osm = "Osm",
}

export interface TileOptions {
    subdomains?: string | undefined;
}

export interface TileUrlModel {
    title?: string | undefined;
    type: TileType;
    url?: string | undefined;
    options?: TileOptions;
}

export enum TechSupportChatType {
    Chatra = "Chatra",
    Bitrix = "Bitrix",
    CarrotQuest = "CarrotQuest",
}

/** Первичные настройки для страницы */
export interface InitialPageSettingsModel {
    /** Адреса для получения тайлов осм */
    tileUrls?: TileUrlModel[] | undefined;
    /** Версия приложения (каждые последующие 4 бита - major, minor, build, revision) */
    version: number;
    displayVersion?: string | undefined;
    location?: Point;
    techSupportChatType: TechSupportChatType;
}

export interface ChangePasswordModel {
    password?: string | undefined;
    passwordConfirmation?: string | undefined;
    key?: string | undefined;
}

export interface LegalPersonEditModel {
    name?: string | undefined;
    inn?: string | undefined;
    id: number;
}

export interface LegalPersonViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface LegalPersonDeleteModel {
    id: number;
}

export interface SetMainLegalPersonModel {
    id: number;
}

export interface SalaryCostOptionModel {
    id: number;
    /** Средняя стоимость топлива, руб/л */
    averageFuelCost?: number | undefined;
    /** ЗП и команд. водителям, руб./км */
    driverSalaryAndTravelAllowance?: number | undefined;
    /** Норма топлива (в среднем по праку), л/100 км */
    fuelRate?: number | undefined;
    /** Средняя стоимость ремонта, руб./км */
    averageRepairCost?: number | undefined;
    /** Средняя стоимость ОСАГО, руб./мес */
    averageOsagoCost?: number | undefined;
    /** Средняя стоимость страховки груза, руб./мес */
    averageCargoInsuranceCost?: number | undefined;
    /** Итого лизинг, развитие, прочее (руб./авто) */
    totalLeaseCostByCars?: number | undefined;
}

export interface SalaryBaseValueModel {
    id: number;
    /** План (руб./авто) */
    plan?: number | undefined;
    /** Оклад (руб./авто) */
    salary?: number | undefined;
    /** Базовые % для индивидуальных премий от маржи */
    percentageOfMargin?: number | undefined;
    /** Базовый размер командной премии */
    teamPrize?: number | undefined;
    /** Идентификатор логиста */
    logistId: number;
}

export interface LogisticSalaryOptionsModel {
    /** Отчетный период */
    period: string;
    salaryCostOption?: SalaryCostOptionModel;
    /** Базовые значения для расчета */
    baseValues?: SalaryBaseValueModel[] | undefined;
}

export interface LogistTaskSettingEditModel {
    id: number;
    notificationType: NotificationType;
    bidRole?: BidRole;
    commentRequired: boolean;
    isActive: boolean;
}

export interface LogistTaskSettingsEditModel {
    settings?: LogistTaskSettingEditModel[] | undefined;
}

export interface LogistTaskListModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export enum LogistTaskStatus {
    New = "New",
    Viewed = "Viewed",
    Completed = "Completed",
    Canceled = "Canceled",
    Failed = "Failed",
}

export interface LogistTaskListModel {
    id: number;
    name?: string | undefined;
    bidId: number;
    userName?: string | undefined;
    createdAt: string;
    completedAt?: string | undefined;
    status: LogistTaskStatus;
}

export interface UserFullNameAndPhoneModel {
    id: number;
    /** Полное ФИО */
    fullName?: string | undefined;
    /** Номер телефона */
    phoneNumber?: string | undefined;
}

export interface DriverFullNameAndPhoneModel {
    id: number;
    user?: UserFullNameAndPhoneModel;
}

export interface BidPointPlanDatesAndGeozoneModel {
    id: number;
    geozone?: MapObjectViewModel;
    /** Плановая дата загрузки/выгрузки, вычисленная по плановой локальной дате, учитывая часовой пояс точки. */
    planEnterDateOffset: string;
    /** Плановая дата выезда. Если модуль планирования включен, вычисляется как плановая дата въезда + X часов. */
    planLeaveDateOffset?: string | undefined;
    /** Вторая плановая дата загрузки/выгрузки, вычисленная по плановой локальной дате, учитывая часовой пояс точки. */
    secondaryPlanEnterDateOffset?: string | undefined;
}

export interface LogistTaskViewModel {
    id: number;
    bidId: number;
    userId: number;
    car?: CarNumberModel;
    driver?: DriverFullNameAndPhoneModel;
    trailer?: TrailerNumberModel;
    firstBidPoint?: BidPointPlanDatesAndGeozoneModel;
    lastBidPoint?: BidPointPlanDatesAndGeozoneModel;
    name?: string | undefined;
    createdAt: string;
    completedAt?: string | undefined;
    status: LogistTaskStatus;
    commentRequired: boolean;
    comment?: string | undefined;
}

export interface SetLogistTaskAsViewedModel {
    id: number;
}

export interface LogistTaskCompletionModel {
    id: number;
    comment?: string | undefined;
}

export interface LogistTasksStatisticsModel {
    totalCount: number;
    completedCount: number;
    failedCount: number;
    yesterdayNewCount: number;
    yesterdayCompletedCount: number;
    averageDuration: string;
    completionPercent: number;
}

export interface LastCarLocationModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CarMapViewModel {
    /** ID машины. */
    id?: number | undefined;
    /** Номер машины. */
    number?: string | undefined;
}

export interface LastCarLocationModel {
    fixedAt?: string | undefined;
    location?: Point;
    status?: CarStatus;
    car?: CarMapViewModel;
}

export interface LastTrackerWithDriverCarModel {
    bidId?: number | undefined;
    driver?: DriverUserMapViewModel;
    fixedAt?: string | undefined;
    location?: Point;
    status?: CarStatus;
    car?: CarMapViewModel;
}

/** Contains car map locations */
export interface CarMapLocationsModel {
    lastCarLocation?: LastTrackerWithDriverCarModel;
    estimatedCarLocation?: CoordinateModel;
    /** Estimated At */
    estimatedAt?: string | undefined;
}

export interface WorldSubjectModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export enum WorldSubjectType {
    Unknown = "Unknown",
    Village = "Village",
    City = "City",
    County = "County",
    FederalDistrict = "FederalDistrict",
}

/** World subject */
export interface WorldSubjectModel {
    id: number;
    /** Имя */
    name?: string | undefined;
    /** Область, регион */
    state?: string | undefined;
    /** Тэги для поиска */
    tags?: string | undefined;
    type: WorldSubjectType;
}

export enum RegionType {
    Unknown = "Unknown",
    Country = "Country",
    FederalDistrict = "FederalDistrict",
    FederalSubject = "FederalSubject",
}

export interface RegionListViewModel {
    id: number;
    /** Название региона */
    name?: string | undefined;
    type: RegionType;
    /** Есть ли потомки */
    hasChildren: boolean;
}

export interface RegionListViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface RegionOrSubjectResultModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface RegionOrSubjectResultModel {
    id: number;
    name?: string | undefined;
    isRegion: boolean;
}

export interface GetInfrastructureObjectsModel {
    northEast?: Point;
    southWest?: Point;
    /** Уровень приближения */
    resolution: number;
}

export enum InfrastructureObjectType {
    Plato = "Plato",
    Camera = "Camera",
    Azs = "Azs",
    WC = "WC",
    Loundary = "Loundary",
    Wrecker = "Wrecker",
    RoadPatrolService = "RoadPatrolService",
    Shop = "Shop",
    Radar = "Radar",
    Motel = "Motel",
    TechnicalStation = "TechnicalStation",
    Cafe = "Cafe",
    TireFitting = "TireFitting",
    Water = "Water",
    TrafficAccident = "TrafficAccident",
}

export interface InfrastructureObjectModel {
    name?: string | undefined;
    location?: Point;
    type: InfrastructureObjectType;
    additionalInfo?: any | undefined;
    clusters?: Clusters | undefined;
}

/** Segment point model */
export interface SegmentItemPointModel {
    /** Map object point id, can be null */
    id?: number | undefined;
    /** Full readable address */
    address?: string | undefined;
    location: Point;
    type: MapObjectType;
}

export interface GetRouteBetweenPointsModel {
    routeOptions?: RouteOptions;
    mapObjectFrom?: SegmentItemPointModel;
    mapObjectTo?: SegmentItemPointModel;
}

/** Route step geometry */
export interface RouteStepGeometry {
    /** Type */
    type?: string | undefined;
    /** Coordinates */
    coordinates?: number[][] | undefined;
}

export interface InstructionModel {
    distance: number;
    heading?: number | undefined;
    sign: number;
    interval?: number[] | undefined;
    text?: string | undefined;
    time: number;
    street_name?: string | undefined;
    exit_number?: number | undefined;
    exited?: boolean | undefined;
    turn_angle?: number | undefined;
    last_heading?: number | undefined;
}

export interface DetailsModel {
    max_speed?: number[] | undefined;
    average_speed?: number[] | undefined;
}

export interface WaypointServiceModel {
    point?: number[] | undefined;
}

/** The toll segment info structure. */
export interface TollSegmentServiceModel {
    /** Gets or sets the track name value. */
    trackName?: string | undefined;
    /** Gets or sets the toll tag value. */
    tag?: string | undefined;
    /** Gets or sets the 2D points of segment vertices. */
    points?: number[][] | undefined;
    /** Gets or sets the distance in meters. */
    distance: number;
    /** Gets or sets the cost value. */
    cost: number;
    /** Gets or sets the waypoints array. */
    waypoints?: WaypointServiceModel[] | undefined;
    startIndex: number;
    endIndex: number;
    waypointIndexes?: number[] | undefined;
}

/** The toll segments info structure. */
export interface TollSegmentsInfoServiceModel {
    /** Gets or sets the toll segments. */
    segments?: TollSegmentServiceModel[] | undefined;
}

/** Service route */
export interface ServiceRoute {
    /** Distance in meters */
    distance: number;
    /** Duration in seconds */
    duration: number;
    geometry?: RouteStepGeometry;
    /** Instructions (navigation, etc) */
    instructions?: InstructionModel[] | undefined;
    details?: DetailsModel;
    profile?: RouterProfile;
    tollSegmentsInfo?: TollSegmentsInfoServiceModel;
}

export enum RouterType {
    OSRM = "OSRM",
    GraphHopper = "GraphHopper",
    Yatrs = "Yatrs",
    Here = "Here",
}

/** Router service response object */
export interface RouteServiceResponse {
    /** Ключ, по которому был произведён поиск маршрута */
    coordinateKey?: string | undefined;
    /** Подходящие маршруты */
    routes?: ServiceRoute[] | undefined;
    /** Статус ответа */
    code?: string | undefined;
    readonly isCorrect: boolean;
    readonly isEmpty: boolean;
    /** In meters */
    firstCoordinateDifference: number;
    /** In meters */
    lastCoordinateDifference: number;
    routerType: RouterType;
}

export interface GetAddressInfoYandexMapModel {
    latitude: number;
    longitude: number;
}

/** Returns OSM address info */
export interface GetAddressInfoModel {
    /** Latitude */
    latitude: number;
    /** Longitude */
    longitude: number;
}

/** Model used to lookup Here.Api address info */
export interface GetAddressInfoHereApiModel {
    /** Latitude */
    latitude: number;
    /** Longitude */
    longitude: number;
}

export interface GetYandexMapAddressesInfoModel {
    /** Address, partial address, for an autocomplete. */
    address?: string | undefined;
    count?: number | undefined;
}

/** Collection of address suggestions */
export interface AddressSuggestionsModel {
    /** Suggestions */
    suggestions?: AddressViewModel[] | undefined;
}

/** Model used to lookup location by id in Here.Api */
export interface GetHereApiLocationByIdModel {
    /** Location id */
    locationId?: string | undefined;
}

/** A model used to lookup for osm addresses */
export interface GetOsmAddressesInfoModel {
    /** Address, partial address, for an autocomplete. */
    address?: string | undefined;
    /** Amount of results */
    count?: number | undefined;
    /** Lookup key */
    readonly key?: string | undefined;
}

/** Used to retrieve multiple addresses info by a text */
export interface GetAddressesInfoModel {
    /** Address, partial address, for an autocomplete. */
    address?: string | undefined;
    /** Amount of results */
    count?: number | undefined;
}

export interface TrackerLogViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface TrackerLogViewModel {
    trackerId: number;
    location?: CoordinateModel;
    fixedAt: string;
}

export interface TrackerLogsViewModel {
    trackerLogs?: TrackerLogViewModel[] | undefined;
    distance: number;
}

export interface MechanicNameModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export enum MessageMediaType {
    Text = "Text",
    File = "File",
    Voice = "Voice",
}

export enum UserMessageType {
    User = "User",
    System = "System",
    LifeCycle = "LifeCycle",
    Deviation = "Deviation",
    FuelPlanning = "FuelPlanning",
    PointVisiting = "PointVisiting",
    LoadLateness = "LoadLateness",
    ServicePoints = "ServicePoints",
    Waybills = "Waybills",
}

/** Used to send a text message. */
export interface SendTextMessageModel {
    /** A text message */
    text?: string | undefined;
    /** A chat id. Can be null if it's a new chat */
    chatId?: number | undefined;
    /** A recipient id. Can be null but must be set if chatId is null */
    recipientId?: number | undefined;
    /** A message id. Can be null. Set only if editing */
    messageId?: number | undefined;
}

export interface UserChatMessageModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface UserChatModel {
    id: number;
    fullName?: string | undefined;
}

export interface UserChatMessageModel {
    id: number;
    /** Текст */
    text?: string | undefined;
    /** Дата написания */
    createdAt: string;
    chatId: number;
    createdById?: number | undefined;
    fileId?: number | undefined;
    file?: FileModel;
    createdBy?: UserChatModel;
    isDeleted: boolean;
    recipientId: number;
    recipient?: UserChatModel;
    messageId: number;
    type: UserMessageType;
}

export interface ChatMessageGetModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export enum UserMessageFlag {
    None = "None",
    Mentioned = "Mentioned",
}

export interface RecipientInfoModel {
    id: number;
    fullName?: string | undefined;
    bidRoles?: string[] | undefined;
    isIntegrationAccount: boolean;
}

export interface UserMessageInfoModel {
    id: number;
    createdAt: string;
    readAt?: string | undefined;
    isRead: boolean;
    isDeleted: boolean;
    flags: UserMessageFlag;
    recipient?: RecipientInfoModel;
}

export interface ChatMessageGetModel {
    id: number;
    /** Текст */
    text?: string | undefined;
    /** Дата написания */
    createdAt: string;
    chatId: number;
    createdById?: number | undefined;
    fileId?: number | undefined;
    file?: FileModel;
    createdBy?: UserChatModel;
    isDeleted: boolean;
    userMessagesInfo?: UserMessageInfoModel[] | undefined;
}

/** Organization participant in chat model */
export interface ChatParticipantModel {
    id: number;
    inn?: string | undefined;
    kpp?: string | undefined;
    ogrn?: string | undefined;
    bank?: string | undefined;
    ks?: string | undefined;
    rs?: string | undefined;
    address?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    imageUrl?: string | undefined;
    /** Organization participating users */
    userIds?: number[] | undefined;
}

export interface AddUserToChatModel {
    /** Идентификатор добавляемого пользователя */
    userId: number;
    /** Идентификатор чата */
    chatId: number;
}

export interface AddChatToFavoritesModel {
    /** Идентификатор чата */
    chatId: number;
}

export interface RemoveChatFromFavoritesModel {
    /** Идентификатор чата */
    chatId: number;
}

export interface LeaveChatModel {
    /** Идентификатор чата */
    chatId: number;
}

export interface DeleteUserFromChatModel {
    /** Идентификатор удаляемого пользователя */
    userId: number;
    /** Идентификатор чата */
    chatId: number;
}

export interface DeleteChatMessageModel {
    id: number;
    chatId: number;
}

export interface ChatMessageRestoreModel {
    id: number;
    chatId: number;
}

export interface MobileAppRatingListModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export enum Rating {
    None = "None",
    Good = "Good",
    Bad = "Bad",
}

export interface MobileAppRatingListModel {
    id: number;
    driverId: number;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    organizationId: number;
    organizationName?: string | undefined;
    host?: string | undefined;
    createdAt: string;
    rating: Rating;
    comment?: string | undefined;
}

export interface MobileAppRatingEditModel {
    rating: Rating;
    comment?: string | undefined;
}

export interface MobileAppRatingSyncModel {
    driverId: number;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    organizationId: number;
    organizationName?: string | undefined;
    host?: string | undefined;
    createdAt: string;
    rating: Rating;
    comment?: string | undefined;
}

export interface MobileTrackerLogModel {
    point?: CoordinateModel;
    /** Fixed at date, utc */
    fixedAt: string;
}

export interface ReceiveMobileTrackerLogModel {
    /** Модельки координат */
    models?: MobileTrackerLogModel[] | undefined;
}

export interface MobileVersionEditModel {
    id: number;
    version?: string | undefined;
    urls?: string[] | undefined;
}

export interface MobileVersionViewModel {
    id: number;
    version?: string | undefined;
    url?: string | undefined;
    organizationName?: string | undefined;
}

export interface NewsItemEditModel {
    header?: string | undefined;
    text?: string | undefined;
    fileIds?: number[] | undefined;
    id: number;
}

export interface NewsItemDeleteModel {
    id: number;
}

export interface NewsItemCreatedByModel {
    id: number;
    shortName?: string | undefined;
}

export interface NewsItemViewModel {
    header?: string | undefined;
    isNewForUser: boolean;
    createdBy?: NewsItemCreatedByModel;
    createdAt: string;
    updatedAt: string;
    text?: string | undefined;
    files?: FileModel[] | undefined;
    id: number;
}

export interface NewsItemModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface NewsItemModel {
    header?: string | undefined;
    isNewForUser: boolean;
    createdBy?: NewsItemCreatedByModel;
    createdAt: string;
    updatedAt: string;
    id: number;
}

export interface ChatLastMessageModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

/** Used for chat view model */
export interface ChatGetModel {
    type?: ChatType;
    /** Chat description */
    description?: string | undefined;
    isFavorite: boolean;
    id: number;
}

/** Собеседник */
export interface InterlocutorModel {
    name?: string | undefined;
    imageUrl?: string | undefined;
}

/** Новое сообщение в чате */
export interface ChatLastMessageModel {
    id: number;
    /** Текст, превью */
    text?: string | undefined;
    /** Количество непрочитанных сообщений */
    unreadMessagesCount: number;
    /** Дата нового сообщения */
    lastMessageDate: string;
    chat?: ChatGetModel;
    interlocutor?: InterlocutorModel;
}

export interface SetMessagesAsReadModel {
    /** Если значение не задано, то все сообщения в текущем чате будут помечены прочитанными. */
    messageId?: number | undefined;
    /** Идентификатор чата, если значение не задано, то все сообщения в чатах будут помечены прочитанными. */
    chatId?: number | undefined;
    chatType: ChatType;
}

export interface SetMessageAsUnreadModel {
    /** Идентификатор сообщения */
    messageId: number;
    /** Идентификатор чата */
    chatId: number;
}

export interface OrganizationStartedDateModel {
    startedAt: string;
}

export interface OrganizationActivityTargetModel {
    id: number;
    countOfCars: number;
    averageMileage: number;
    averageBidPrice: number;
    outputPerKm: number;
    outputPerHour: number;
    emptyMileageRate: number;
    averageDowntime: string;
}

export interface InviteUserModel {
    /** Email */
    email?: string | undefined;
    /** Номер телефона */
    phoneNumber?: string | undefined;
}

export interface RemoveUserInviteModel {
    /** Идентификатор пользователя */
    userId: number;
}

export interface UserSimpleModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export enum UserState {
    Valid = "Valid",
    Banned = "Banned",
    Invited = "Invited",
}

export enum Role {
    Root = "Root",
    Admin = "Admin",
    Driver = "Driver",
    Guest = "Guest",
    TechSupport = "TechSupport",
    Diagnostics = "Diagnostics",
    TruckingOrganizationAdmin = "TruckingOrganizationAdmin",
    TruckingOrganizationManager = "TruckingOrganizationManager",
    TruckingOrganizationHeadLogist = "TruckingOrganizationHeadLogist",
    TruckingOrganizationOperator = "TruckingOrganizationOperator",
    TruckingOrganizationViewer = "TruckingOrganizationViewer",
    TruckingOrganizationDispatcher = "TruckingOrganizationDispatcher",
    TruckingOrganizationExtendedViewer = "TruckingOrganizationExtendedViewer",
    CargoOwnerAdmin = "CargoOwnerAdmin",
    CargoOwnerManager = "CargoOwnerManager",
    ForwarderAdmin = "ForwarderAdmin",
    ForwarderManager = "ForwarderManager",
    DataAdmin = "DataAdmin",
    IntegrationAccount = "IntegrationAccount",
    IntegrationManager = "IntegrationManager",
    AccountManager = "AccountManager",
    WaybillIntegrationAccount = "WaybillIntegrationAccount",
    ManagementSystem = "ManagementSystem",
}

export interface UserSimpleModel {
    id: number;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberExtension?: string | undefined;
    fullName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    patronymic?: string | undefined;
    state: UserState;
    isDeleted: boolean;
    roleTypes?: Role[] | undefined;
}

/** Модель для установки роли пользователя */
export interface AddUserRoleModel {
    /** Id пользователя */
    userId: number;
    role: Role;
}

/** Модель для удаления роли пользователя */
export interface RemoveUserRoleModel {
    /** Id пользователя */
    userId: number;
    role: Role;
}

export interface SetUserStateByIdModel {
    /** Идентификатор пользователя */
    userId: number;
}

export interface CarLogistSimpleModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface CarLogistSimpleModel {
    id: number;
    email?: string | undefined;
    fullName?: string | undefined;
    carsCount: number;
}

export interface CarLogistModel {
    id: number;
    email?: string | undefined;
    fullName?: string | undefined;
    cars?: CarNumberViewModel[] | undefined;
    readonly carsCount: number;
}

export interface UserAddModel {
    password: string | undefined;
    sendLoginData: boolean;
    /** Email */
    email: string | undefined;
    /** Имя */
    firstName: string | undefined;
    /** Фамилия */
    lastName: string | undefined;
    /** Отчество */
    patronymic?: string | undefined;
    /** Номер телефона */
    phoneNumber?: string | undefined;
    /** Добавочный номер телефона */
    phoneNumberExtension?: string | undefined;
    lastSignInAt?: string | undefined;
    connectionState: ConnectionState;
    id: number;
}

export interface OrganizationFeatureModuleSwitchModel {
    organizationId: number;
    featureModuleId: number;
    isActive: boolean;
}

/** Planning feature module settings. */
export interface PlanningScheduleSettingsModel {
    /** Кол-во часов на поездку (0-24 часа) */
    workHours: number;
    /** Средняя скорость машины (км/ч) */
    averageSpeed: number;
    /** Максимальное время загрузки/выгрузки */
    maxLoadUnloadPeriod: number;
    /** Время нахождения в точках в порожних заявках (часов) */
    emptyMileagePointStayPeriod?: string | undefined;
    /** Кол-во заявок, которые можно запланировать. */
    maxPlannedBidsCount: number;
    /** Начало дня */
    dayStart: string;
    /** Радиус подбора заказов (км) */
    matchingDistributionBidsRadius: number;
    /** Рекомендуемое рабочее время */
    recommendedWorkTime: string;
    /** Рекомендуемое время отдыха */
    recommendedRestTime: string;
    /** Рекомендуемое время перерыва */
    recommendedBreakTime: string;
    /** Использовать текущее местоположение машины при создании порожних заявок */
    useLastCarLocationForEmptyMileageBid: boolean;
}

export interface WialonSettingsModel {
    authHost?: string | undefined;
    apiHost?: string | undefined;
    login?: string | undefined;
    password?: string | undefined;
    token?: string | undefined;
    tokenExpiresIn: string;
}

export interface WialonSettingsEditModel {
    authHost?: string | undefined;
    apiHost?: string | undefined;
    login?: string | undefined;
    password?: string | undefined;
}

export enum BidRefuelingServiceType {
    None = "None",
    MultiGo = "MultiGo",
    Delkon = "Delkon",
    Str = "Str",
    MultiGo2 = "MultiGo2",
    SolarFrps = "SolarFrps",
}

export interface RefuelingPlanningSettingsSolarFrpsModel {
    baseUrl?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    isFuelLimitEnabled: boolean;
    filterByFuelCardType: boolean;
    updatingPeriod?: number | undefined;
}

export interface FuelLimitSettingsModel {
    /** Диапазон актуальных показателей ДУТ при открытии топливного лимита (мин) */
    actualLiquidDataRange: number;
}

/** Refueling planning feature module settings */
export interface RefuelingPlanningSettingsModel {
    refuelingServiceType: BidRefuelingServiceType;
    solarFrps?: RefuelingPlanningSettingsSolarFrpsModel;
    fuelLimitSettings?: FuelLimitSettingsModel;
    carIds?: number[] | undefined;
}

/** Axis load monitoring settings for its module */
export interface AxisLoadMonitoringSettingsModel {
    /** Default car axis load */
    carDefaultAxisLoad: number;
    /** Default trailer axis load */
    trailerDefaultAxisLoad: number;
    /** Cargo default weight (tonnage) */
    cargoDefaultWeight: number;
}

export interface DriverControlPointsSettingsModel {
    /** Время проверки посещения */
    checkVisitingTime: string;
    /** Время проверки успеваемости */
    checkLatenessTime: string;
    /** Плановый дневной пробег (км) */
    planDailyMileage: number;
    /** Типы маршрутных точек для уменьшения пробега на смену */
    customPointTypeIds?: number[] | undefined;
    /** Значение уменьшения пробега (км) */
    maxMileageAfterCustomPoint: number;
}

export interface OrganizationFeatureModuleGetModel {
    featureModuleId: number;
    featureModuleName?: string | undefined;
    featureModuleType: FeatureModuleType;
    isActive: boolean;
}

export interface DriverEducationResourceModel {
    /** Название обучающего ресурса */
    name?: string | undefined;
    /** Ссылка на обучающий ресурс */
    link?: string | undefined;
}

export interface DriverEducationResourceSettingsModel {
    resources?: DriverEducationResourceModel[] | undefined;
}

/** Exploitation approving settings */
export interface ExploitationApprovingSettingsModel {
    /** Consider current location */
    considerCurrentLocation: boolean;
}

/** Cargorun exploitation feature module settings */
export interface ExploitationSettingsModel {
    /** Api key */
    apiKey?: string | undefined;
    approvingSettings?: ExploitationApprovingSettingsModel;
}

export enum WaybillProviderType {
    ProviderEmulator = "ProviderEmulator",
    Astral = "Astral",
    Kontur = "Kontur",
}

/** Waybills feature module settings */
export interface WaybillSettingsModel {
    /** Users that has access to Waybills functionality */
    userIds?: number[] | undefined;
    /** Data provider */
    providerType: WaybillProviderType;
}

export interface EBillSettingsModel extends WaybillSettingsModel {}

export interface OrganizationWaybillBidMatchingSettingEditModel {
    useCreateDate: boolean;
    useCounterparty?: boolean | undefined;
    createDateMatchingPeriodInHours: number;
    allowedStatuses: BidStatus[];
}

export interface OrganizationWaybillLoadPointMatchingSettingEditModel {
    usePlanEnterDate: boolean;
    planEnterDateMatchingPeriodInHours: number;
    useLocation: boolean;
    matchingRadius: number;
}

export interface OrganizationWaybillUnloadPointMatchingSettingEditModel {
    useCounterparty: boolean;
    useLocation: boolean;
    matchingRadius: number;
}

export interface OrganizationWaybillMatchingSettingEditModel {
    disableMatching: boolean;
    useShippingOrderNumber: boolean;
    bid: OrganizationWaybillBidMatchingSettingEditModel;
    loadPoint: OrganizationWaybillLoadPointMatchingSettingEditModel;
    unloadPoint: OrganizationWaybillUnloadPointMatchingSettingEditModel;
}

export interface WaybillMatchingSettingsPeriodViewModel {
    from: string;
    to: string;
}

export interface WaybillLoadPointMatchingSettingViewModel {
    counterpartyIds?: number[] | undefined;
    matchingRadius?: number | undefined;
    coordinates?: number[] | undefined;
    loadDate?: string | undefined;
    planEnterDatePeriod?: WaybillMatchingSettingsPeriodViewModel | undefined;
}

export interface WaybillUnloadPointMatchingSettingViewModel {
    counterpartyIds?: number[] | undefined;
    matchingRadius?: number | undefined;
    coordinates?: number[] | undefined;
}

export interface WaybillBidMatchingSettingsViewModel {
    organizationId: number;
    carId: number;
    useShippingOrderNumber: boolean;
    shippingOrderNumber?: string | undefined;
    driverByLicenseOrInn: boolean;
    driverIds?: number[] | undefined;
    allowedBidStatuses?: BidStatus[] | undefined;
    createDatePeriod?: WaybillMatchingSettingsPeriodViewModel | undefined;
    loadPoint?: WaybillLoadPointMatchingSettingViewModel | undefined;
    unloadPoint?: WaybillUnloadPointMatchingSettingViewModel | undefined;
    excludedBidIds?: number[] | undefined;
}

export interface WaybillMatchedCarSnapshotViewModel {
    id: number;
    number?: string | undefined;
}

export interface WaybillMatchedDriverSnapshotViewModel {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    patronymic?: string | undefined;
    phoneNumber?: string | undefined;
    inn?: string | undefined;
    driverLicenseSeries?: string | undefined;
    driverLicenseNumber?: string | undefined;
}

export interface WaybillMatchedCounterpartySnapshotViewModel {
    id: number;
    inn?: string | undefined;
    kpp?: string | undefined;
    name?: string | undefined;
}

export interface WaybillMatchedBidPointSnapshotViewModel {
    counterparty?: WaybillMatchedCounterpartySnapshotViewModel | undefined;
    coordinates?: number[] | undefined;
    timezoneId?: string | undefined;
    planEnterDateOffset?: string | undefined;
}

export interface WaybillMatchedBidSnapshotViewModel {
    id: number;
    distributionBidId?: number | undefined;
    car?: WaybillMatchedCarSnapshotViewModel | undefined;
    driver?: WaybillMatchedDriverSnapshotViewModel | undefined;
    counterparty?: WaybillMatchedCounterpartySnapshotViewModel | undefined;
    status?: BidStatus | undefined;
    createdAt?: string | undefined;
    loadPoint?: WaybillMatchedBidPointSnapshotViewModel | undefined;
    unloadPoint?: WaybillMatchedBidPointSnapshotViewModel | undefined;
    settings?: WaybillBidMatchingSettingsViewModel | undefined;
}

export interface WaybillBidMatchingLogViewModel {
    id: number;
    waybillId: number;
    bidId?: number | null | undefined;
    updatedById?: number | null | undefined;
    updatedBy?: UserDisplayNameModel | null | undefined;
    bid?: WaybillMatchedBidSnapshotViewModel | null | undefined;
    createdAt: string;
}

export type WaybillMatchingLogModel = WaybillBidMatchingLogViewModel;
export type WaybillMatchedBidSnapshotModel = WaybillMatchedBidSnapshotViewModel;

/** Trip scenarios feature module settings */
export interface TripScenariosSettingsModel {
    buttonName?: string | undefined;
}

/** Neural network module settings */
export interface NeuralNetworkSettingsModel {
    /** Unload point search radius, km */
    searchRadius: number;
    /** Start delay, hours */
    startDelay: number;
    /** Lower border to accept new point, % */
    minPercentage: number;
}

export enum MessengerType {
    WhatsApp = "WhatsApp",
    Telegram = "Telegram",
}

/** Messenger message sending settings */
export interface MessengerSettingsModel {
    type: MessengerType;
}

export enum OrganizationFlags {
    None = "None",
    CanCreateBids = "CanCreateBids",
    NoAccessToEditBooks = "NoAccessToEditBooks",
    HasCompoundCargos = "HasCompoundCargos",
    AnalyzeOverallReportByHourlyMileage = "AnalyzeOverallReportByHourlyMileage",
    AdminHasAccessToDriverPasswords = "AdminHasAccessToDriverPasswords",
    UseCargorunRouterOnly = "UseCargorunRouterOnly",
    ParallelItemChangePoints = "ParallelItemChangePoints",
    AdminCanDownloadDriverList = "AdminCanDownloadDriverList",
    IsDocumentReceivingMandatory = "IsDocumentReceivingMandatory",
    AutoSetMainContract = "AutoSetMainContract",
    DisplayLateAndIdleTimeInReport = "DisplayLateAndIdleTimeInReport",
    AllowManualNeuralNetworkUsage = "AllowManualNeuralNetworkUsage",
}

export enum BooksEditPermissionsFlag {
    None = "None",
    HasAccessToEditCars = "HasAccessToEditCars",
    HasAccessToEditDrivers = "HasAccessToEditDrivers",
    HasAccessToEditTrailers = "HasAccessToEditTrailers",
    HasAccessToEditCounterparties = "HasAccessToEditCounterparties",
    HasAccessToEditLegalPersons = "HasAccessToEditLegalPersons",
    AllowEverything = "AllowEverything",
}

export interface OrganizationDemoPeriod {
    daysRemaining: number;
    status: number | string;
    hasDocument: boolean;
    lastNotifiedAt?: string | undefined;
    isDemoPeriodExpiring: boolean;
}

export interface OrganizationProfileModel {
    inn?: string | undefined;
    kpp?: string | undefined;
    ogrn?: string | undefined;
    bank?: string | undefined;
    ks?: string | undefined;
    rs?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    site?: string | undefined;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    location?: Point;
    flags: OrganizationFlags;
    booksEditPermissionsFlags: BooksEditPermissionsFlag;
    readonly intBooksEditPermissionsFlags: number;
    readonly intFlags: number;
    currency: CurrencyType;
    imageUrl?: string | undefined;
    timezoneId?: string | undefined;
    isDriverGeozoneControlEnabled: boolean;
    readonly noAccessToEditBooks: boolean;
    /** Закрытый период включен/выключен */
    closedPeriodIsEnabled: boolean;
    /** День месяца закрытого периода (от 1 до 28) */
    closedPeriodDay?: number | undefined;
    /** Критический пробег */
    criticalMileage: number;
    /** Использует ли организация систему согласования заявок? */
    usesBidsApproval: boolean;
    /** Время игнорирования посещения точки заявки (в минутах) */
    bidPointVisitIgnoreDuration: number;
    /** Радиус геозоны по умолчанию (м) */
    geozoneRadius: number;
    /** Не обновлять план заправок до АЗС (в км.) */
    suppressRefuelingUpdateRadius: number;
    /** Корректировка периода нахождения в геозоне (мин) */
    driverAtPointOffset: number;
    /** Желаемая выработка за машину (руб/км) */
    wantedOutput?: number | undefined;
    /** Минимальное время нахождения на точке перецепки/пересменки */
    minimumBidItemChangePointDuration: string;
    /** Минимальная длительность остановки для отчета по простоям машин */
    minimumCarStopDuration: string;
    /** Минимальное время нахождения на заправке */
    minimumRefuelingDuration: number;
    /** Не запускать заявку в работу без успешной синхронизации */
    startBidWithSuccessSync: boolean;
    /** Не синхронизировать с ВИС порожнюю заявку */
    startEmptyMileageBidWithoutSync: boolean;
    registrationStatus?: {} | undefined;
    refuelingServiceType: BidRefuelingServiceType;
    routerType: RouterType;
    /** При положительном значении отображать плановую дату выезда в мобильном приложении */
    displayPlanLeaveDate: boolean;
    /** При положительном значении включается ограничение на ввод веса в тоннах */
    weightLimit: boolean;
    maxPlanMileageDeviation: number;
    pinCode?: string | undefined;
    /** При положительном значении мобильное приложение отправит координаты */
    sendMobileAppCoordinates: boolean;
    /** Кастомный номер тех поддержки */
    techSupportNumber?: string | undefined;
    /** Промежуток времени отправки пакета координат в секундах */
    sendCoordinatesGap: number;
    /** Интервал фиксирования координат в секундах в секундах */
    saveCoordinatesInterval: number;
    /** Запрет на загрузку фото из галереи */
    onlyNewPhotos: boolean;
    id: number;
    createdAt?: string | undefined;
    demoPeriod?: OrganizationDemoPeriod | undefined;
    adminId?: number | undefined;
    useTrailerMileage?: boolean | undefined;
    externalIdSources?: ExternalIdSource[] | undefined;
}

export enum DriverChatInitalizeType {
    AllBidParticipants = "AllBidParticipants",
    LogistAndDriver = "LogistAndDriver",
}

export interface DriverChatSettingsModel {
    id: number;
    driverChatInitalizeType: DriverChatInitalizeType;
}

export interface OrganizationEditFinancialPartModel {
    id: number;
    /** ИНН, КПП */
    inn?: string | undefined;
    kpp?: string | undefined;
    /** ОГРН */
    ogrn?: string | undefined;
    /** Банк */
    bank?: string | undefined;
    /** КС */
    ks?: string | undefined;
    /** РС */
    rs?: string | undefined;
}

export interface OrganizationEditInformationPartModel {
    id: number;
    /** Наименование */
    name: string | undefined;
    /** Email */
    email: string | undefined;
    /** Сайт */
    site?: string | undefined;
    /** Номер телефона */
    phoneNumber: string | undefined;
    /** Адрес */
    address?: string | undefined;
    location?: Point;
    /** Часовой пояс, Iana формат (например Europe/Moscow) */
    timezoneId?: string | undefined;
    isDriverGeozoneControlEnabled: boolean;
    /** Не запускать заявку в работу без успешной синхронизации */
    startBidWithSuccessSync: boolean;
    /** Не синхронизировать с ВИС порожнюю заявку */
    startEmptyMileageBidWithoutSync: boolean;
    /** Закрытый период включен/выключен */
    closedPeriodIsEnabled: boolean;
    /** День месяца закрытого периода (от 1 до 28) */
    closedPeriodDay?: number | undefined;
    /** Критический пробег */
    criticalMileage?: number | undefined;
    /** Использует организация согласование заявок? */
    usesBidsApproval: boolean;
    /** Время игнорирования посещения точки заявки (в минутах) */
    bidPointVisitIgnoreDuration?: number | undefined;
    /** Радиус геозоны по умолчанию (м) */
    geozoneRadius?: number | undefined;
    /** Корректировка периода нахождения в геозоне (мин) */
    driverAtPointOffset?: number | undefined;
    /** Желаемая выработка за машину (руб/км) */
    wantedOutput?: number | undefined;
    /** Минимальная длительность остановки для отчета по простоям машин */
    minimumCarStopDuration: string;
    /** Минимальная длительность посещения в точке перецепки/пересменки */
    minimumBidItemChangePointDuration: string;
    /** Минимальное время нахождения на заправке */
    minimumRefuelingDuration: number;
    /** Не обновлять план заправок до АЗС (в км.) */
    suppressRefuelingUpdateRadius: number;
    /** При положительном значении отображать плановую дату выезда в мобильном приложении */
    displayPlanLeaveDate: boolean;
    /** При положительном значении включается ограничение на ввод веса в тоннах */
    weightLimit: boolean;
    /** Максимально допустимый процент отклонения фактического пробега от планового */
    maxPlanMileageDeviation: number;
    /** При положительном значении мобильное приложение отправит координаты */
    sendMobileAppCoordinates: boolean;
    /** Кастомный номер тех поддержки */
    techSupportNumber?: string | undefined;
    /** Промежуток времени отправки пакета координат в секундах */
    sendCoordinatesGap: number;
    /** Интервал фиксирования координат в секундах */
    saveCoordinatesInterval: number;
    /** Запретить загрузку фото из галереи */
    onlyNewPhotos: boolean;
}

export interface OrganizationEditCurrencyPartModel {
    id: number;
    currency: CurrencyType;
}

export interface OrganizationCurrencyModel {
    id: number;
    name?: string | undefined;
    sign: string;
}

/** Profitability of bid feature module settings. */
export interface ProfitabilityOfBidSettingsModel {
    /** Средний расход топлива (литр/100км) */
    averageFuelConsumption: number;
    /** Средняя стоимость литра (руб.) */
    averageFuelCostPerLiter: number;
    /** Стоимость 1 дня работы (руб.) */
    costOfOneDay: number;
    /** Коэффициент преобразования часов в дни */
    hoursToDaysConvertasionsRate: number;
}

export interface OrganizationRegionModel {
    id: number;
    /** Fuel consumption (liters/100km) */
    fuelConsumption: number;
    /** Minimum fuel volume level, in liters */
    minimumFuelTankVolume: number;
}

export interface OrganizationRegionSettingsModel {
    id: number;
    /** Preferred gas stations (flags) */
    readonly intPreferredGasStations: number;
    preferredGasStations: GasStationType;
    refuelingServiceType: BidRefuelingServiceType;
    /** Region settings */
    regions?: OrganizationRegionModel[] | undefined;
}

export interface ReportExecutionTimeModel {
    id: number;
    executionTime: string;
}

export interface OrganizationReportExecutionModel {
    /** Элементы настройки выполнения отчетов для организации */
    executionTimes?: ReportExecutionTimeModel[] | undefined;
}

export interface OrganizationDefaultRouteOptionsModel {
    routerType: RouterType;
    /** Не строить маршрут по платным дорогам */
    avoidTollRoadFlags: number;
    avoidSpecialRoadFlags: number;
    disallowToll: boolean;
    disallowTollExceptM4: boolean;
    disallowTollExceptM12DRT: boolean;
    /** Разрешить паромы, false - паромы запрещены */
    allowFerry: boolean;
    /** Получать платные дороги */
    calcTolls: boolean;
    /** Использовать индивидуальную учетную запись */
    useIndividualAccount: boolean;
    /** Api ключ */
    apiKey?: string | undefined;
    country?: RouterCountryType;
    routerProfile: RouterProfile;
    readonly useCargorunRouterOnly: boolean;
}

/** Driver contact model. */
export interface DriverContactModel {
    /** Название контакта */
    name?: string | undefined;
    /** Опция "Не отображать" контакт */
    isHidden: boolean;
}

/** Driver contact list settings. */
export interface DriverContactListSettingsModel {
    logist?: DriverContactModel;
    bidCreator?: DriverContactModel;
    responsibleForBid?: DriverContactModel;
    salesManager?: DriverContactModel;
}

/** Модель для редактирования контакта организации */
export interface OrganizationContactEditModel {
    id: number;
    /** Наименование контакта */
    name?: string | undefined;
    /** ФИО */
    fullName?: string | undefined;
    /** Номер телефона */
    phoneNumber?: string | undefined;
    /** Булевая настройка "Скрыть в приложении" */
    isHidden: boolean;
}

/** Модель для редактирования контактов организации */
export interface OrganizationContactsEditModel {
    /** Список контактов */
    contacts?: OrganizationContactEditModel[] | undefined;
}

/** Bid cars planning report settings. */
export interface BidCarsPlanningSettingsModel {
    /** Допустимое расстояние от последней точки заявки, для свободной машины (км) */
    allowableDistanceFromLastBidPoint?: number | undefined;
}

export interface OrganizationRecommendationDeleteModel {
    id: number;
    organizationId: number;
}

export interface OrganizationRecommendationListModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface OrganizationRecommendationListModel {
    id: number;
    organizationId: number;
    organizationName?: string | undefined;
    file?: FileModel;
    userDisplayName?: string | undefined;
    month: string;
    updatedAt: string;
}

export interface OrganizationRecommendationUserModel {
    id: number;
    month: string;
    file?: FileModel;
}

/** Validation result for validators */
export interface ValidationApiResult {
    isOk: boolean;
    errorMessage?: string | undefined;
}

export interface DeletePayslipMessageModel {
    id: number;
    driverId: number;
}

export interface UserDisplayNameModel {
    id: number;
    /** Email or a full name */
    displayName?: string | undefined;
}

export interface FuelTankJsonObject {
    fuelConsumption: number;
    totalVolume: number;
    currentVolume: number;
    minimumVolume: number;
    maximumVolumeToVisitStation: number;
    minimumVolumeInFinishDesired?: number | undefined;
    type: FuelTankType;
}

export interface RefuelingResourceJsonObject {
    iconUrl?: string | undefined;
}

export interface FuelCardJsonObject {
    number?: string | undefined;
    brand?: string | undefined;
    code?: string | undefined;
    iconUrl?: string | undefined;
    type?: FuelCardType;
    hasCardsConflict: boolean;
}

export interface BidPlannedRefuelingViewModel {
    id: number;
    /** Стоимость */
    price: number;
    /** Стоимость со скидкой */
    priceWithDiscount?: number | undefined;
    /** Порядок заправки */
    order: number;
    /** Расстояние до заправки от первой точки маршрута */
    distanceFromStart: number;
    /** Расстояние до заправки от точки машины */
    destinationDistance: number;
    /** Сколько топлива необходимо заправить, в литрах */
    requiredLoadVolume: number;
    /** Плановый объем топлива перед заправкой, в литрах */
    planVolumeBeforeRefueling: number;
    /** Плановый объем топлива после заправки, в литрах */
    planVolumeAfterRefueling: number;
    /** Фактический объем топлива перед заправкой, в литрах */
    factVolumeBeforeRefueling?: number | undefined;
    /** Фактический объем топлива после заправки, в литрах */
    factVolumeAfterRefueling?: number | undefined;
    /** Наименование топлива */
    fuelName?: string | undefined;
    /** Наименование, бренд */
    name?: string | undefined;
    /** Enter date, automatic, utc */
    autoEnteredAt?: string | undefined;
    /** Leave date, automatic, utc */
    autoLeftAt?: string | undefined;
    gasStationType: GasStationType;
    mapObject?: MapObjectModel;
    resource?: RefuelingResourceJsonObject;
    /** Топливные карточки */
    fuelCards?: FuelCardJsonObject[] | undefined;
    /** Сколько заправился, в литрах */
    readonly factLoadVolume?: number | undefined;
}

export interface BidQueuedPlanRefuelingsViewModel {
    fuelTanks?: FuelTankJsonObject[] | undefined;
    plannedRefuelings?: BidPlannedRefuelingViewModel[] | undefined;
}

/** Fuel tank model */
export interface BidQueuedPlanRefuelingFuelTankModel {
    id: number;
    /** Current volume */
    currentVolume?: number | undefined;
    /** Total volume */
    totalVolume: number;
    /** Fuel consumption (liters/100km) */
    fuelConsumption: number;
    /** Minimum fuel volume level, in liters */
    minimumVolume: number;
    /** Maximum fuel volume to visit gas station (using by STR) */
    maximumVolumeToVisitStation: number;
    /** Minimum desired fuel volume in finish */
    minimumVolumeInFinishDesired?: number | undefined;
    type: FuelTankType;
}

export interface BidToRefuelQueueApiModel {
    id: number;
    bidId: number;
    externalId?: string | undefined;
    location?: FixedAtLocationPoco;
    fuelTanks?: BidQueuedPlanRefuelingFuelTankModel[] | undefined;
}

export interface EditRefuelingContext {
    id: number;
    bidId: number;
    requiredLoadVolume: number;
    readonly unitType?: string | undefined;
    readonly options?: number | undefined;
    readonly instanceId: number;
    readonly compoundKey?: string | undefined;
    state?: any | undefined;
}

export interface DeleteRefuelingContext {
    id: number;
    bidId: number;
    readonly unitType?: string | undefined;
    readonly options?: number | undefined;
    readonly instanceId: number;
    readonly compoundKey?: string | undefined;
    state?: any | undefined;
}

export interface BidDeletePlannedRefuelingsModel {
    bidId: number;
}

export interface BidPlannedRefuelingForDriverModel {
    id: number;
    /** Порядок заправки */
    order: number;
    /** Расстояние до заправки от первой точки маршрута */
    distanceFromStart: number;
    /** Расстояние до заправки от точки машины */
    destinationDistance: number;
    /** Сколько топлива необходимо заправить, в литрах */
    requiredLoadVolume: number;
    /** Плановый объем топлива перед заправкой, в литрах */
    planVolumeBeforeRefueling: number;
    /** Плановый объем топлива после заправки, в литрах */
    planVolumeAfterRefueling: number;
    /** Фактический объем топлива перед заправкой, в литрах */
    factVolumeBeforeRefueling?: number | undefined;
    /** Фактический объем топлива после заправки, в литрах */
    factVolumeAfterRefueling?: number | undefined;
    /** Наименование топлива */
    fuelName?: string | undefined;
    /** Наименование, бренд */
    name?: string | undefined;
    /** Enter date, automatic, utc */
    autoEnteredAt?: string | undefined;
    /** Leave date, automatic, utc */
    autoLeftAt?: string | undefined;
    gasStationType: GasStationType;
    mapObject?: MapObjectModel;
    resource?: RefuelingResourceJsonObject;
    /** Топливные карточки */
    fuelCards?: FuelCardJsonObject[] | undefined;
    /** Сколько заправился, в литрах */
    readonly factLoadVolume?: number | undefined;
    canReportProblem: boolean;
}

export interface BidQueuedPlanRefuelingsForDriverModel {
    /** Запланированные заправки по заявке */
    plannedRefuelings?: BidPlannedRefuelingForDriverModel[] | undefined;
}

export interface DriverAppUsageForExploitationModel {
    driverId: number;
    driverDisplayName?: string | undefined;
    averagePercent: number;
    isAppInstalled: boolean;
}

export interface DriverWorkAndRestReportShiftModel {
    carNumber?: string | undefined;
    carLogistDisplayName?: string | undefined;
    workStartedAt: string;
    workEndedAt?: string | undefined;
    workTime?: string | undefined;
    restStartedAt?: string | undefined;
    restEndedAt?: string | undefined;
    restTime?: string | undefined;
    breakTime?: string | undefined;
}

export interface DriverWorkAndRestReportModel {
    driverId: number;
    driverFullName?: string | undefined;
    averageWorkTime: string;
    averageRestTime: string;
    averageBreakTime: string;
    shifts?: DriverWorkAndRestReportShiftModel[] | undefined;
}

export interface ReportModel {
    id?: string | undefined;
    name?: string | undefined;
}

export enum ReportColumnAggregateType {
    None = "None",
    Sum = "Sum",
    Average = "Average",
    Other = "Other",
}

export enum ReportCellType {
    Default = "Default",
    Numeric = "Numeric",
    NumericPercent = "NumericPercent",
    DateTime = "DateTime",
    TimeSpan = "TimeSpan",
    TimeSpanPlusMinus = "TimeSpanPlusMinus",
    StringArray = "StringArray",
}

export interface ReportColumnTypeInfo {
    index?: number | undefined;
    label?: string | undefined;
    propertyName?: string | undefined;
    clrType?: string | undefined;
    ignoreInGroup: boolean;
    isSubGroup: boolean;
    isSubModel: boolean;
    aggregateType?: ReportColumnAggregateType;
    cellType?: ReportCellType;
    isAdditionalColumn: boolean;
    isEntityId: boolean;
    metadata?: { [key: string]: any } | undefined;
    isFooterData: boolean;
}

export interface ReportMetadataModel {
    readonly data?: any[] | undefined;
    footer?: { [key: string]: any } | undefined;
    generatedAt?: string | undefined;
    isDynamic: boolean;
    columns?: ReportColumnTypeInfo[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
}

export interface GenerateReportModel {
    parametersQuery?: string | undefined;
    filterQuery?: string | undefined;
    generateFile: boolean;
}

export interface VehicleStatisticsModel {
    all: number;
    inShift: number;
    inServiceWork: number;
    accidentStatus: number;
    readonly withoutDriver: number;
}

export interface TrailerStatisticsModel {
    accidentStatus: number;
}

export interface ExploitationStatisticsModel {
    vehicles?: VehicleStatisticsModel;
    trailers?: TrailerStatisticsModel;
    fixedAt: string;
}

export interface CarRouteForExternalModel {
    /** Пройденный маршрут от точки 0 до точки А (координаты + время фиксации) */
    emptyMileageRoute?: TraveledRouteFixedAtPartModel[] | undefined;
    /** Пройденный маршрут от точки А до конца маршрута (координаты + время фиксации) */
    mainRoute?: TraveledRouteFixedAtPartModel[] | undefined;
    /** Идентификатор машины */
    carId: number;
    /** Номер машины */
    carNumber?: string | undefined;
    /** У заявки есть активный пробег (заехала в первую точку по заявке) */
    hasActiveMileage: boolean;
    /** Данная часть маршрута построена из мобильных координат */
    isMobile: boolean;
}

export interface SegmentItemModel {
    /** Может быть несколько путей от осрм, индекс указывает на тот, который был выбран пользователем */
    routeIndex: number;
    /** Порядок сегмента */
    order: number;
    mapObjectFrom?: SegmentItemPointModel;
    mapObjectTo?: SegmentItemPointModel;
}

export interface BidRouteEditModel {
    /** Идентификатор заявки */
    bidId: number;
    /** Сегменты, если пустой массив, то будут использованы точки заявки автоматически */
    segmentsKeys?: SegmentItemModel[] | undefined;
    routeOptions?: RouteOptions;
    id: number;
}

export interface DistributionRouteEditModel {
    distributionBidId: number;
    /** Сегменты, если пустой массив, то будут использованы точки заявки автоматически */
    segmentsKeys?: SegmentItemModel[] | undefined;
    routeOptions?: RouteOptions;
    id: number;
}

export interface RouteDeleteModel {
    /** Идентификатор заявки */
    bidId: number;
    id: number;
}

export interface DistributionRouteDeleteModel {
    /** Идентификатор заказа */
    distributionBidId: number;
    id: number;
}

export interface MapObjectIndexModel {
    index: number;
    type: MapObjectType;
    duration: number;
    distance: number;
}

export interface RoutePointsWithInstructionsModel {
    /** Instructions */
    segmentInstructions?: InstructionModel[] | undefined;
    /** Details */
    details?: DetailsModel[] | undefined;
    /** Route coordinate points */
    points?: number[][] | undefined;
    /** Control points (explicit route points) */
    controlPoints?: MapObjectIndexModel[] | undefined;
}

export interface RouteTemplateEditModel {
    id: number;
    /** Идентификатор заявки */
    bidId?: number | undefined;
    name?: string | undefined;
}

export interface RouteTemplateDeleteModel {
    id: number;
}

export interface ScenarioExternalDataJsonModel {
    propertyName?: string | undefined;
}

export interface ScenarioEditModel {
    /** Название */
    name: string | undefined;
    /** Описание */
    description?: string | undefined;
    /** Начальный вопрос */
    startQuestionId?: number | undefined;
    externalData?: ScenarioExternalDataJsonModel;
    id: number;
}

export interface ScenarioListViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface ScenarioListViewModel {
    id: number;
    /** Наименование сценария */
    name?: string | undefined;
    /** Описание сценария */
    description?: string | undefined;
    /** Начальный вопрос */
    startQuestionId?: number | undefined;
    externalData?: ScenarioExternalDataJsonModel;
}

export interface ScenarioDeleteModel {
    id: number;
}

export interface ScenarioRestoreModel {
    id: number;
}

export enum ScenarioQuestionType {
    SelectOne = "SelectOne",
    SelectMultiple = "SelectMultiple",
    Instruction = "Instruction",
    Value = "Value",
}

export enum ScenarioAnswerValueType {
    String = "String",
    Integer = "Integer",
    Double = "Double",
    DateTime = "DateTime",
    File = "File",
    TimeSpan = "TimeSpan",
    Date = "Date",
}

export interface ScenarioQuestionEditModel {
    id: number;
    /** Текст */
    text: string | undefined;
    /** Сценарий */
    scenarioId: number;
    questionType: ScenarioQuestionType;
    answerValueType?: ScenarioAnswerValueType;
    /** Следующий вопрос */
    nextQuestionId?: number | undefined;
    /** Минимальное значение */
    minValueCondition?: number | undefined;
    /** Максимальное значение */
    maxValueCondition?: number | undefined;
    externalData?: ScenarioExternalDataJsonModel;
    /** Запретить загрузку фото из галереи */
    onlyNewPhotos: boolean;
}

export interface ScenarioQuestionDeleteModel {
    id: number;
}

export interface ScenarioQuestionListViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface ScenarioQuestionListViewModel {
    id: number;
    /** Текст */
    text: string | undefined;
    /** Сценарий */
    scenarioId: number;
    questionType: ScenarioQuestionType;
    answerValueType?: ScenarioAnswerValueType;
    /** Следующий вопрос */
    nextQuestionId?: number | undefined;
    /** Минимальное значение */
    minValueCondition?: number | undefined;
    /** Максимальное значение */
    maxValueCondition?: number | undefined;
    /** Запретить загрузку фото из галереи */
    onlyNewPhotos: boolean;
    externalData?: ScenarioExternalDataJsonModel;
}

export interface ScenarioAnswerOptionEditModel {
    id: number;
    /** Текущий вопрос */
    questionId: number;
    /** Текст варианта ответа */
    text: string | undefined;
    /** Следующий вопрос */
    nextQuestionId?: number | undefined;
    /** Порядковый номер */
    order: number;
    externalData?: ScenarioExternalDataJsonModel;
}

export interface ScenarioAnswerOptionDeleteModel {
    id: number;
}

export interface ScenarioAnswerOptionViewModel {
    text?: string | undefined;
    nextQuestionId?: number | undefined;
    order: number;
    questionId: number;
    id: number;
    externalData?: ScenarioExternalDataJsonModel;
}

export interface ScenarioDriverAnswerViewModel {
    updatedAt: string;
    value?: string | undefined;
    selectedAnswerOptions?: number[] | undefined;
    files?: FileModel[] | undefined;
}

export interface ScenarioQuestionViewModel {
    text?: string | undefined;
    questionType: ScenarioQuestionType;
    answerValueType?: ScenarioAnswerValueType;
    nextQuestionId?: number | undefined;
    minValueCondition?: number | undefined;
    maxValueCondition?: number | undefined;
    answerOptions?: ScenarioAnswerOptionViewModel[] | undefined;
    scenarioId: number;
    answer?: ScenarioDriverAnswerViewModel;
    id: number;
    externalData?: ScenarioExternalDataJsonModel;
    onlyNewPhotos: boolean;
}

export interface ScenarioWholeModel {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    updatedAt: string;
    startQuestionId?: number | undefined;
    questions?: ScenarioQuestionViewModel[] | undefined;
    externalData?: ScenarioExternalDataJsonModel;
    hasDriverAnswers: boolean;
}

export interface ScenarioQuestionLogistViewModel {
    text?: string | undefined;
    questionType: ScenarioQuestionType;
    answerValueType?: ScenarioAnswerValueType;
    nextQuestionId?: number | undefined;
    minValueCondition?: number | undefined;
    maxValueCondition?: number | undefined;
    answerOptions?: ScenarioAnswerOptionViewModel[] | undefined;
    scenarioId: number;
    answer?: ScenarioDriverAnswerViewModel;
    logistAnswer?: ScenarioDriverAnswerViewModel;
    id: number;
    externalData?: ScenarioExternalDataJsonModel;
    onlyNewPhotos: boolean;
}

export interface ScenarioLogistViewModel {
    name?: string | undefined;
    description?: string | undefined;
    updatedAt: string;
    startQuestionId?: number | undefined;
    questions?: ScenarioQuestionLogistViewModel[] | undefined;
    id: number;
    externalData?: ScenarioExternalDataJsonModel;
}

export interface BidPointLogistScenarioModel {
    bidPointId: number;
    isScenarioCompleted: boolean;
    scenario?: ScenarioLogistViewModel;
}

export interface ScenarioDriverAnswerApplyModel {
    id: number;
    questionId: number;
    bidPointId: number;
    value?: string | undefined;
    selectedAnswerOptionIds?: number[] | undefined;
}

export interface ScenarioLogistAnswersApplyModel {
    driverAnswers?: ScenarioDriverAnswerApplyModel[] | undefined;
}

export interface ScenarioLogistFileDeleteModel {
    questionId: number;
    bidPointId: number;
    fileId: number;
}

export interface ScenarioViewModel {
    name?: string | undefined;
    description?: string | undefined;
    updatedAt: string;
    startQuestionId?: number | undefined;
    questions?: ScenarioQuestionViewModel[] | undefined;
    id: number;
    externalData?: ScenarioExternalDataJsonModel;
}

export interface BidPointScenarioModel {
    bidPointId: number;
    scenario?: ScenarioViewModel;
}

export interface ScenarioDriverAnswersApplyModel {
    driverAnswers?: ScenarioDriverAnswerApplyModel[] | undefined;
}

export interface ScenarioDriverFileDeleteModel {
    questionId: number;
    bidPointId: number;
    fileId: number;
}

export interface ScenarioCompleteModel {
    bidPointId: number;
}

export interface ClientStatisticsForBitrixModel {
    /** Имя организации */
    organizationName?: string | undefined;
    /** Выработка, руб/час */
    outputPerHour: number;
    /** % использования приложения водителями */
    driverAppUsageAveragePercent: number;
    /** % своевременного заведения заявок */
    bidsCreatedOnTimePercent: number;
}

export interface DriverStatsListModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface DriverStatCardListModel {
    id: number;
    number: number;
    fixedAt: string;
    isShared: boolean;
    isSynced: boolean;
}

export interface DriverStatsListModel {
    id: number;
    driverId: number;
    fullName?: string | undefined;
    host?: string | undefined;
    mileage: number;
    mileageRating: number;
    bidCount: number;
    bidsRating: number;
    topCities?: { [key: string]: number } | undefined;
    bidOnTimeCount: number;
    bidsOnTimeRating: number;
    appUsagePercent: number;
    appUsageRating: number;
    cards?: DriverStatCardListModel[] | undefined;
}

export interface CollectStatsModel {
    key?: string | undefined;
    year?: number | undefined;
}

export interface DriverStatsSyncModel {
    driverId: number;
    fullName?: string | undefined;
    host?: string | undefined;
    mileage: number;
    bidCount: number;
    topCities?: { [key: string]: number } | undefined;
    bidOnTimeCount: number;
    appUsagePercent: number;
}

export interface DriverRatingsSyncModel {
    driverId: number;
    mileageRating: number;
    bidsRating: number;
    bidsOnTimeRating: number;
    appUsageRating: number;
}

export interface DriverCardSyncModel {
    driverId: number;
    host?: string | undefined;
    number: number;
    fixedAt: string;
    isShared: boolean;
}

export interface DriverStatsOfYearViewModel {
    id: number;
    mileage: number;
    mileageRating: number;
    bidCount: number;
    bidsRating: number;
    topCities?: { [key: string]: number } | undefined;
    bidOnTimeCount: number;
    bidsOnTimeRating: number;
    appUsagePercent: number;
    appUsageRating: number;
}

export interface SetDriverStatCardAsViewedModel {
    statsId: number;
    number: number;
    fixedAt: string;
}

export interface SetDriverStatCardAsSharedModel {
    statsId: number;
    number: number;
}

export enum SyncEntityType {
    Bid = "Bid",
    DistributionBid = "DistributionBid",
}

export interface AddSyncEntityStatusModel {
    /** Идентификатор сущности в Cargorun */
    entityId: number;
    entityType: SyncEntityType;
    /** Версия данных */
    version?: string | undefined;
    syncStatus: SyncEntityStatus;
    /** Комментарий */
    comment?: string | undefined;
    /** Дата фиксации изменения статуса синхронизации */
    fixedAt: string;
    /** Внешний идентификатор сущности */
    externalId?: string | undefined;
}

export interface LastSyncStatusModel {
    /** Дата фиксации изменения статуса синхронизации во внешней системе */
    fixedAt: string;
    /** Дата фиксации изменения статуса синхронизации в Cargorun */
    createdAt: string;
    syncStatus: SyncEntityStatus;
    /** Комментарий */
    comment?: string | undefined;
}

export enum SyncSystemBehavior {
    Read = "Read",
    ReadConfirmation = "ReadConfirmation",
}

export enum SyncSystemTrackingType {
    NoTracking = "NoTracking",
    AllChanges = "AllChanges",
    Forwarding = "Forwarding",
}

/** Модель для редактирования данных ВИС */
export interface SyncSystemModel {
    id: number;
    /** Прикрепленный пользователь для синхронизации */
    userId: number;
    /** Отображаемое имя прикрепленного пользователя для синхронизации */
    userDisplayName?: string | undefined;
    /** Ключ ВИС */
    key?: string | undefined;
    behavior: SyncSystemBehavior;
    trackingType: SyncSystemTrackingType;
}

export enum QueuedApiTaskAction {
    Write = "Write",
    Read = "Read",
    ReadConfirmation = "ReadConfirmation",
    ReadQuery = "ReadQuery",
    Delete = "Delete",
}

export enum QueuedApiTaskModelType {
    Default = "Default",
    BidSharedInfoForForwardingModel = "BidSharedInfoForForwardingModel",
}

export enum QueuedApiTaskSyncStatus {
    Info = "Info",
    Warn = "Warn",
    Error = "Error",
}

export interface QueuedApiTaskObjectStatusJson {
    message?: string | undefined;
    type: QueuedApiTaskSyncStatus;
}

export enum InternalEntityType {
    Bid = "Bid",
    DistributionBid = "DistributionBid",
    Car = "Car",
    Trailer = "Trailer",
    Driver = "Driver",
    Counterparty = "Counterparty",
}

/** Модель объекта задания со статусом */
export interface QueuedApiTaskObjectAddModel {
    modelType: QueuedApiTaskModelType;
    status?: QueuedApiTaskObjectStatusJson;
    /** Данные */
    body?: any | undefined;
    /** Внешний ключ объекта */
    key?: string | undefined;
    type: InternalEntityType;
    sourceType?: SourceType;
    /** Внутренний идентификатор объекта, если null или 0, то будет создан новый объект */
    id?: number | undefined;
    /** Версия объекта
Если null и Carteam.Silo.Client.TaskQueue.Models.QueuedApiTaskObjectMetadataModel.Id не null, то версию контролировать не требуется */
    version?: string | undefined;
    /** OData фильтр
Поля Carteam.Silo.Client.TaskQueue.Models.QueuedApiTaskObjectMetadataModel.Id, Carteam.Silo.Client.TaskQueue.Models.QueuedApiTaskObjectMetadataModel.Version, Carteam.Silo.Client.TaskQueue.Models.QueuedApiTaskObjectMetadataModel.Key должны быть пустыми при использовании Carteam.Silo.Client.TaskQueue.Models.QueuedApiTaskObjectMetadataModel.Query */
    query?: string | undefined;
}

/** Модель задания с указаным типом действия и объектами */
export interface QueuedApiTaskAddCommandsModel {
    action: QueuedApiTaskAction;
    /** Объекты */
    objects?: QueuedApiTaskObjectAddModel[] | undefined;
}

/** Коллекция команд на выполнение */
export interface QueuedApiTaskCommandsCollectionModel {
    /** Команды */
    commands?: QueuedApiTaskAddCommandsModel[] | undefined;
}

export enum QueuedApiTaskStatus {
    Awaiting = "Awaiting",
    InProgress = "InProgress",
    Completed = "Completed",
    Error = "Error",
}

export enum QueuedApiTaskObjectResultStatus {
    Created = "Created",
    Success = "Success",
    Error = "Error",
    VersionMismatch = "VersionMismatch",
}

/** Модель для элемента объекта при получении сформированных данных */
export interface QueuedApiTaskObjectResultModel {
    /** Сообщение */
    message?: string | undefined;
    status: QueuedApiTaskObjectResultStatus;
    /** Данные */
    body?: any | undefined;
    /** Внешний ключ объекта */
    key?: string | undefined;
    type: InternalEntityType;
    sourceType?: SourceType;
    /** Внутренний идентификатор объекта, если null или 0, то будет создан новый объект */
    id?: number | undefined;
    /** Версия объекта
Если null и Carteam.Silo.Client.TaskQueue.Models.QueuedApiTaskObjectMetadataModel.Id не null, то версию контролировать не требуется */
    version?: string | undefined;
    /** OData фильтр
Поля Carteam.Silo.Client.TaskQueue.Models.QueuedApiTaskObjectMetadataModel.Id, Carteam.Silo.Client.TaskQueue.Models.QueuedApiTaskObjectMetadataModel.Version, Carteam.Silo.Client.TaskQueue.Models.QueuedApiTaskObjectMetadataModel.Key должны быть пустыми при использовании Carteam.Silo.Client.TaskQueue.Models.QueuedApiTaskObjectMetadataModel.Query */
    query?: string | undefined;
}

/** Модель для получения результатов */
export interface QueuedApiTaskGetResultsModel {
    /** Сообщение */
    message?: string | undefined;
    status: QueuedApiTaskStatus;
    /** Примерное время, через которое можно будет получить результат */
    readyInMsec: number;
    /** Оставшиеся количество объектов на выполнение */
    remainingObjectCount: number;
    /** Объекты */
    objects?: QueuedApiTaskObjectResultModel[] | undefined;
}

export interface TimezoneViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

/** Часовой пояс */
export interface TimezoneViewModel {
    /** Идентификатор часового пояса по стандарту Iana (например Europe/Prague) */
    id?: string | undefined;
    /** Отображаемое название */
    displayName?: string | undefined;
    /** Разница часового пояса по сравнению с UTC */
    utcOffset: string;
}

export interface TrackerViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export enum TrackerType {
    Default = "Default",
    Autograf = "Autograf",
    Mobile = "Mobile",
    Wialon = "Wialon",
}

/** Дополнительная информация по текущему трекеру */
export interface TrackerAdditionalInfoModel {
    /** Id объекта */
    entityId?: number | undefined;
    type: TrackerRelationType;
    /** Начало периода прикрепления объекта к трекеру */
    startedAt: string;
    /** Конец периода прикрепления объекта к трекеру */
    endedAt?: string | undefined;
    /** Номер объекта */
    number?: string | undefined;
}

export interface TrackerViewModel {
    id: number;
    type: TrackerType;
    deviceNumber: string | undefined;
    organizationId?: number | undefined;
    /** Имя организации */
    organizationName?: string | undefined;
    activeTrackerPeriod?: TrackerAdditionalInfoModel;
    /** Последняя дата фиксации трекера */
    lastTrackerLogFixedAt?: string | undefined;
    /** Дата создания */
    createdAt: string;
}

export interface TrackerDeviceNumberModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface TrackerDeviceNumberModel {
    id: number;
    deviceNumber?: string | undefined;
    type: TrackerType;
}

export interface TrackerEditModel {
    type: TrackerType;
    deviceNumber?: string | undefined;
    organizationId?: number | undefined;
    id: number;
}

export interface TrackerAttachModel {
    /** Идентификатор объекта, к которому надо присоединить трекер */
    entityId?: number | undefined;
    type: TrackerRelationType;
    /** Если поле Id = 0 или не указано и это поле не null, то поиск будет выполнен по номеру трекера */
    deviceNumber?: string | undefined;
    id: number;
}

export interface TrackerDeleteModel {
    id: number;
}

export interface TrackerRestoreModel {
    id: number;
}

export interface BindTrackersToOrganizationModel {
    organizationId: number;
    trackers?: string[] | undefined;
}

export interface AxisLoadValueModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface TrackerHistoryItemViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface TrackerHistoryItemViewModel {
    id: number;
    /** Id объекта */
    entityId?: number | undefined;
    type: TrackerRelationType;
    /** Номер объекта, к которому присоединен трекер */
    number?: string | undefined;
    startedAt: string;
    endedAt?: string | undefined;
}

export interface TrackerHistoryItemEditModel {
    id: number;
    trackerId: number;
    entityId: number;
    startedAt?: string | undefined;
    endedAt?: string | undefined;
    type: TrackerRelationType;
}

export interface TrackerHistoryItemDeleteModel {
    id: number;
}

export interface TrackerInfoViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface TrackerInfoViewModel {
    /** Имя организации */
    organizationName?: string | undefined;
    /** Кол-во машин с трекерами */
    carsWithTrackerCount: number;
    /** Кол-во машин, у которых нет координат за последний час */
    carsWithoutCoordinatesIn1HourCount: number;
    /** % машин у которых нет координат за последний час по отношению к CarsWithTrackerCount */
    percentOfCarsWithoutCoordinatesIn1Hour: number;
    /** Кол-во машин, у которых нет координат за последние 3 часа */
    carsWithoutCoordinatesIn3HoursCount: number;
    /** % машин у которых нет координат за последние 3 часа по отношению к CarsWithTrackerCount */
    percentOfCarsWithoutCoordinatesIn3Hours: number;
    /** Кол-во машин, у которых нет координат за последние 24 часа */
    carsWithoutCoordinatesIn24HoursCount: number;
    /** % машин у которых нет координат за последние 24 часа по отношению к CarsWithTrackerCount */
    percentOfCarsWithoutCoordinatesIn24Hours: number;
}

export interface TrailerBidsInfoForExploitationModel {
    id: number;
    /** Номер прицепа */
    trailerNumber?: string | undefined;
    lastLocation?: FixedAtLocationPoco;
    /** Активные и запланированные заявки */
    bids?: BidInfoForExploitationModel[] | undefined;
}

export interface TrailerEditModel {
    /** Идентификатор водителя */
    driverId?: number | undefined;
    /** Id транспортной колонны */
    transportColumnId?: number | undefined;
    mechanic?: MechanicModel;
    /** Типы загрузки/выгрузки прицепа */
    loadUnloadOptions?: LoadUnloadOptionModel[] | undefined;
    /** Тип трейлера. */
    typeId: number;
    /** Номер. */
    number: string | undefined;
    /** Грузоподъемность. */
    carrying?: number | undefined;
    /** Объем. */
    volume?: number | undefined;
    /** Длина. */
    length?: number | undefined;
    /** Высота. */
    height?: number | undefined;
    /** Ширина. */
    width?: number | undefined;
    /** Тип владения */
    ownershipType?: VehicleOwnershipType | undefined;
    /** Идентификатор типа бренда прицепа. */
    brandTypeId: number;
    /** Количество отсеков */
    containerCount?: number | undefined;
    /** Описание колес */
    wheelsDescription?: string | undefined;
    /** Колесная база */
    wheelBase?: number | undefined;
    /** Колесная формула */
    wheelFormula?: string | undefined;
    /** Расстояние между осями */
    axesDistance?: number | undefined;
    /** Нагрузка на ось */
    axleLoad?: number | undefined;
    /** Нагрузка на ССУ */
    fifthWheelLoad?: number | undefined;
    /** Вес брутто */
    grossWeight?: number | undefined;
    /** Масса снаряженного ТС */
    curbWeight?: number | undefined;
    comment?: string | undefined;
    /** Документы-основания владения */
    ownershipBasisDocuments?: TrailerOwnershipBasisDocumentModel[] | undefined;
    id: number;
}

export interface TrailerListViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface TrailerNumberModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface TrailerGetModel {
    /** Activity sign */
    isActive: boolean;
    /** Tracker id */
    trackerId?: number | undefined;
    /** Транспортная колонна */
    transportColumnId?: number | undefined;
    mechanic?: MechanicViewModel;
    resourceInactivityInfo?: ResourceInactivityInfoJsonObject;
    /** Типы загрузки/выгрузки прицепа */
    loadUnloadOptions?: LoadUnloadOptionModel[] | undefined;
    /** Удален? */
    isDeleted: boolean;
    /** Тип трейлера. */
    typeId: number;
    /** Номер. */
    number: string | undefined;
    /** Грузоподъемность. */
    carrying?: number | undefined;
    /** Объем. */
    volume?: number | undefined;
    /** Длина. */
    length?: number | undefined;
    /** Высота. */
    height?: number | undefined;
    /** Ширина. */
    width?: number | undefined;
    /** Тип владения */
    ownershipType?: VehicleOwnershipType | undefined;
    /** Идентификатор типа бренда прицепа. */
    brandTypeId: number;
    /** Количество отсеков */
    containerCount?: number | undefined;
    /** Описание колес */
    wheelsDescription?: string | undefined;
    /** Колесная база */
    wheelBase?: number | undefined;
    /** Колесная формула */
    wheelFormula?: string | undefined;
    /** Расстояние между осями */
    axesDistance?: number | undefined;
    /** Нагрузка на ось */
    axleLoad?: number | undefined;
    /** Нагрузка на ССУ */
    fifthWheelLoad?: number | undefined;
    /** Вес брутто */
    grossWeight?: number | undefined;
    /** Масса снаряженного ТС */
    curbWeight?: number | undefined;
    comment?: string | undefined;
    /** Документы-основания владения */
    ownershipBasisDocuments?: TrailerOwnershipBasisDocumentModel[] | undefined;
    id: number;
}

export interface TrailerDeleteModel {
    id: number;
}

export interface TrailerRestoreModel {
    id: number;
}

export interface TrailerEditableListModel {
    ids?: number[] | undefined;
}

export interface TrailerChangeResourceActivityModel {
    /** Trailer ID */
    trailerId: number;
    /** Activity sign */
    isActive: boolean;
    resourceInactivityInfo?: ResourceInactivityInfoJsonObject;
}

/** Модель для создания/редактирования транспортной колонны */
export interface TransportColumnEditModel {
    /** Название */
    name?: string | undefined;
    id: number;
}

/** Модель для отображения транспортной колонны */
export interface TransportColumnViewModel {
    /** Название */
    name?: string | undefined;
    /** Удален? */
    isDeleted: boolean;
    id: number;
}

export interface TransportColumnListItemModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

/** Модель элемента списка транспортных колонн */
export interface TransportColumnListItemModel {
    id: number;
    /** Название */
    name?: string | undefined;
    /** Удален? */
    isDeleted: boolean;
}

/** Модель для удаления транспортной колонны */
export interface TransportColumnDeleteModel {
    id: number;
}

/** Модель для восстановления транспортной колонны */
export interface TransportColumnRestoreModel {
    id: number;
}

/** Модель редактирования сцепки */
export interface TripCouplingEditModel {
    /** Id машины */
    carId: number;
    /** Id прицепа */
    trailerId?: number | undefined;
    /** Id водителя */
    driverId: number;
    organizationId: number;
    geozone?: MapObjectEditModel;
    startedAt: string;
    endedAt: string;
    id: number;
}

export interface TripCouplingBatchEditModel {
    /** Смены */
    items?: TripCouplingEditModel[] | undefined;
}

export interface TripCouplingBatchDeleteModel {
    tripCouplingIds?: number[] | undefined;
}

/** Модель сцепки для просмотра */
export interface TripCouplingViewModel {
    /** Id сцепки */
    id: number;
    driver?: DriverUserFullNameViewModel;
    trailer?: TrailerOptionPreviewModel;
    car?: CarNumberViewModel;
    geozone?: MapObjectModel;
}

export interface TripCouplingListItemModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

/** Модель сцепки для получения списка */
export interface TripCouplingListItemModel {
    /** Id сцепки */
    id: number;
    driver?: DriverFullNameViewModel;
    trailer?: TrailerOptionPreviewModel;
    car?: CarNumberViewModel;
    geozone?: MapObjectModel;
    /** Дата создания */
    startedAt: string;
    /** Дата завершения */
    endedAt?: string | undefined;
}

export interface TripScenarioForExternalModel {
    bidId: number;
    bidTripScenarioId: number;
    scenarioId: number;
    updatedAt: string;
}

export enum ScenarioFlag {
    None = "None",
    Main = "Main",
}

export interface TripScenarioEditModel {
    flags: ScenarioFlag;
    /** Название */
    name: string | undefined;
    /** Описание */
    description?: string | undefined;
    /** Начальный вопрос */
    startQuestionId?: number | undefined;
    externalData?: ScenarioExternalDataJsonModel;
    id: number;
}

export interface TripScenarioIdModel {
    id: number;
}

export interface TripScenarioListViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface TripScenarioListViewModel {
    /** true если основной сценарий */
    readonly isMain: boolean;
    id: number;
    /** Наименование сценария */
    name?: string | undefined;
    /** Описание сценария */
    description?: string | undefined;
    /** Начальный вопрос */
    startQuestionId?: number | undefined;
    externalData?: ScenarioExternalDataJsonModel;
}

export interface TripScenarioDeleteModel {
    id: number;
}

export interface TripScenarioRestoreModel {
    id: number;
}

export interface TripScenarioQuestionEditModel {
    id: number;
    /** Текст */
    text: string | undefined;
    /** Сценарий */
    scenarioId: number;
    questionType: ScenarioQuestionType;
    answerValueType?: ScenarioAnswerValueType;
    /** Следующий вопрос */
    nextQuestionId?: number | undefined;
    /** Минимальное значение */
    minValueCondition?: number | undefined;
    /** Максимальное значение */
    maxValueCondition?: number | undefined;
    externalData?: ScenarioExternalDataJsonModel;
    /** Запретить загрузку фото из галереи */
    onlyNewPhotos: boolean;
}

export interface TripScenarioQuestionDeleteModel {
    id: number;
}

export interface TripScenarioAnswerOptionEditModel {
    id: number;
    /** Текущий вопрос */
    questionId: number;
    /** Текст варианта ответа */
    text: string | undefined;
    /** Следующий вопрос */
    nextQuestionId?: number | undefined;
    /** Порядковый номер */
    order: number;
    externalData?: ScenarioExternalDataJsonModel;
}

export interface TripScenarioAnswerOptionDeleteModel {
    id: number;
}

export interface BidTripScenarioModel {
    id: number;
    scenario?: ScenarioViewModel;
}

export interface TripScenarioDriverAnswerApplyModel {
    id: number;
    questionId: number;
    value?: string | undefined;
    selectedAnswerOptionIds?: number[] | undefined;
}

export interface TripScenarioDriverAnswersApplyModel {
    scenarioId: number;
    bidTripScenarioId?: number | undefined;
    bidId: number;
    driverAnswers?: TripScenarioDriverAnswerApplyModel[] | undefined;
}

export interface TripScenarioDriverFileDeleteModel {
    questionId: number;
    bidTripScenarioId: number;
    fileId: number;
}

export interface TripScenarioCompleteModel {
    id: number;
    bidId: number;
}

export interface BidRateEditModel {
    id: number;
    /** Идентификатор заявки */
    bidId: number;
    /** Идентификатор типа Тип оплаты */
    paymentTypeId?: number | undefined;
    /** Идентификатор типа Тип НДС */
    ndsTypeId?: number | undefined;
    /** Сумма */
    price?: number | undefined;
    /** Почасовая цена */
    hourlyPrice?: number | undefined;
    /** Комментарий */
    comment?: string | undefined;
}

export interface TrailerOptionTrailerIdModel {
    /** Идентификатор выбранного прицепа для заявки */
    trailerId?: number | undefined;
}

export interface BidLogistTaskSettingEditModel {
    id: number;
    notificationType: NotificationType;
    bidRole?: BidRole;
    commentRequired: boolean;
    isActive: boolean;
}

export enum ParallelPointBehavior {
    Update = "Update",
    Delete = "Delete",
}

/** Модель, которая используется для взаимодействия с заявкой от лица транспортной компании. */
export interface BidTruckingEditModel {
    /** Type identifier payment type */
    paymentTypeId?: number | undefined;
    /** Type identifier vat type */
    ndsTypeId?: number | undefined;
    /** Hourly price */
    hourlyPrice?: number | undefined;
    /** Price */
    price?: number | undefined;
    /** Does VAT go on top of price */
    isVatTop?: boolean | undefined;
    externalId?: string | undefined;
    /** Contract number */
    contractNumber?: string | undefined;
    /** Срок оплаты в днях */
    paymentPeriodInDays?: number | undefined;
    paymentPeriodType?: PaymentPeriodType;
    /** Bid documents */
    documents?: RelatedDocumentModel[] | undefined;
    /** Идентификатор партнера-организации */
    partnerId?: number | undefined;
    /** Нужно ли создавать задание сдачи документов водителю после завершения заявки? */
    createDocumentAssignment: boolean;
    expressBid?: ExpressBidModel;
    /** Точки, минимум две */
    bidPoints?: BidPointEditModel[] | undefined;
    /** Грузы */
    cargos?: CargoModel[] | undefined;
    extendedProperties?: ExtendedPropertyJsonObject[] | undefined;
    /** Дополнительные опции заявки */
    typeOptions?: TypeOptionModel[] | undefined;
    status: BidStatus;
    /** Идентификатор заказа, из которого создается заявка. Устанавливается только при создании заявки */
    distributionBidId?: number | undefined;
    carOption?: CarOptionCarIdModel;
    driver?: DriverModel;
    temperatureRegime?: BidTemperatureRegimeModel;
    /** Дата обновления из 1с */
    externalUpdatedAt?: string | undefined;
    secondaryDriverId?: number | undefined;
    /** Контрагент/Грузовладелец */
    cargoOwnerDictionaryItemId?: number | undefined;
    /** Договор контрагента */
    contractId?: number | undefined;
    /** Менеджер по продажам */
    salesManagerId?: number | undefined;
    /** Если отметить этот флаг, то заявка будет считаться порожней */
    isEmptyMileageBid: boolean;
    /** Если отметить этот флаг, то заявка будет считаться экспресс-заявкой */
    isExpressBid: boolean;
    /** Если отметить этот флаг, водитель является экспедитором */
    isDriverForwarder: boolean;
    /** Идентификатор юр. лица из справочника */
    legalPersonId?: number | undefined;
    /** Идентификатор ответственнного */
    responsibleId?: number | undefined;
    /** Себестоимость маршрута */
    routeCost?: number | undefined;
    trailerOption?: TrailerOptionTrailerIdModel;
    logistTaskSettings?: BidLogistTaskSettingEditModel[] | undefined;
    parallelPointBehavior: ParallelPointBehavior;
    id: number;
}

/** Используется для возврата статуса заявки назад */
export interface BidRevertModel {
    bidId: number;
}

export interface TypeOptionPatchModel {
    /** Идентификатор типа */
    id?: number | undefined;
    /** Идентификатор опции сущности */
    entityOptionId: number;
}

export interface BidPatchModel {
    trailerId?: number | undefined;
    /** Идентификатор из 1с */
    externalId?: string | undefined;
    /** Дата обновления из 1с */
    externalUpdatedAt?: string | undefined;
    paymentTypeId?: number | undefined;
    ndsTypeId?: number | undefined;
    price?: number | undefined;
    /** Себестоимость маршрута */
    routeCost?: number | undefined;
    cargos?: CargoModel[] | undefined;
    bidPoints?: BidPointEditModel[] | undefined;
    carId?: number | undefined;
    /** НДС сверху */
    isVatTop?: boolean | undefined;
    extendedProperties?: ExtendedPropertyJsonObject[] | undefined;
    temperatureRegime?: BidTemperatureRegimeModel;
    typeOptions?: TypeOptionPatchModel[] | undefined;
    driverId?: number | undefined;
    secondaryDriverId?: number | undefined;
    responsibleId?: number | undefined;
    /** Менеджер по продажам */
    salesManagerId?: number | undefined;
    /** Нужно ли создавать задание сдачи документов водителю после завершения заявки? */
    createDocumentAssignment?: boolean | undefined;
    /** Водитель-экспедитор */
    isDriverForwarder?: boolean | undefined;
    parallelPointBehavior: ParallelPointBehavior;
    id: number;
}

export interface BidCloneModel {
    /** Идентификатор заявки. */
    id: number;
}

/** Используется для входных данных для согласования заявки */
export interface BidApproveModel {
    id: number;
}

/** Используется для входных данных для отмены согласования заявки */
export interface BidDisapproveModel {
    id: number;
}

export interface CarBidHistoryItemModel {
    id: number;
    bidId: number;
    carId: number;
    car?: CarSimpleModel;
    startedAt: string;
    endedAt?: string | undefined;
}

/** Модель для смены статуса заявки */
export interface BidChangeStatusApiModel {
    /** Идентификатор заявки */
    bidId: number;
    status?: BidStatus;
    id: number;
}

export interface BidPointDatesByLogistModel {
    id: number;
    /** Дата въезда, установленная логистом */
    enteredAtByLogist?: string | undefined;
    /** Дата выгрузки/выезда, установленная логистом */
    loadUnloadedAtByLogist?: string | undefined;
}

/** Информация для закрытия заявки */
export interface BidForceCompleteModel {
    /** Идентификатор заявки. */
    bidId: number;
    /** Причина ручного закрытия */
    reason?: string | undefined;
    /** Фактический километраж */
    mileage: number;
    /** Точки заявки */
    bidPoints?: BidPointDatesByLogistModel[] | undefined;
}

export interface ExcessMileageViewModel {
    /** Перепробег (в км.) */
    excessMileage: number;
    /** Причина перепробега */
    reason?: string | undefined;
    /** Тип причины перепробега */
    reasonTypeId?: number | undefined;
    /** Согласовано с логистом */
    isApproved: boolean;
}

export interface BidExcessMileageViewModel {
    id: number;
    driver?: DriverFullNameViewModel;
    /** Плановый пробег, км */
    planMileage: number;
    /** Фактический пробег, км */
    factMileage: number;
    values?: ExcessMileageViewModel[] | undefined;
}

export interface BidExcessMileagesViewModel {
    message?: string | undefined;
    excessMileages?: BidExcessMileageViewModel[] | undefined;
}

/** Информация о перепробеге */
export interface ExcessMileageEditModel {
    /** Перепробег (в км.) */
    excessMileage: number;
    /** Причина перепробега */
    reason?: string | undefined;
    /** Тип причины перепробега */
    reasonTypeId?: number | undefined;
    /** Согласовано с логистом */
    isApproved: boolean;
}

export interface BidExcessMileageEditModel {
    id: number;
    values?: ExcessMileageEditModel[] | undefined;
}

export interface BidExcessMileagesEditModel {
    bidId: number;
    excessMileages?: BidExcessMileageEditModel[] | undefined;
}

export interface BidPointEnterViewModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

/** Информация о посещении точки */
export interface BidPointEnterViewModel {
    id: number;
    /** Точка была посещена мобильным устройством */
    isMobile: boolean;
    /** Идентификатор точки заявки */
    bidPointId: number;
    /** Дата въезда в точку, в UTC */
    enterDate: string;
    /** Дата выезда из точки, в UTC */
    leaveDate?: string | undefined;
}

export interface BidPointVisitModel {
    id: number;
    /** Идентификатор посещения точки */
    bidPointEnterId: number;
}

export interface BidPointSetVisitsModel {
    id: number;
    /** Информация о посещении точек */
    bidPointVisits?: BidPointVisitModel[] | undefined;
}

export interface BidPointDatesModel {
    /** Идентификатор заявки. */
    bidId: number;
    bidPoint?: BidPointDatesByLogistModel;
}

export interface BidEstimatedLeaveModel {
    id: number;
    /** Расчетная дата */
    date: string;
    /** Комментарий */
    comment?: string | undefined;
}

export interface BidForFactoringModel {
    id: number;
}

export interface BidsForFactoringModel {
    bids?: BidForFactoringModel[] | undefined;
}

export interface BidIdsModel {
    bidIds?: number[] | undefined;
}

export interface CheckBidCollisionsResultModel {
    collisionBidIds?: number[] | undefined;
    compoundBidWillBeCreated?: boolean | undefined;
    collisionEmptyMileageBidId?: number | null;
    trailerCollisionEmptyMileageBidId?: number | null;
    approvingServiceWorkLogistTaskIds?: number[] | null;
}

/** Модель для добавления пересменки/перецепки заявки */
export interface BidItemsChangeAddModel {
    /** Идентификатор заявки */
    bidId: number;
    /** Идентификатор машины */
    carId?: number | undefined;
    /** Идентификатор водителя */
    driverId?: number | undefined;
    /** Идентификатор прицепа */
    trailerId?: number | undefined;
    /** Дата, с которой начинается назначение этого элемента в заявке */
    startedAt?: string | undefined;
}

export enum BidItemType {
    Car = "Car",
    Driver = "Driver",
    Trailer = "Trailer",
}

/** Модель для изменения пересменки/перецепки заявки */
export interface BidItemChangeEditModel {
    /** Идентификатор заявки */
    bidId: number;
    itemType: BidItemType;
    /** Идентификатор машины/водителя/прицепа */
    itemId?: number | undefined;
    /** Новая дата, с которой начинается назначение этого элемента в заявке */
    startedAt?: string | undefined;
    /** Идентификатор пересменки/перецепки */
    id: number;
}

/** Модель для удаления пересменки/перецепки заявки */
export interface BidItemChangeDeleteModel {
    /** Идентификатор заявки */
    bidId: number;
    itemType: BidItemType;
    /** Идентификатор пересменки/перецепки */
    id: number;
}

/** Модель для отображения пересменки/перецепки заявки */
export interface BidItemChangeViewModel {
    /** Номер машины/прицепа или ФИО водителя */
    displayName?: string | undefined;
    itemType: BidItemType;
    /** Идентификатор машины/водителя/прицепа */
    itemId: number;
    /** Дата, с которой начинается назначение этого элемента в заявке */
    startedAt: string;
    /** Идентификатор пересменки/перецепки */
    id: number;
}

/** Модель создания/обновления точки пересменки */
export interface ItemChangePointEditModel {
    /** Машина, которую использовать при перецепке */
    shiftCarId?: number | undefined;
    /** Водитель, которого использовать при пересменке */
    shiftDriverId?: number | undefined;
    /** Прицеп, который использовать при перецепке */
    shiftTrailerId?: number | undefined;
    /** Плановая дата въезда / плановая дата перецепки */
    planEnterDate?: string | undefined;
    /** Плановая дата выезда / плановая дата окончания перецепки */
    planLeaveDate?: string | undefined;
    mapObject?: MapObjectEditModel;
    /** Заявка для создания параллельной точки перецепки */
    parallelBidId?: number | undefined;
    id: number;
}

export interface BidItemChangePointsEditModel {
    /** Id заявки */
    bidId: number;
    /** Точки перецепки/пересменки, которые надо добавить в заявку */
    items?: ItemChangePointEditModel[] | undefined;
    parallelPointBehavior: ParallelPointBehavior;
}

export interface ItemChangePointDatesByLogistModel {
    id: number;
    /** Дата начала перецепки, установленная логистом */
    manualStartAt?: string | undefined;
    /** Дата конца перецепки, установленная логистом */
    manualEndAt?: string | undefined;
}

export interface BidItemChangePointsDeleteModel {
    /** Id точки */
    id: number;
    /** Id заявки */
    bidId: number;
    parallelPointBehavior: ParallelPointBehavior;
}

export interface GetBidsForParallelPointModel {
    /** Id заявки */
    bidId: number;
    point?: ItemChangePointEditModel;
}

export interface BidForParallelPointModel {
    id: number;
    firstBidPoint?: BidPointListItemModel;
    lastBidPoint?: BidPointListItemModel;
    /** Грузы */
    cargos?: CargoBidListModel[] | undefined;
    car?: BidCarViewModel;
    /** Идентификатор текущего водителя заявки */
    driverId?: number | undefined;
    /** ФИО текущего водителя заявки */
    driverName?: string | undefined;
    status: BidStatus;
}

export interface BidItemIdsModel {
    carId?: number | undefined;
    driverId?: number | undefined;
    trailerId?: number | undefined;
    isPatch: boolean;
}

export interface CheckItemsBeforeParallelPointModel {
    bidId: number;
    itemsToApply?: BidItemIdsModel;
    pointToApply?: ItemChangePointEditModel;
    pointIdToDelete?: number | undefined;
}

export interface CheckItemsBeforeParallelPointResult {
    willBeChanged: boolean;
    parallelBidId?: number | undefined;
    car?: CarNumberModel;
    driver?: DriverUserSimpleModel;
    trailer?: TrailerNumberModel;
}

export interface ShiftCarRouteForBidModel {
    /** Пройденный маршрут (координаты) */
    readonly traveledRouteCoordinates?: number[][] | undefined;
    carLastLocation?: FixedAtLocationPoco;
}

export enum PowerOfAttorneyFlags {
    None = 0,
    IsPaper = 1,
}

export interface PowerOfAttorneyModel {
    id: number;
    externalId?: string | undefined;
    issueDate?: string | undefined;
    intFlags: number;
}

export interface PowerOfAttorneyApplyModel {
    externalId?: string | undefined;
    issueDate?: string | undefined;
    intFlags: number;
}

export interface PowerOfAttorneyRemoveModel {
    id: number;
}

export interface UserProfileModel {
    id: number;
    email: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    patronymic?: string | undefined;
    phoneNumber: string | undefined;
    phoneNumberExtension?: string | undefined;
    imageUrl?: string | undefined;
    fullName?: string | undefined;
    organizationId?: number | undefined;
    createdAt: string;
    powerOfAttorneys?: PowerOfAttorneyModel[] | undefined;
    loginProviders?: string[] | undefined;
}

export interface UserProfileEditModel {
    /** Email */
    email: string | undefined;
    /** Имя */
    firstName: string | undefined;
    /** Фамилия */
    lastName: string | undefined;
    /** Отчество */
    patronymic?: string | undefined;
    /** Номер телефона */
    phoneNumber?: string | undefined;
    /** Добавочный номер телефона */
    phoneNumberExtension?: string | undefined;
    lastSignInAt?: string | undefined;
    connectionState: ConnectionState;
    id: number;
}

export enum NotificationThresholdType {
    None = "None",
    Hour = "Hour",
    Km = "Km",
    Minute = "Minute",
}

export enum NotificationExtraType {
    ResendNotification = "ResendNotification",
}

export interface UserNotificationExtraThresholdsJsonObject {
    thresholds?: number[] | undefined;
    type: NotificationExtraType;
}

export interface NotificationExtraThresholdsJsonObject {
    displayName?: string | undefined;
    minimumThreshold?: number | undefined;
    maximumThreshold?: number | undefined;
    thresholdsMaxCount: number;
    thresholdType: NotificationThresholdType;
    type: NotificationExtraType;
}

export interface UserNotificationOptionGetModel {
    id: number;
    /** Выбранные настройки уведомлений */
    flags: number;
    /** Значение предела */
    threshold?: number | undefined;
    thresholdType: NotificationThresholdType;
    /** Название настройки уведомления */
    displayName?: string | undefined;
    /** Подсказка (описание) настройки уведомления */
    hint?: string | undefined;
    /** Настройки уведомлений в режиме "только для чтения" */
    readOnlyFlags: number;
    /** Настройка чтобы отключить уведомления */
    disabledFlags: number;
    /** Id настройки уведомления */
    notificationOptionId?: number | undefined;
    extraThresholds?: UserNotificationExtraThresholdsJsonObject[] | undefined;
    /** Тексты для кнопок добавления дополнительных параметров, и т.д. */
    extraThresholdsInfo?: NotificationExtraThresholdsJsonObject[] | undefined;
}

/** Настройки пользователя, содержащие настройки уведомлений */
export interface UserNotificationsModel {
    /** Настройки уведомлений */
    notificationOptions?: UserNotificationOptionGetModel[] | undefined;
    doNotSendNotificationsAtNight: boolean;
}

export interface UserNotificationOptionModel {
    id: number;
    /** Выбранные настройки уведомлений */
    flags: number;
    /** Значение предела */
    threshold?: number | undefined;
    thresholdType: NotificationThresholdType;
    /** Название настройки уведомления */
    displayName?: string | undefined;
    /** Подсказка (описание) настройки уведомления */
    hint?: string | undefined;
    /** Настройки уведомлений в режиме "только для чтения" */
    readOnlyFlags: number;
    /** Настройка чтобы отключить уведомления */
    disabledFlags: number;
    /** Id настройки уведомления */
    notificationOptionId?: number | undefined;
    extraThresholds?: UserNotificationExtraThresholdsJsonObject[] | undefined;
}

/** Настройки пользователя, содержащие настройки уведомлений */
export interface UserNotificationsEditModel {
    id: number;
    /** Настройки уведомлений */
    notificationOptions?: UserNotificationOptionModel[] | undefined;
}

export interface UserEditPhoneModel {
    /** Номер телефона */
    phone: string | undefined;
}

export interface UserEditPhoneTokenModel {
    /** Номер телефона */
    phone: string | undefined;
    /** Секретный ключ для смены телефона, который приходит по СМС */
    token: string | undefined;
}

export interface UserEditPasswordModel {
    /** Текущий пароль */
    oldPassword?: string | undefined;
    /** Новый пароль */
    newPassword?: string | undefined;
}

export interface UserDeleteProfileModel {}

export interface UserRestoreProfileModel {}

export enum UserDeviceType {
    Other = "Other",
    Android = "Android",
    IOS = "iOS",
}

export enum NotificationServiceType {
    Firebase = "Firebase",
    HmsPushKit = "HmsPushKit",
    WhatsApp = "WhatsApp",
    Telegram = "Telegram",
}

/** Модель с токеном устройства. */
export interface DeviceTokenModel {
    /** Токен. Если пусто, то токен будет сброшен. */
    deviceToken?: string | undefined;
    mobileType?: UserDeviceType;
    notificationServiceType: NotificationServiceType;
}

/** Модель с токеном для веб пуш уведомлений. */
export interface WebTokenModel {
    /** Токен. */
    token?: string | undefined;
}

export interface MobileDeviceEditModel {
    model?: string | undefined;
    osVersion?: string | undefined;
}

export interface GenerateUserMessengerInfoModel {
    userId: number;
}

export interface VehicleEntityModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export enum GenericVehicleType {
    Car = "Car",
    Trailer = "Trailer",
}

export interface VehicleEntityModel {
    /** Vehicle id */
    id: number;
    /** Vehicle number */
    number?: string | undefined;
    type: GenericVehicleType;
}

export interface BreakPeriodModel {
    id: number;
    startedAt: string;
    endedAt?: string | undefined;
}

export interface CurrentShiftDatesModel {
    id: number;
    startedAt: string;
    breakPeriods?: BreakPeriodModel[] | undefined;
}

export interface ShiftPeriodsModelQueryMetadata {
    clrType?: string | undefined;
    request?: RequestMessage;
    fullCrlTypeName?: string | undefined;
}

export interface ShiftPeriodsModel {
    id: number;
    startedAt: string;
    endedAt?: string | undefined;
    breakPeriods?: BreakPeriodModel[] | undefined;
}

export interface ShiftStartApiModel {}

export interface ShiftEndApiModel {}

export interface BreakPeriodStartApiModel {}

export interface BreakPeriodEndApiModel {}

export interface ShiftCorrectModel {
    id: number;
    startedAt: string;
    endedAt?: string | undefined;
}

export interface BreakPeriodCorrectModel {
    id: number;
    shiftId: number;
    startedAt: string;
    endedAt?: string | undefined;
}

export interface Clusters {
    Plato?: number;
    Camera?: number;
    Azs?: number;
    WC?: number;
    Loundary?: number;
    Wrecker?: number;
    RoadPatrolService?: number;
    Shop?: number;
    Radar?: number;
    Motel?: number;
    TechnicalStation?: number;
    Cafe?: number;
    TireFitting?: number;
    Water?: number;
    TrafficAccident?: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface Period {
    year: string;
    month: string;
}
